import BookingInputButton from '../common/button/BookingInputButton';
import BookingDialog from '../common/button/BookingDialog';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Accordion, Badge, Button, ButtonGroup, Card, CloseButton, Col, Container, FloatingLabel, Form, Image, InputGroup, Modal, ModalBody, ProgressBar, Row, Spinner, Tab, Table, Tabs, Toast, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../../App';
import ImageFile from '../../domain/ImageFile';
import * as ImageUtil from '../../service/ImageUtil';
import ApiFetch from '../ApiFetch';
import CampaignMessage from '../CampaignMessage';
import Dialog from '../Dialog';
import Footer from '../Footer';
import Header from '../Header';
import Category from '../Category';
import EXIF from 'exif-js';
import extractChunks from 'png-chunks-extract/index'
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Typeahead } from 'react-bootstrap-typeahead' ;
import 'react-bootstrap-typeahead/css/Typeahead.css' ;
import Cropper from 'react-easy-crop'
import {getStyleList,setStyle,deleteStyleList} from '../../service/AIGenerateService';
import Questionnaire from '../Questionnaire';
import RegistOrLogin from '../RegistOrLogin';
import AITalk from '../AITalk';
import { Bar } from 'react-chartjs-2';
import { login } from '../../service/LoginService';
import ExifReader from 'exifreader';
import TagSelector from '../TagSelector';
import SampleCollection from '../SampleCollection';
import Thumb from '../common/Thumb';
import DynamicDialog from '../DynamicDialog';
import { arrayShuffle, planDialog } from '../../service/CommonUtil';
import UserMark from '../UserMark';
import MuiButton from '@mui/material/Button';
import { ImageList ,ImageListItem, Skeleton , Slider, IconButton, Box, Checkbox, FormControl, FormControlLabel,TextField, FormLabel, Radio, RadioGroup, TableBody, Menu, Popper, FormGroup, Switch, AlertTitle, Alert, LinearProgress } from '@mui/material';
import CommonDialog from '../common/CommonDialog';
import SubscriptionUpgradeLink from '../common/SubscriptionUpgradeLink';
import { DataGrid } from '@mui/x-data-grid';
import CropButton from '../common/CropButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DeleteIcon from '@mui/icons-material/Delete';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import Chip from '@mui/material/Chip';
import MuiToggleButton from '@mui/material/ToggleButton';
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import Inpaint from '../common/Inpaint';
import PostLimit from './PostLimit';
import Fade from '@mui/material/Fade';
import Constants from '../common/Constants';
import DiamondIcon from '@mui/icons-material/Diamond';
import PaymentMethodSelector from './PaymentMethodSelector';
import LoadingButton from '@mui/lab/LoadingButton';
import { useDropzone } from "react-dropzone";
import GradientBlurText from '../common/GradientBlurText';
import { BorderLinearProgress } from '../common/ProgressBar';
import GenerateCount from './GenerateCount';
import CharacterProfileCard from '../common/CharacterProfileCard';
import SelectedLoRaList from './SelectedLoRaList';

const Upload = (props) => {
    const [trainingImageList,setTrainingImageList] = useState([])
    const onDrop = useCallback((acceptedFiles) => {
        // ドロップされたファイルの処理
        acceptedFiles.forEach((file) => {
          const reader = new FileReader();
    
          reader.onload = () => {
            // ファイルの中身を表示（テキストファイルの場合）
            const fileContents = reader.result;
            trainingImageList.push({name:file.name,img:fileContents})
            setTrainingImageList(trainingImageList)
          };
    
          reader.readAsDataURL(file); // テキストとして読み込む場合
        });
      }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    function getAIGeneraleImageList(userId,page){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/generated/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getAIGeneraleImageFile(procId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImage/"+procId+"/0").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function deleteAIGeneraleImageFile(procIdList){
        return new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/generatedHistory",{procIdList:procIdList}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function createZipFile(procIdList){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/dl",{procIdList:procIdList}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function existZipFile(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/existZip").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getStatusCount(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/statusCount").then((r)=>{
            return r.json()
        })
    }
    function getStatus(procId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/status/"+procId).then((r)=>{
            return r.json()
        })
    }
    function getPoint(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point").then((r)=>{
            return r.json()
        })
    }
	async function getCoinInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/coinInfo").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImage(model,modelId){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/modelSamples",{model:model,modelId:modelId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function generateCancel(procId){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/generateCancel",{procId:procId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function generateCancelHandler(procId){
        generateCancel(procId).then(r => {
            if(r.result){
                setServerWaitingStatus(0)
                clearAllInterval()
                setAiProccessing(() => false)
                procId = ""
                dialog(t("common.info"),"キャンセルしました。")
            } else {
                dialog(t("common.error"),r.errors)
            }
        })
    }
    function txt2img(booking,random,count,style,isFullMode,isFastMode,isScaleUpx2,enterJpPrompt,enterEnhancePrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sampler,upscaler,steps,scale,denoisingStrength,seed,width,height,hires){
        if(false === booking) setAiProccessing(true)
        if(enterJpPrompt){
            setJpPromptTranslating(true)
            document.getElementById("sd-prompt").value = ""
        }
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/txt2img",
            {mode:"txt2img",paymentMethod:paymentMethod,booking:booking ? 1 : 0,random:random ? 1 : 0,count:count,style:style,isFullMode:isFullMode,isFastMode:isFastMode,isScaleUpx2:isScaleUpx2,enterJpPrompt:enterJpPrompt,enterEnhancePrompt:enterEnhancePrompt,jpPrompt:jpPrompt,prompt:prompt,negativePrompt:negativePrompt,styleP:styleP,styleNP:styleNP,sampler:sampler,upscaler:upscaler,steps:steps,scale:scale,denoisingStrength:denoisingStrength,seed:seed,width:width,height:height,hires:hires}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    if(booking){
                        dialog(t("common.info"),"予約しました。")
                    }
                    if(json.data.translatedPrompt){
                        document.getElementById("sd-prompt").value = json.data.translatedPrompt
                    }
                    setPoint(json.data.afterPoint)
                    setCoin(json.data.afterCoin)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("利用規約への同意が必要です。") !== -1){
                        getTerms().then(r => {
                            if(r.result){
                                setAIGenTerms(r.text)
                            }
                        })
                    } else if(json.errors.join("\r\n").indexOf("継続するにはログインが必要です。") !== -1){
                        dialog("",<RegistOrLogin dialog={dialog} />)
                        return
                    } else if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />

                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>プレミアムプラン</Link>でポイント消費することなく画像生成できます(条件あり)。</li>
                                <li>SMS認証またはWorldID認証することで、毎日付与されるポイント上限があがります。</li>
                                <li>翌日まで待てばポイント回復。<br />
                                    活動実績により変動。</li>
                                <li>作品の投稿やいいね、コメントを投稿することでポイント回復。</li>
                                <li>今日のお題に参加すると投稿時にもらえるポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    if(false === booking) setAiProccessing(false)
                }
                if(enterJpPrompt){
                    setJpPromptTranslating(false)
                }
                return json.result
            })
        })
    }
    function img2img(booking,random,count,style,isFullMode,isFastMode,isScaleUpx2,img,mask,enterJpPrompt,enterEnhancePrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sampler,upscaler,steps,scale,denoisingStrength,seed,width,height){
        if(false === booking) setAiProccessing(true)
        if(enterJpPrompt){
            setJpPromptTranslating(true)
            document.getElementById("sd-prompt").value = ""
        }
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/img2img",
            {mode:"img2img",paymentMethod:paymentMethod,random:random ? 1 : 0,count:count,style:style,isFullMode:isFullMode,isFastMode:isFastMode,isScaleUpx2:isScaleUpx2,img:img,mask:mask,enterJpPrompt:enterJpPrompt,enterEnhancePrompt:enterEnhancePrompt,jpPrompt:jpPrompt,prompt:prompt,negativePrompt:negativePrompt,styleP:styleP,styleNP:styleNP,sampler:sampler,upscaler:upscaler,steps:steps,scale:scale,denoisingStrength:denoisingStrength,seed:seed,width:width,height:height}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    if(booking){
                        dialog(t("common.info"),"予約しました。")
                    }
                    if(json.data.translatedPrompt){
                        document.getElementById("sd-prompt").value = json.data.translatedPrompt
                    }
                    setPoint(json.data.afterPoint)
                    setCoin(json.data.afterCoin)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("利用規約への同意が必要です。") !== -1){
                        getTerms().then(r => {
                            if(r.result){
                                setAIGenTerms(r.text)
                            }
                        })
                    } else if(json.errors.join("\r\n").indexOf("継続するにはログインが必要です。") !== -1){
                        dialog("",<RegistOrLogin dialog={dialog} />)
                        return
                    } else if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />

                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>プレミアムプラン</Link>でポイント消費することなく画像生成できます(条件あり)。</li>
                                <li>SMS認証またはWorldID認証することで、毎日付与されるポイント上限があがります。</li>
                                <li>翌日まで待てばポイント回復。<br />
                                    活動実績により変動。</li>
                                <li>作品の投稿やいいね、コメントを投稿することでポイント回復。</li>
                                <li>今日のお題に参加すると投稿時にもらえるポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    if(false === booking) setAiProccessing(false)
                }
                if(enterJpPrompt){
                    setJpPromptTranslating(false)
                }
                return json.result
            })
        })
    }
    function txt2imgControlnet(booking,random,count,style,isFullMode,isFastMode,isScaleUpx2,img,mask,enterJpPrompt,enterEnhancePrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sampler,upscaler,steps,scale,denoisingStrength,seed,width,height){
        if(false === booking) setAiProccessing(true)
        if(enterJpPrompt){
            setJpPromptTranslating(true)
            document.getElementById("sd-prompt").value = ""
        }
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/txt2img",
            {mode:"txt2img",paymentMethod:paymentMethod,random:random ? 1 : 0,count:count,style:style,controlnet:useControlnet ? 1 : 0,controlnetModule:"lineart_anime_denoise",controlnetModel:"Katarag_lineartXL-fp16 [ac23a680]",isFullMode:isFullMode,isFastMode:isFastMode,isScaleUpx2:isScaleUpx2,img:img,mask:mask,enterJpPrompt:enterJpPrompt,enterEnhancePrompt:enterEnhancePrompt,jpPrompt:jpPrompt,prompt:prompt,negativePrompt:negativePrompt,styleP:styleP,styleNP:styleNP,sampler:sampler,upscaler:upscaler,steps:steps,scale:scale,denoisingStrength:denoisingStrength,seed:seed,width:width,height:height}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    if(booking){
                        dialog(t("common.info"),"予約しました。")
                    }
                    if(json.data.translatedPrompt){
                        document.getElementById("sd-prompt").value = json.data.translatedPrompt
                    }
                    setPoint(json.data.afterPoint)
                    setCoin(json.data.afterCoin)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("利用規約への同意が必要です。") !== -1){
                        getTerms().then(r => {
                            if(r.result){
                                setAIGenTerms(r.text)
                            }
                        })
                    } else if(json.errors.join("\r\n").indexOf("継続するにはログインが必要です。") !== -1){
                        dialog("",<RegistOrLogin dialog={dialog} />)
                        return
                    } else if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />

                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>プレミアムプラン</Link>でポイント消費することなく画像生成できます(条件あり)。</li>
                                <li>翌日まで待てばポイント回復。<br />
                                    活動実績により変動。</li>
                                <li>作品の投稿やいいね、コメントを投稿することでポイント回復。</li>
                                <li>今日のお題に参加すると投稿時にもらえるポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    if(false === booking) setAiProccessing(false)
                }
                if(enterJpPrompt){
                    setJpPromptTranslating(false)
                }
                return json.result
            })
        })
    }
    function upScale(img,style,scale){
        setAiProccessing(true)
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/extraBatchImages",
            {img:[img],style:style,scale:scale}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    setPoint(json.data.afterPoint)
                    setCoin(json.data.afterCoin)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("利用規約への同意が必要です。") !== -1){
                        getTerms().then(r => {
                            if(r.result){
                                setAIGenTerms(r.text)
                            }
                        })
                    } else if(json.errors.join("\r\n").indexOf("継続するにはログインが必要です。") !== -1){
                        dialog("",<RegistOrLogin dialog={dialog} />)
                        return
                    } else if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />

                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>プレミアムプラン</Link>でポイント消費することなく画像生成できます(条件あり)。</li>
                                <li>翌日まで待てばポイント回復。<br />
                                    活動実績により変動。</li>
                                <li>作品の投稿やいいね、コメントを投稿することでポイント回復。</li>
                                <li>今日のお題に参加すると投稿時にもらえるポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    setAiProccessing(false)
                }
                return json.result
            })
        })
    }
    function getOdai(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/odai/latest").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function calcPoint(postCount){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point/calc/"+postCount).then((r)=>{
            return r.json()
        })
    }
    function getSeriesList(userId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/list/"+userId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getUsersByDay(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/users").then((r)=>{
            return r.json()
        })
    }
    function tagSearch(word){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/search/",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getEvent(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/event/hold/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getTagLatest(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/latest/image").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getTags(prompt){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/chat/getTags",{prompt:prompt}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getTagsByImage(image){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/chat/getTagsByImage",{image:image}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getIdentityByImage(image){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/chat/getIdentityByImage",{image:image}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getAgeLimitByImage(image){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/chat/getAgeLimitByImage",{image:image}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPromptByImage(image){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/chat/getPromptByImage",{image:image}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function enhancePrompt(prompt){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/chat/enhancePrompt",{prompt:prompt}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getHowToText(tag){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/tag",{tag:tag,page:1}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getBookingTimeList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/bookingTimeList").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPeriod(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/freeCampaign/period/image_generate").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPromptByDetailId(detailId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/promptDetail/"+detailId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPromptByShareId(shareId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/promptShare/"+shareId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function createShareId(procId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/createShare/"+procId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function terms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/terms/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function termsAgree(){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPlanList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/peoples/")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getAdList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/ad/list/generating_image/107305bd-dd69-47a7-bfb3-a099862463f0").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getModelList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/modelList/2").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getFavoriteModelList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/favoriteModelList").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function favorite(id,flg){
        if(flg){
            new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/image_ai_model/"+id,{}).then((res) => {
                res.json().then((json)=>{
                    if(json.result){
                        getModelList().then(r => {
                            if(r.result){
                                // update_datetimeが1時間以上経過している場合のみ取得
                                const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
                                const updatedModels = r.data.filter(model => new Date(model.update_datetime) < oneHourAgo);
                                setModelList(updatedModels);
                            }
                        })
                    } else {
                    }
                })  
            })
        } else {
            new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/image_ai_model/"+id,{}).then((res) => {
                res.json().then((json)=>{
                    if(json.result){
                        getModelList().then(r => {
                            if(r.result){
                                // update_datetimeが1時間以上経過している場合のみ取得
                                const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
                                const updatedModels = r.data.filter(model => new Date(model.update_datetime) < oneHourAgo);
                                setModelList(updatedModels);
                            }
                        })
                    } else {
                    }
                })  
            })
        }
    }
    async function getCharacterList(word){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/character/allowFanart",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function trainLoRa(name,images){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/trainLoRa",{name:name,images:images}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()
    const param = useParams()

    // 無料期間情報
    const [freePeriodInfo,setFreePeriodInfo] = useState([])
    const [free,setFree] = useState(false)

    // イベント一覧
    const [eventList,setEventList] = useState([])
    const [eventTag,setEventTag] = useState("")

    // タグ生成
    const [tagging,setTagging] = useState(false)

    // ノウハウ文書
    const [howTo,setHowTo] = useState([])

    // プラン一覧
    const [planList,setPlanList] = useState([])
    // 広告一覧
    const [adInfo,setAdInfo] = useState([])
    const adList = [
        /*  {"isAd":true,"title":"AIイラスト入門用ノートPC","text":"[PR]Amazonブラックフライデー先行セール中！","element":<>
        <a href="https://www.amazon.co.jp/ASUS-%E3%82%B2%E3%83%BC%E3%83%9F%E3%83%B3%E3%82%B0%E3%83%8E%E3%83%BC%E3%83%88PC-%E3%83%AA%E3%83%95%E3%83%AC%E3%83%83%E3%82%B7%E3%83%A5%E3%83%AC%E3%83%BC%E3%83%88144Hz-RGB%E3%82%A4%E3%83%AB%E3%83%9F%E3%83%8D%E3%83%BC%E3%83%88%E3%82%AD%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%89-FA507RM-R76R3060A/dp/B0CHVSCDQ4?__mk_ja_JP=%E3%82%AB%E3%82%BF%E3%82%AB%E3%83%8A&keywords=rtx+3060&qid=1700666016&sr=8-3-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9tdGY&psc=1&linkCode=li2&tag=ourt-ai-22&linkId=fe5c358f8ccb351d2f9a0779a8e608d0&language=ja_JP&ref_=as_li_ss_il" target="_blank">
            <img border="0" src="//ws-fe.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B0CHVSCDQ4&Format=_SL160_&ID=AsinImage&MarketPlace=JP&ServiceVersion=20070822&WS=1&tag=ourt-ai-22&language=ja_JP" />
        </a>
            <img src="https://ir-jp.amazon-adsystem.com/e/ir?t=ourt-ai-22&language=ja_JP&l=li2&o=9&a=B0CHVSCDQ4" width="1" height="1" border="0" alt="" style={{border:"none !important", margin:"0px !important"}} /></>},
        */
        {"isAd":true,"title":"ベーシックプランで広告非表示","text":"月額500円で広告非表示のプランです。","element":<Button variant="primary" onClick={() => planDialog(dialog)}>プラン詳細</Button>},
        {"isAd":true,"title":"プレミアムプラスプランで高画質で回数無制限","text":"広告非表示。ポイントの消費を気にせず生成しよう。","element":<Button variant="primary" onClick={() => planDialog(dialog)}>プラン詳細</Button>},
        {"isAd":true,"title":"有料プランでは生成が優先されます","text":"専用環境で待機時間の短縮を。対象プラン：スタンダード、プレミアム、プレミアムプラス","element":<Button variant="primary" onClick={() => planDialog(dialog)}>プラン詳細</Button>},
        {"isAd":true,"title":"有料プラン専用マーク","text":"各プランに加入すると、名前の隣にプランを表すマークが付与されます。","element":<>
            <UserMark plan="basic" dialog={() => false} />&nbsp;&nbsp;&nbsp;&nbsp;ベーシック<br />
            <UserMark plan="certification" dialog={() => false} />&nbsp;&nbsp;&nbsp;&nbsp;スタンダード<br />
            <UserMark plan="unlimited" dialog={() => false} />&nbsp;プレミアム<br />
            <UserMark plan="plus" dialog={() => false} />&nbsp;プレミアムプラス <b>(最初の1か月20% OFF)</b><br /><br />
        <Button variant="primary" onClick={() => planDialog(dialog)}>プラン詳細</Button></>},
    ]
    useEffect(() => {
        getEvent().then(r => {
            if(r.result){
                setEventList(r.data)
            }
        })
        getHowToText("ノウハウ").then(r => {
            if(r.result){
                setHowTo(r.data)
            }
        })

        getPeriod().then(r => {
            if(r.result){
                setFreePeriodInfo(r.data)
                setFree(r.data.enabled === 1)
            }
        })
        // 参考にする詳細IDがあれば取得
        const match = window.location.href.match(/.+?[^s]id=([0-9\-a-z]{36})/)
        if(match !== null && match.length === 2){
            getPromptByDetailId(match[1]).then(r => {
                setSrcMode(true)
                if(r.result){
                    //setSdResolution("512x768")
                    setSdStyle("ourt_AI_Diffusion_XL_Anime_V2")
                    setModelId("1dc62e32-6d6e-11ef-bde2-525400aff247")
                    document.querySelector("#sd-seed").value = -1
                    document.querySelector("#sd-prompt").value = r.data.prompt
                    document.querySelector("#sd-negative-prompt").value = r.data.negative_prompt
                    setQualityTags(false)
                } else {
                    dialog(t("common.error"),r.errors)
                }
            })
        }
        const matchP = window.location.href.match(/.+?sid=([0-9\-a-z]{36})/)
        if(matchP !== null && matchP.length === 2){
            getPromptByShareId(matchP[1]).then(r => {
                if(r.result){
                    setSrcMode(true)
                    const d = r.data
                    setSdScale(d.cfg_scale)
                    if(d.denoising_strength === ""){
                        setSdDenoisingStrength("0.35")   
                    } else {
                        setSdDenoisingStrength(d.denoising_strength)
                    }
                    if(d.enable_hr === 1){
                        const width = parseInt(d.width) * 2
                        const height = parseInt(d.height) * 2
                        setSdResolution(width+"x"+height+"h")
                    } else {
                        setSdResolution(d.width+"x"+d.height)
                    }
                    setSdStyle(d.sd_model_checkpoint)
                    //setSdSeed(d.real_seed)
                    setSdSteps(d.steps)
                    setSdSampler(d.sampler)
                    setSdStyle(d.style)
                    setModelId(d.id)
                    //document.querySelector("#sd-seed").value = d.real_seed
                    document.querySelector("#sd-prompt").value = d.prompt
                    document.querySelector("#sd-negative-prompt").value = d.negative_prompt
                    setQualityTags(false)
                } else {
                    dialog(t("common.error"),r.errors)
                }
            })
        }
        getAdList().then(r => {
            if(r.result){
                setAdInfo(r.data)
            }
        })
        getModelList().then(r => {
            if(r.result){
                // update_datetimeが1時間以上経過している場合のみ取得
                const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
                const updatedModels = r.data.filter(model => new Date(model.update_datetime) < oneHourAgo);
                setModelList(updatedModels);
            }
        })
    },[])

    useEffect(() => {
        if(loginInfo.result){
            getPlanList().then(r => {
                if(r.result){
                    setRows(r.data.map(d => {
                        d.id = d.plan_id
                        d.amount = "￥"+d.amount.toLocaleString()
                        return d
                    }))
                } else {
                    setRows([].concat())
                }
            })
        }
    },[loginInfo])

    const [aiGenTerms,setAIGenTerms] = useState("")
    const [srcMode,setSrcMode] = useState(false)

    // 最新タグ
    const [tagLatest,setTagLatest] = useState([])

    // よく使う予約時刻一覧
    const [bookingTimeList,setBookingTimeList] = useState([])
    const [showBookingDatetime,setShowBookingDatetime] = useState(false)

    // お題
    const [odai,setOdai] = useState([])
    const [useOdai,setUseOdai] = useState(false)

    // フラグ
    const [batchMode,setBatchMode] = useState(false)
    const [useFilename,setUseFilename] = useState(false)
    const [notReadPromptInfo,setNotReadPromptInfo] = useState(false)
    const [promptInfoPublication,setPromptInfoPublication] = useState(true)

    // アップロード処理
    const [batchUploading,setBatchUploading] = useState(false)
    const [batchProgressNow,setBatchProgressNow] = useState(0)
    const [batchProgressLabel,setBatchProgressLabel] = useState(0)
    const [uploading,setUploading] = useState(false)
    const [progressNow,setProgressNow] = useState(0)
    const [progressLabel,setProgressLabel] = useState(0)
    const maxFileSize = 31457280000
    // 104857600 100MB
    // 262144000 200MB
    // 31457280000 30GB
    localStorage.getItem("sd-style")
    localStorage.getItem("model-id")
    localStorage.getItem("sd-resolution")
    localStorage.getItem("sd-sampler")
    localStorage.getItem("sd-fast")
    localStorage.getItem("sd-steps")
    localStorage.getItem("sd-denoising-strength")
    localStorage.getItem("sd-generate-mode")
    localStorage.getItem("sd-scale")
    localStorage.getItem("sd-seed")
    localStorage.getItem("sd-quality-tags")
    // AIでの生成関連
    const [useAiGenerate,setUseAiGenerate] = useState(param.generate === "generate" || false) // 生成を使用
    const [jpPromptTranslating,setJpPromptTranslating] = useState(false) // 翻訳中
    const [aiProccessing,setAiProccessing] = useState(false) // 生成処理中
    const [qualityTags,setQualityTags] = useState(localStorage.getItem("sd-quality-tags") === "true")
    const [point,setPoint] = useState(0)
    const [pointCost,setPointCost] = useState(0)
    const [coinCost,setCoinCost] = useState(0)
    const [upscalePointCost,setUpscalePointCost] = useState(0)
    const [upscaleCoinCost,setUpscaleCoinCost] = useState(0)
    const [calcPointInfo,setCalcPointInfo] = useState([])
    const [sdStyle,setSdStyle] = useState(localStorage.getItem("sd-style") || "illustriousPencilXL_v200")
    const [modelId,setModelId] = useState(localStorage.getItem("model-id") || "1dc62e32-6d6e-11ef-bde2-525400aff247")
    const [modelImage,setModelImage] = useState("")
    const [modelName,setModelName] = useState("")
    const [modelDescription,setModelDescription] = useState("")
    const [modelType,setModelType] = useState("")
    const [modelIdentifiedName,setModelIdentifiedName] = useState("")
    const [modelOptions,setModelOptions] = useState([])
    const [bgName,setBgName] = useState("")
    const [sdResolution,setSdResolution] = useState(localStorage.getItem("sd-resolution") || "768x1152")
    const [sdWidth,setSdWidth] = useState(768)
    const [sdHeight,setSdHeight] = useState(1152)
    const [fastModeVer,setFastModeVer] = useState("0")
    const [isFastMode,setIsFastMode] = useState(localStorage.getItem("sd-fast") === null ? false : (localStorage.getItem("sd-fast") === "true"))
    const [isFullMode,setIsFullMode] = useState(false)
    const [useControlnet,setUseControlnet] = useState(false)
    const [modelFullModeEnable,setModelFullModeEnable] = useState(false)
    const [isScaleUpx2,setIsScaleUpx2] = useState(false)
    const [sdSampler,setSdSampler] = useState(localStorage.getItem("sd-sampler") || "Euler A Turbo")
    const [sdUpscaler,setSdUpscaler] = useState(localStorage.getItem("sd-upscaler") || "R-ESRGAN 4x+ Anime6B")
    const [sdSteps,setSdSteps] = useState(localStorage.getItem("sd-steps") || 14)
    const [sdScale,setSdScale] = useState(localStorage.getItem("sd-scale") || 5)
    const [sdDenoisingStrength,setSdDenoisingStrength] = useState(localStorage.getItem("sd-denoising-strength") || 0.35)
    const [sdSeed,setSdSeed] = useState(localStorage.getItem("sd-seed") || -1)
    const [sdImagesCount,setSdImagesCount] = useState("1")
    const [aiGenerateImageList,setAIGenerateImageList] = useState([]) // AI生成履歴
    const [generatedImageIndex,setGeneratedImageIndex] = useState(0) 
    const [generateImageListCols,setGenerateImageListCols] = useState(localStorage.getItem("generateImageListCols") || 3) // AI生成履歴の表示列数
    const [displayAIGeneratedPanel,setDisplayAIGeneratedPanel] = useState(false) // AI生成履歴パネルの表示
    const [aiGenerateImagePage,setAIGenerateImagePage] = useState(-1) // AI生成履歴パネルのページ
    const [aiGenerateReset,setAIGenerateReset] = useState(false) // AI生成履歴を再取得するためのフラグ
    const [generateMode,setGenerateMode] = useState("txt2img") // 生成モード
    const [showSettings,setShowSettings] = useState(false) // settings表示
    const [generateTabKey,setGenerateTabKey] = useState("txt2img") // 生成タブキー表示
    const [img2ImgFile,setImg2ImgFile] = useState() // img2imgのbase64
    const [inpaintFile,setInpaintFile] = useState() // inpaintする元画像のbase64
    const [inpaintMask,setInpaintMask] = useState() // inpaintで使用するmask画像
    const [selectedImageWidth,setSelectedImageWidth] = useState(0) // img2imgのbase64のwidth
    const [selectedImageHeight,setSelectedImageHeight] = useState(0) // img2imgのbase64のheight
    const [dlImages,setDLImages] = useState() // DL中
    const [modelList,setModelList] = useState([]) // モデル一覧
    const [modelSearchWord,setModelSearchWord] = useState("") // モデル検索
    const [tabKey,setTabKey] = useState("all") // 生成モデル一覧タブ
    const [generatedImageListHeight,setGeneratedImageListHeight] = useState("100px")
    const [scaleBy,setScaleBy] = useState(4) // アップスケール倍率
    const [trainingName,setTrainingName] = useState("") // トレーニング名
    const [training,setTraining] = useState(false) // トレーニング

    // コイン関連
    const [coinInfo,setCoinInfo] = useState([])
    const [coin,setCoin] = useState(0)
    const [loading,setLoading] = useState(false)
    const [imageList,setImageList] = useState([])
    const [imageListReset,setImageListReset] = useState(false)

    useEffect(() => {
        if(useAiGenerate){
            getCoinInfo().then(r => {
                if(r.result){
                    setCoinInfo(r.data)
                    setCoin(r.data.coin)
                    /*setChargeList(r.data.chargeList)
                    setUsageList(r.data.usageList)*/
                }
            })
        }
    },[useAiGenerate])

    useEffect(() => {
        localStorage.removeItem("generateImageListCols")
        localStorage.setItem("generateImageListCols",generateImageListCols)
    },[generateImageListCols])

    useEffect(() => {
        setUseAiGenerate(param.generate === "generate")
        if(param.generate === "generate"){
            aiGenInitHandler(true)
        }
    },[param.generate])

    let procId = ""
    useEffect(() => {
        if(aiGenerateImagePage > 0 && loginInfo.result){
            calcCost()
            getAIGeneraleImageList(loginInfo.userId,aiGenerateImagePage).then(r => {
                if(r.result){
                    if(r.data.length > 0){
                        if(aiGenerateImagePage === 1){
                            setAIGenerateImageList([].concat(r.data))
                        } else {
                            setAIGenerateImageList(aiGenerateImageList.concat(r.data))
                        }
                    } else {
                        if(aiGenerateImagePage === 1){
                            setAIGenerateImageList([])
                            //dialog("","履歴がありません。AI生成機能を利用してみませんか？")
                        }
                    }
                } else {
                    setAIGenerateImageList([])
                    dialog("確認",r.errors)
                }
                let elm = document.getElementById("generated-image-list")
                if(elm !== null && window){
                    let newHeight = window.innerHeight - elm.offsetTop
                    setGeneratedImageListHeight(newHeight)
                }
            })
        }
    },[loginInfo,aiGenerateImagePage,aiGenerateReset])

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[aiGenerateImageList])

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "500px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (aiGenerateImagePage * 200 - 1) ){
                    setAIGenerateImagePage(aiGenerateImagePage+1)
                    console.log(aiGenerateImagePage)
                }
              }
        })
    }, options);

    // 編集情報
    const [editImageNo,setEditImageNo] = useState(0)
    const [editImageTargetNo,setEditImageTargetNo] = useState(-1)
    const [editLabel,setEditLabel] = useState("モザイク描画")
    const [previewSource,setPreviewSource] = useState("")
    const [previewFlg,setPreviewFlg] = useState(false)
    const ref = React.createRef()
    const styleRef = React.createRef()
    const [styleOptions,setStyleOptions] = useState([])
    const [styleSelected,setStyleSelected] = useState([])
    const [generateMethodSelected,setGenearteMethodSelected] = useState([])
    const [optionSelected,setOptionSelected] = useState([])
    const [enterJpPrompt,setEnterJpPrompt] = useState(false)
    const [enterEnhancePrompt,setEnterEnhancePrompt] = useState(false)
    const [jpCost,setJpCost] = useState(0)
    const [aiTalkShow,setAiTalkShow] = useState(false)
    const [tagSelectorShow,setTagSelectorShow] = useState(false)
    const [sampleCollectionShow,setSampleCollectionShow] = useState(false)
    const [selectedSample,setSelectedSample] = useState(null)
    const [bookingDate,setBookingDate] = useState("")
    const [bookingTime,setBookingTime] = useState("")
    const [tagOptions, setTagOptions] = useState([])
    const [tag, setTag] = useState([])

    // 投稿完了後
    const [postedGroupId,setPostedGroupId] = useState("")
    const [url,setURL] = useState("")
    const [urlAffi,setURLAffi] = useState("")
    const [imgUrl,setImgURL] = useState("")
    let timer
    let uploadProgressNo = 0
    let oldUploadProgressNo = 1

    function uploadSelect(files){
        // アップロード開始
        setUploading(true)
        // 入力フォーム無効化
        setDisabled()
        let batch = document.getElementById("batch").checked
        if(batch){
            setBatchUploading(true)
            timer = setInterval(() => {
                if(!uploading){
                    if(uploadProgressNo < files.length){
                        if(uploadProgressNo !== oldUploadProgressNo){
                            upload([files[uploadProgressNo]])
                            let per = Math.floor((uploadProgressNo + 1) / files.length * 100)
                            let label = ""
                            if(per === 100){
                                label = "登録中"
                            } else {
                                label = per + "%"
                            }
                            setBatchProgressNow(per)
                            setBatchProgressLabel(label)
                        }
                        oldUploadProgressNo = uploadProgressNo
                    }
                }
            },3000)
        } else {
            upload(files)
        }
    }

    /**
     * 入力フォームを無効化する
     */
    function setDisabled(){
        let elements = ["batch","title","description","original","limited-publication",
            "ai-model","prompt","negative-prompt","delete-password"
            ,"noise","steps","scale","seed","sampler","strength","mask-blur",
            "clip-skip","controlnet-enabled","controlnet-module","controlnet-model","controlnet-weight",
            "ensd","hires-upscale","hires-upscaler","raw-info"
        ]
        elements.forEach(id => {
            if(loginInfo.result && id === "delete-password") return
            let elm = document.getElementById(id)
            if(elm !== null)
            elm.setAttribute("disabled",true)
        })
    }

    /**
     * 入力フォームの無効化を解除する
     */
    function unsetDisabled(){
        let elements = ["batch","title","description","original","limited-publication",
            "ai-model","prompt","negative-prompt","delete-password"
            ,"noise","steps","scale","seed","sampler","strength","mask-blur",
            "clip-skip","controlnet-enabled","controlnet-module","controlnet-model","controlnet-weight",
            "ensd","hires-upscale","hires-upscaler","raw-info"
        ]
        elements.forEach(id => {
            if(loginInfo.result && id === "delete-password") return
            let elm = document.getElementById(id)
            if(elm !== null)
            elm.removeAttribute("disabled")
            
        })
    }

    /**
     * 入力フォームの内容をリセットする
     */
    function deleteFormValue(){
        let elements = ["batch","title","description"]
        elements.forEach(id => {
            let elm = document.getElementById(id)
            elm.value = ""
        })
        document.getElementById("batch").checked = false
        //document.getElementById("original").checked = false
        //document.getElementById("limited-publication").checked = false

        document.getElementById("ai-model").value = "no-select"
        document.getElementById("prompt").value = ""
        document.getElementById("negative-prompt").value = ""
        document.getElementById("noise").value = ""
        document.getElementById("steps").value = ""
        document.getElementById("scale").value = ""
        document.getElementById("seed").value = ""
        document.getElementById("sampler").value = ""
        document.getElementById("strength").value = ""
        document.getElementById("mask-blur").value = ""
        document.getElementById("model-version").value = ""
        document.getElementById("clip-skip").value = ""
        document.getElementById("controlnet-enabled").value = ""
        document.getElementById("controlnet-module").value = ""
        document.getElementById("controlnet-model").value = ""
        document.getElementById("controlnet-weight").value = ""
        document.getElementById("ensd").value = ""
        document.getElementById("hires-upscale").value = ""
        document.getElementById("hires-upscaler").value = ""
        document.getElementById("raw-info").value = ""
        setVAE([])
        setGPU([])
        setVRAM([])

        if(loginInfo.length === 0){
            let deletePassword = document.getElementById("delete-password")
            deletePassword.value = ""
        }
        setFileList([])
    }

    /**
     * 現在の情報を削除する
     */
    function deleteSelectedFormValue(){
        document.getElementById("ai-model").value = "no-select"
        document.getElementById("prompt").value = ""
        document.getElementById("negative-prompt").value = ""
        document.getElementById("noise").value = ""
        document.getElementById("steps").value = ""
        document.getElementById("scale").value = ""
        document.getElementById("seed").value = ""
        document.getElementById("sampler").value = ""
        document.getElementById("strength").value = ""
        document.getElementById("mask-blur").value = ""
        document.getElementById("model-version").value = ""
        document.getElementById("clip-skip").value = ""
        document.getElementById("controlnet-enabled").value = ""
        document.getElementById("controlnet-module").value = ""
        document.getElementById("controlnet-model").value = ""
        document.getElementById("controlnet-weight").value = ""
        document.getElementById("ensd").value = ""
        document.getElementById("hires-upscale").value = ""
        document.getElementById("hires-upscaler").value = ""
        document.getElementById("raw-info").value = ""
        setVAE([])
        setGPU([])
        setVRAM([])

        if(fileList.length > 0){
            fileList.filter((d,i) => i === editImageNo).map(r => {
                r.prompt = ""
                r.software = "no-select"
                r.softwareLocked = "0"
                r.modelHash = ""
                r.rawInfo = ""
                r.useAIGeneration = false
                r.comment = {uc:"",noise:"",steps:"",scale:"",seed:"",sampler:"",strength:"",maskBlur:"",
                    clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",ensd:"",
                    hiresUpscale:"",hiresUpscaler:""
                }
                r.error = false
                return r
            })
        }
    }

    function upload(files){
        let fd = new FormData()
        let batch = document.getElementById("batch").checked
        let bookingDatetime = ""
        if(bookingDate.length > 0 && bookingTime.length > 0){
            bookingDatetime = bookingDate + " " + bookingTime
        } else {
            bookingDatetime = ""
        }
        // 一括投稿モードかつファイル名利用フラグが有効の場合、ファイル名から拡張子をとったものをタイトルに設定
        if(batch && useFilename){
            let title = files[0].file.name.replace(/\..[^.]+?$/,"").substring(0,100)
            if(title === ""){
                title = "無題"
            }
            fd.append("title",title)
        } else {
            fd.append("title",document.getElementById("title").value)
        }
        fd.append("styleOfPainting",styleOfPainting)
        fd.append("original",optionSelected.findIndex(v => v.value === "original") !== -1 ? "1" : "0")
        fd.append("bookingDatetime",bookingDatetime)
        fd.append("ageLimit",ageLimit)
        fd.append("sexualExpression",sexualExpression)
        fd.append("limitDiv",limitDiv)
        selectionPlans.forEach(d => {
            fd.append("selectionPlans[]",d)
        })
        fd.append("unitAmount",unitAmount)
        fd.append("loggedInUserOnly",optionSelected.findIndex(v => v.value === "loggedInUserOnly") !== -1 ? "1" : "0")
        fd.append("limitedPublication",optionSelected.findIndex(v => v.value === "limitedPublication") !== -1 ? "1" : "0")
        fd.append("displayNewList",optionSelected.findIndex(v => v.value === "newPostHidden") !== -1 || batch ? "1" : "0")
        fd.append("displayRanking",optionSelected.findIndex(v => v.value === "rankingHidden") !== -1 ? "1" : "0")
        fd.append("sensitive",optionSelected.findIndex(v => v.value === "sensitive") !== -1 ? "1" : "0")
        fd.append("editImageNo",editImageNo) // 標準サムネイル番号
        fd.append("seriesId",series.id !== undefined ? series.id : "") // シリーズID
        if(selectedCharacterList.length > 0){
            selectedCharacterList.forEach(d => {
                fd.append("selectedCharacterList[]",d.id)
            })
        }
        if(batch){
            if(uploadProgressNo === 0){
                fd.append("insideThumbnail",insideThumbnail !== undefined ? insideThumbnail : "")
                fd.append("outsideThumbnail",outsideThumbnail !== undefined ? outsideThumbnail : "")
                if(questionInfo !== undefined){
                    if(questionInfo.options.filter(v => v.length > 0).length > 0){
                        fd.append("questionDeadlineDatetime",questionInfo.deadlineDate + " " + questionInfo.deadlineTime)
                        questionInfo.options.filter(v => v.length > 0).forEach(d => {
                            fd.append("questionOptions[]",d)
                        })
                    }
                }
            }
        } else {
            fd.append("insideThumbnail",insideThumbnail !== undefined ? insideThumbnail : "")
            fd.append("outsideThumbnail",outsideThumbnail !== undefined ? outsideThumbnail : "")
            if(questionInfo !== undefined){
                if(questionInfo.options.filter(v => v.length > 0).length > 0){
                    fd.append("questionDeadlineDatetime",questionInfo.deadlineDate + " " + questionInfo.deadlineTime)
                    questionInfo.options.filter(v => v.length > 0).forEach(d => {
                        fd.append("questionOptions[]",d)
                    })
                }
            }
        }
        fd.append("request",document.getElementById("request").value)
        let description = document.getElementById("description").value

        let aiModel = document.getElementById("ai-model")
        if(aiModel.value !== "no-select"){
            if(description.indexOf(aiModel.value) === -1){
                description += "\n#" + aiModel.value.replace(/-/g,"_").replace(/\s/g,"_").replace(/\(|\)/g,"_").replace(/_+/g,"_").replace(/_$/g,"")
                if(description.indexOf("#AIイラスト") === -1){
                    // description += " #AIイラスト #AIart"
                }
            }
        }
        // イベントタグ
        if(eventTag.length > 0 && description.indexOf("#"+eventTag) === -1){
            description += "\n#" + eventTag
        }
        // タグ
        if(tag.length > 0){
            description += "\n" + tag.map(d => "#"+d).join(" ")
        }

        if(generateMethodSelected.findIndex(v => v.value === "t2i") !== -1) description += " #t2i"
        if(generateMethodSelected.findIndex(v => v.value === "i2i") !== -1) description += " #i2i"
        if(generateMethodSelected.findIndex(v => v.value === "inpaint") !== -1) description += " #inpaint"
        if(generateMethodSelected.findIndex(v => v.value === "outpaint") !== -1) description += " #outpaint"
        if(generateMethodSelected.findIndex(v => v.value === "ip2p") !== -1) description += " #ip2p"
        if(generateMethodSelected.findIndex(v => v.value === "ControlNet") !== -1) description += " #ControlNet"

        let promptFound = false
        for(let i = 0;i < files.length;i++){
            let useMosaic = files[i].useMosaic
            let imageDataOriginal = files[i].imageDataOriginal
            fd.append("useMosaic[]",useMosaic ? "1" : "0")
            fd.append("imageDataOriginal[]",useMosaic ? base64ToFile(imageDataOriginal.replace(/^.*,/, ''),files[i].file.name,"image/png") : "")
            // 使用モデルは必須
            let software = files[i].software ? files[i].software : ""
            fd.append("software[]",software.replace(/-/g,"_").replace(/\s/g,"_").replace(/\(|\)/g,"_").replace(/_+/g,"_").replace(/_$/g,""))

            if(promptInfoPublication){
                let modelId = files[i].modelId ? files[i].modelId : ""
                let modelHash = files[i].modelHash ? files[i].modelHash : ""
                let prompt = files[i].prompt ? files[i].prompt : ""
                let negativePrompt = files[i].comment !== undefined ? files[i].comment.uc : ""
                let noise = files[i].comment !== undefined ? files[i].comment.noise : ""
                let steps = files[i].comment !== undefined ? files[i].comment.steps : ""
                let scale = files[i].comment !== undefined ? files[i].comment.scale : ""
                let seed = files[i].comment !== undefined ? files[i].comment.seed : ""
                let sampler = files[i].comment !== undefined ? files[i].comment.sampler : ""
                let strength = files[i].comment !== undefined ? files[i].comment.strength : ""
                let maskBlur = files[i].comment !== undefined ? files[i].comment.maskBlur : ""
                let clipSkip = files[i].comment !== undefined ? files[i].comment.clipSkip : ""
                let controlNetEnabled = files[i].comment !== undefined ? files[i].comment.controlNetEnabled : ""
                let controlNetModule = files[i].comment !== undefined ? files[i].comment.controlNetModule : ""
                let controlNetModel = files[i].comment !== undefined ? files[i].comment.controlNetModel : ""
                let controlNetWeight = files[i].comment !== undefined ? files[i].comment.controlNetWeight : ""
                let ensd = files[i].comment !== undefined ? files[i].comment.ensd : ""
                let hiresUpscale = files[i].comment !== undefined ? files[i].comment.hiresUpscale : ""
                let hiresUpscaler = files[i].comment !== undefined ? files[i].comment.hiresUpscaler : ""
                let rawInfo = files[i].rawInfo !== undefined ? files[i].rawInfo : ""
                let vae = files[i].vae !== undefined ? files[i].vae : ""
                let gpu = files[i].gpu !== undefined ? files[i].gpu : ""
                let vram = files[i].vram !== undefined ? files[i].vram : ""
                let useAIGeneration = files[i].useAIGeneration ? 1 : 0
                if(typeof prompt === "string"){
                    if(!promptFound && (prompt.trim().length > 0 || negativePrompt.trim().length > 0)){
                        promptFound = true
                    }
                }
                fd.append("modelId[]",modelId)
                fd.append("modelHash[]",modelHash)
                fd.append("prompt[]",prompt)
                fd.append("negativePrompt[]",negativePrompt)
                fd.append("noise[]",noise)
                fd.append("steps[]",steps)
                fd.append("scale[]",scale)
                fd.append("seed[]",seed)
                fd.append("sampler[]",sampler)
                fd.append("strength[]",strength)
                fd.append("maskBlur[]",maskBlur)
                fd.append("clipSkip[]",clipSkip)
                fd.append("controlNetEnabled[]",controlNetEnabled)
                fd.append("controlNetModule[]",controlNetModule)
                fd.append("controlNetModel[]",controlNetModel)
                fd.append("controlNetWeight[]",controlNetWeight)
                fd.append("ensd[]",ensd)
                fd.append("hiresUpscale[]",hiresUpscale)
                fd.append("hiresUpscaler[]",hiresUpscaler)
                fd.append("rawInfo[]",rawInfo)
                fd.append("vae[]",vae)
                fd.append("gpu[]",gpu)
                fd.append("vram[]",vram)
                fd.append("useAIGeneration[]",useAIGeneration)
            }
        }
        if(promptFound){
            description += " #プロンプトあり"
        }
        fd.append("description",description)
        if(loginInfo.result === false){
            fd.append("deletePassword",document.getElementById("delete-password").value)
        }
        for(let i = 0;i < files.length;i++){
            fd.append("file[]",files[i].useMosaic === "1" ? base64ToFile(files[i].imageDataEdited.replace(/^.*,/, ''),files[i].file.name,"image/png") : files[i].file)
        }
        let req = new XMLHttpRequest()
        req.open("POST",ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/image")
        req.withCredentials = true
        req.onreadystatechange = () => {
            if(req.readyState === 4 && req.status === 200){
                if(req.responseText !== ""){
                    var r = JSON.parse(req.responseText)
                    if(r.result){
                        let title = document.getElementById("title")
                        let titleValue = title.value

                        if(batch && fileList.length !== 1){
                            console.log(uploadProgressNo+1,fileList.length)
                            if(uploadProgressNo + 1 === fileList.length){
                                clearInterval(timer)
                                // 入力内容をリセット
                                deleteFormValue()
                                unsetDisabled()
                                setBatchProgressNow(0)
                                setBatchProgressLabel(0)
                                setBatchUploading(false)
                                setUploading(false)
                                dialog("確認","投稿完了しました。")
                                uploadProgressNo = 0
                                oldUploadProgressNo = 1
                            }
                        } else {
                            // 予約投稿でなければリンク共有メッセージを出す
                            if(bookingDate === ""){
                                // 投稿ID
                                setPostedGroupId(r.groupId)
                                // タグ
                                let tags = r.tags.filter(tag => {
                                    // 自動で追加するタグは除外する
                                    return tag !== "AIイラスト"
                                }).map(tag => "#" + tag).join(" ")
                                // サムネイルURL
                                setImgURL(ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+r.img)
                                // ツイートURL
                                setURL("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                                    + encodeURIComponent("「アワートAI」AIイラスト無料生成&投稿サイトに投稿しました！\nタイトル：「" + titleValue + "」\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/image/"+r.groupId + "\n#ourtAI")
                                )
                                setURLAffi("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                                    + encodeURIComponent("「アワートAI」AIイラスト無料生成&投稿サイトに投稿しました！\nタイトル：「" + titleValue + "」\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/image/"+r.groupId + "?af=" + (r.display_id === "" ? r.user_id : r.display_id) + "\n#ourtAI")
                                )
                            } else {
                                dialog("確認","予約投稿が完了しました。")
                            }
                            // 入力内容をリセット
                            deleteFormValue()
                            unsetDisabled()
                            // アップロード終了
                            setUploading(false)
                        }
                        setTempThumbnail()
                        setEventTag("")
                        uploadProgressNo++
                        // 入力準備チェック
                        setUploadReady(false)
                    } else {
                        clearInterval(timer)
                        unsetDisabled()
                        setBatchProgressNow(0)
                        setBatchProgressLabel(0)
                        setBatchUploading(false)
                        setUploading(false)
                        dialog("エラー",r.errors.join("\r\n"))
                    }
                    setProgressNow(0)
                    setProgressLabel(0)
                }
            }
        }
        req.onerror = (e) => {
            clearInterval(timer)
            setUploading(false)
            unsetDisabled()
            setProgressNow(0)
            setProgressLabel(0)
            setBatchProgressNow(0)
            setBatchProgressLabel(0)
            setBatchUploading(false)
            setUploading(false)
            console.log(e)
            dialog("エラー","通信エラーが発生しました。")
        }
        req.upload.onprogress = (e) => {
            let per = Math.floor(e.loaded / e.total * 100)
            let label = ""
            if(!batch && per === 100){
                label = "登録中"
            } else {
                label = per + "%"
            }
            setProgressNow(per)
            setProgressLabel(label)
        }
        req.send(fd)
    }

    // 画像設定
    const [fileList, setFileList] = useState([])
    const [fileSize, setFileSize] = useState(0)
    const [fileSizeByte, setFileSizeByte] = useState(0)
    const [fileSizeOver,setFileSizeOver] = useState(false)

    useEffect(() => {
        if(loginInfo.result === false){
            //navigate("/")
        }
        if(loginInfo.result && loginInfo.status !== 0){
            dialog(t("common.error"),"アカウントは利用できません。")
        }
        if(loginInfo.result){
            // シリーズ
            getSeriesList(loginInfo.userId).then(r => {
                if(r.result){
                    let list = []
                    for(let i = 0;i < r.data.length;i++){
                        list.push({"label":r.data[i].info.series_name,"id":r.data[i].info.series_id})
                    }
                    setSeriesList(list)
                }
            })
        }
    },[loginInfo])

    useEffect(() => {
        // お題
        getOdai().then(r => {
            if(r.result && r.data.length > 0){
                setOdai(r.data[0].odai)
            }
        })
        // ポイント
        getPoint().then(r => {
            if(r.result){
                setPoint(r.point)
            } else {
                dialog("エラー",r.errors)
            }
        })
        // 時間帯別利用者数
        getUsersByDay().then(r => {
            if(r.result){
                setUserList(<Bar data={createGraphData(r.data.list,"時間帯別利用者数")} />)
            }
        })
        // 最新タグ
        getTagLatest().then(r => {
            if(r.result){
                setTagLatest(r.data)
            }
        })
    },[])

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "画像投稿 - ourt AI"

        // ファイルサイズ合計計算
        let size = 0
        for(let i = 0;i < fileList.length;i++){
            size += fileList[i].file.size
        }
        setFileSizeByte(size)
        size = size / 1024 / 1024 / 1024
        setFileSizeOver(size > 300)
        setFileSize(Math.ceil(size) + " GB")

        // 獲得ポイント計算
        calcPoint(fileList.length).then(r => {
            if(r.result){
                setCalcPointInfo(r.data)
            }
        })

        if(fileList.length > 0){
            document.getElementById("load-image").src = fileList[editImageNo].useMosaic ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataMiddle
            if(selectedImageFilename !== fileList[editImageNo].file.name){
                //setInsideThumbnail()
                //setOutsideThumbnail()
                setSelectedImageFilename(fileList[editImageNo].file.name)
            }
            if(tempThumbnail === undefined){
                ImageUtil.load(fileList,fileList[0].file,0,(data,data2,data3)=>{
                    if(data !== false){
                        setInsideThumbnail((fileList[0].useMosaic ? fileList[0].imageDataEdited : fileList[0].imageDataMiddle) || data3)
                    }
                })
            }
        }
    },[fileList])

    // 調整用サムネイル
    const [insideThumbnail,setInsideThumbnail] = useState()   // 内部用
    const [outsideThumbnail,setOutsideThumbnail] = useState() // 外部用(OGP)
    const [tempThumbnail,setTempThumbnail] = useState()
    const [selectedImageFilename,setSelectedImageFilename] = useState()

    useEffect(() => {
        if(fileList.length > 0){
            document.getElementById("load-image").src = fileList[editImageNo].useMosaic ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataMiddle
            //setInsideThumbnail()
            //setOutsideThumbnail()
            setSelectedImageFilename(fileList[editImageNo].file.name)
        }
    },[editImageNo])

    // 選択画像を検出してフォーム内容を切り替え
    useEffect(() => {
        if(editImageNo !== -1 && fileList.length > 0){
            setMetaDataField(fileList[editImageNo],true)
        }
    },[fileList,editImageNo])

    // 編集対象の画像を処理
    useEffect(() => {
        if(editImageTargetNo !== -1){
            let file = fileList[editImageTargetNo]
            setCanvas(file)
        }
    },[editImageTargetNo])

    function imageSet(files,isuseAIGeneration,info = []){
        setMessage('')
        setMessageShow("none")
        let fileList = []
        for(let i = 0;i < files.length;i++){
            //if(String(files[i].name).match(/\.(jpg|jpeg?|jfif|bmp|png|gif|webp)$/)){
                let img = new ImageFile({file:files[i]})
                if(info.model_id !== undefined && info.model_id.length > 0){
                    img.modelId = info.model_id
                }
                if(info.model_name !== undefined && info.model_name.length > 0){
                    img.software = info.model_name
                }
                if(isuseAIGeneration){
                    img.useAIGeneration = true
                }
                fileList.push(img)
                // AI生成画像の場合は情報を取得して最初の1件目をフィールドに反映
                setMetaData(files[i],img).then(r => {
                    if(i === 0) setMetaDataField(img,false)
                })
            //}
        }
        setEditImageNo(0)
        setFileList(fileList)
    }

    function imageAdd(files,isuseAIGeneration,info = []){
        setMessage('')
        setMessageShow("none")
        let list = fileList.concat([])
        for(let i = 0;i < files.length;i++){
            //if(String(files[i].name).match(/\.(jpg|jpe?|jfif|bmp|png|gif|webp)$/)){
                let img = new ImageFile({file:files[i]})
                if(info.model_id !== undefined && info.model_id.length > 0){
                    img.modelId = info.model_id
                }
                if(info.model_name !== undefined && info.model_name.length > 0){
                    img.software = info.model_name
                }
                if(isuseAIGeneration){
                    img.useAIGeneration = true
                }
                list.push(img)
                // AI生成画像の場合は情報を取得してフィールドに設定
                setMetaData(files[i],img).then(r => {

                })
            //}
        }
        setFileList(list)
    }

    /**
     * AIで作成された画像の生成情報を取得する
     * @todo 絵文字があるとextractChunksで読み込めない
     * 
     * @param {File} file 
     * @param {ImageFile} img 
     */
    function setMetaData(file,img){
        return file.arrayBuffer().then(buffer => {
            if(notReadPromptInfo) return
            try {
                let chunks = extractChunks(new Uint8Array(buffer))
                .filter(value => value.name === "tEXt" || value.name === "iTXt")
                .map((value) => {
                    let data = value.data
                    let text = new TextDecoder().decode(data)
                    let items = ["Description","Software","Source","Comment","parameters"]
                    let itemName
                    if(undefined !== (itemName = items.find((v) => text.startsWith(v)))){
                        return {name:itemName,value:text.substring(itemName.length+1)}
                    } else {
                        return {name:itemName,value:""}
                    }
                })
                .filter(value => value.name !== undefined)

                // Stable Diffusionならparametersがある
                let parameters = chunks.find(d => d.name === "parameters")
                if(parameters !== undefined && parameters.value !== ""){
                    img.rawInfo = parameters.value.replace(/[\x00]/g,'')
                    let split = parameters.value.split("\n")
                    let prompt = ""
                    let negativePrompt = ""
                    let options = ""
                    let negativeIndex = 0
                    for(let i = 1;i<split.length;i++){
                        if(split[i].startsWith("Negative prompt: ")){
                            negativePrompt = split[i].replace("Negative prompt: ","")
                            negativeIndex = i
                        }
                        if(split[i].startsWith("Steps:")){
                            options = split[i]
                        }
                    }
                    for(let i = 0;i< negativeIndex;i++){
                        prompt += split[i] + "\r\n"
                    }
                    prompt = prompt.replace(/[\x00]/g,'')
                    negativePrompt = negativePrompt.replace(/[\x00]/g,'')
                    options = options.replace(/[\x00]/g,'')
                    //prompt = prompt.replace(/ +/g,' ')
                    let params = []
                    for(const m of options.matchAll(/([a-zA-Z0-9 ]+): ([0-9a-zA-Z.\-_ +]+)?/g)){
                        if(m[2] !== undefined)
                        params.push({name:String(m[1]).trim(),value:m[2]})
                    }
                    // プロンプト
                    for(const m of options.matchAll(/([a-zA-Z0-9 ]+): "(.+?)"/g)){
                        if(m[2] !== undefined)
                        params.push({name:String(m[1]).trim(),value:m[2]})
                    }
                    if(split.length <= 1){
                        throw new Error("必要な情報が揃っていません。")
                    }
                    /*let params = options.split(",").map(d => {
                        let name
                        let value
                        let tmp
                        let item
                        tmp = d.trim()
                        item = tmp.split(":")
                        name = item[0]
                        value = item[1].substring(1)
                        console.log("4")
                        return {name:name,value:value}
                    })*/

                    img.prompt = prompt
                    let modelHash = params.find(d => d.name === "Model hash")
                    if(modelHash !== undefined){
                        img.software = "no-select"
                        if(modelHash.value === "6569e224"){
                            img.software = "AnythingV3"
                        } else if(
                               modelHash.value === "04c147f2" // v1.1 full
                            || modelHash.value === "4567aa0f" // v1.1
                            || modelHash.value === "11d755f8" // v1.2 full
                            || modelHash.value === "5e18682b" // v1.2
                            || modelHash.value === "ec706de4" // v1.3 full
                            || modelHash.value === "3706d7ad" // v1.3
                            || modelHash.value === "06c50424" // v1.4 full
                            || modelHash.value === "7460a6fa" // v1.4
                        ){
                            img.software = "StableDiffusion"
                        } else if(
                               modelHash.value === "84692140"   // v1.3 float16
                            || modelHash.value === "4470c325"   // v1.3 float32
                            || modelHash.value === "e1de58a9"   // v1.3 full
                            || modelHash.value === "3e1a125f"   // v1.3 full opt
                            || modelHash.value === "27310bc7"   // v1.4
                        ){
                            img.software = "WaifuDiffusion"
                        } else if(
                               modelHash.value === "e2ec4647" // 16
                            || modelHash.value === "3a0cfc1c" // 17
                        ){
                            img.software = "HentaiDiffusion"
                        } else if(
                               modelHash.value === "abaf1da6" // ACertainModel-half
                            || modelHash.value === "0ea1c8b4" // ACertainModel
                        ){
                            img.software = "ACertainModel"
                        } else if(
                            modelHash.value === "27bd26ec" // ACertainThing-half
                         || modelHash.value === "26f53cad" // ACertainThing
                        ){
                            img.software = "ACertainThing"
                        } else if(
                               modelHash.value === "0e200e66" // ACertainty
                        ){
                            img.software = "ACertainty"
                        } else if(modelHash.value === "1449e5b0b9"){
                            img.software = "Animagine XL V3"
                        } else if(modelHash.value === "b5c0b653"){
                            img.software = "Protogen"
                        } else if(modelHash.value === "fde2460c"){ 
                            img.software = "ourtAIDiffusion" // V1.0
                        } else if(modelHash.value === "4048130a"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "8838e0d1fb"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "f3b033b02f"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "71e703a0fc"){
                            img.software = "Counterfeit" // V2.5
                        } else if(modelHash.value === "fc9d6d1ff2"){
                            img.software = "SukiyakiMix" // v1.0
                        } else if(modelHash.value === "6e350084a6"){
                            img.software = "7th_anime" // 7th_anime_3.1_A
                        } else if(modelHash.value === "a916690d6d"){
                            img.software = "ourt AI Diffusion (Anime V1)" // Anime V1
                        } else if(modelHash.value === "7a5574856e"){
                            img.software = "ourt AI Diffusion (Anime V2)" // Anime V2
                        } else if(modelHash.value === "09184cfb61"){
                            img.software = "ourt AI Diffusion (Anime V3)" // Anime V3
                        } else if(modelHash.value === "c53b90ad34"){
                            img.software = "ourt AI Diffusion (Anime V3.5)" // Anime V3.5
                        } else if(modelHash.value === "1b5f8211ec"){
                            img.software = "Aurora_v1.0" // Aurora v1.0
                        } else if(modelHash.value === "6772b99463"){
                            img.software = "blue_pencil_v9b" // blue_pencil_v9b
                        } else if(modelHash.value === "3a105af1a6"){
                            img.software = "blue_pencil_v10" // blue_pencil_v10
                        } else if(modelHash.value === "0fd9832365"){
                            img.software = "blue_pencil_EX" // blue_pencil_EX
                        } else if(modelHash.value === "b1fce039e2"){
                            img.software = "milktea_mild_V1" // milktea_mild_V1
                        } else if(modelHash.value === "e4a30e4607"){
                            img.software = "majicmixRealistic_v6"
                        } else {
                            let model = params.find(d => d.name === "Model")
                            if(model !== undefined){
                                img.software = model.value
                            }
                            img.modelHash = modelHash.value
                        }

                        img.modelHash = modelHash.value

                    } else {
                        img.software = "no-select"
                        let model = params.find(d => d.name === "Model")
                        if(model !== undefined){
                            img.software = model.value
                        } else {
                            throw new Error("unsupported model")
                        }
                    }

                    let steps = params.find(d => d.name === "Steps")
                    let scale = params.find(d => d.name === "CFG scale")
                    let seed = params.find(d => d.name === "Seed")
                    let sampler = params.find(d => d.name === "Sampler")
                    let denoisingStrength = params.find(d => d.name === "Denoising strength")
                    let maskBlur = params.find(d => d.name === "Mask blur")
                    let clipSkip = params.find(d => d.name === "Clip skip")
                    let controlNetEnabled = params.find(d => d.name === "ControlNet Enabled")
                    let controlNetModule = params.find(d => d.name === "ControlNet Module")
                    let controlNetModel = params.find(d => d.name === "ControlNet Model")
                    let controlNetWeight = params.find(d => d.name === "ControlNet Weight")
                    let ensd = params.find(d => d.name === "ENSD")
                    let hiresUpscale = params.find(d => d.name === "Hires upscale")
                    let hiresUpscaler = params.find(d => d.name === "Hires upscaler")

                    img.comment = {
                        uc:negativePrompt,
                        noise:"",
                        steps:steps === undefined ? "" : steps.value,
                        scale:scale === undefined ? "" : scale.value,
                        seed:seed === undefined ? "" : seed.value,
                        sampler:sampler === undefined ? "" : sampler.value,
                        // img2imgの場合はDenoising strengthとMask blurも追加
                        strength:denoisingStrength === undefined ? "" : denoisingStrength.value,
                        maskBlur:maskBlur === undefined ? "" : maskBlur.value,
                        clipSkip:clipSkip === undefined ? "" : clipSkip.value,
                        controlNetEnabled:controlNetEnabled === undefined ? "" : controlNetEnabled.value,
                        controlNetModule:controlNetModule === undefined ? "" : controlNetModule.value,
                        controlNetModel:controlNetModel === undefined ? "" : controlNetModel.value,
                        controlNetWeight:controlNetWeight === undefined ? "" : controlNetWeight.value,
                        ensd:ensd === undefined ? "" : ensd.value,
                        hiresUpscale:hiresUpscale === undefined ? "" : hiresUpscale.value,
                        hiresUpscaler:hiresUpscaler === undefined ? "" : hiresUpscaler.value,
                        vae:"",
                        gpu:"",
                        vram:""
                    }
                    return
                }

                // softwareがNovelAIの場合
                let software = chunks.find(d => d.name === "Software")
                let source = chunks.find(d => d.name === "Source")
                let description = chunks.find(d => d.name === "Description")
                let comment = chunks.find(d => d.name === "Comment")

                if(source !== undefined && source.value.split(" ").length === 3){
                    img.modelHash = source.value.split(" ")[2]
                }
                if(software !== undefined && software.value === "NovelAI"){
                    img.prompt = description === undefined ? "" : description
                    img.software = software.value
                    img.useAIGeneration= false
                    img.rawInfo = ""
                    img.vae = ""
                    img.gpu = ""
                    img.vram = ""
                    if(comment !== undefined && comment.value !== ""){
                        let j = JSON.parse(comment.value)
                        img.comment = {uc:j.uc,noise:j.noise,steps:j.steps,scale:j.scale,seed:j.seed,sampler:j.sampler,strength:j.strength,maskBlur:"",
                        clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",ensd:"",hiresUpscale:"",hiresUpscaler:""}
                    }
                }
            } catch(e) {
                img.prompt = ""
                img.software = "no-select"
                img.modelHash = ""
                img.vae = ""
                img.gpu = ""
                img.vram = ""
                img.comment = {uc:"",noise:"",steps:"",scale:"",seed:"",sampler:"",strength:"",maskBlur:"",
                clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",
                ensd:"",hiresUpscale:"",hiresUpscaler:"",rawInfo:"",useAIGeneration:false}
            }
        })
    }

    /**
     * 表示中のフィールドにメタデータを反映する
     * 
     * @param {ImageFile} img 
     * @param {bool} override
     */
    function setMetaDataField(img,override){
        let aiModel = document.getElementById("ai-model")
        let modelVersion = document.getElementById("model-version")
        let prompt = document.getElementById("prompt")
        let negativePrompt = document.getElementById("negative-prompt")
        let noise = document.getElementById("noise")
        let steps = document.getElementById("steps")
        let scale = document.getElementById("scale")
        let seed = document.getElementById("seed")
        let sampler = document.getElementById("sampler")
        let strength = document.getElementById("strength")
        let maskBlur = document.getElementById("mask-blur")
        let clipSkip = document.getElementById("clip-skip")
        let controlNetEnabled = document.getElementById("controlnet-enabled")
        let controlNetModule = document.getElementById("controlnet-module")
        let controlNetModel = document.getElementById("controlnet-model")
        let controlNetWeight = document.getElementById("controlnet-weight")
        let ensd = document.getElementById("ensd")
        let hiresUpscale = document.getElementById("hires-upscale")
        let hiresUpscaler = document.getElementById("hires-upscaler")
        let rawInfo = document.getElementById("raw-info")

        if(override || (aiModel.value === "no-select" && img.software !== "")){
            aiModel.value = img.software
        }
        let versions = {
            "1D44365E":"NAI Diffusion Anime (Curated)",
            "81274D13":"NAI Diffusion Anime (Full)",
            "1D09D794":"NAI Diffusion Furry (Beta V1.3)",
            "04c147f2":"v1.1 full ema", // Stable Diffusion～
            "4567aa0f":"v1.1",          
            "11d755f8":"v1.2 full ema",
            "5e18682b":"v1.2",
            "ec706de4":"v1.3 full ema",
            "3706d7ad":"v1.3",
            "06c50424":"v1.4 full ema",
            "7460a6fa":"v1.4",          // ～Stable Diffusion
            "84692140":"v1.3 float16",  // Waifu Diffusion～
            "4470c325":"v1.3 float32",
            "e1de58a9":"v1.3 full",
            "3e1a125f":"v1.3 full opt",
            "27310bc7":"v1.4",          // ～Waifu Diffusion
            "e2ec4647":"16",            // HentaiDiffusion
            "3a0cfc1c":"17",            // HentaiDiffusion
            "abaf1da6":"half",          // ACertainModel-half
            "27bd26ec":"half",          // ACertainThing-half
            "1449e5b0b9":"V3",
            "b5c0b653":"V2.2 (Anime)",  // Protogen V2.2 (Anime)
            "fde2460c":"V1.0",          // ourtAI Diffusion V1.0
            "4048130a":"V2.0",          // Counterfeit V2.0
            "8838e0d1fb":"V2.0",        // Counterfeit V2.0
            "f3b033b02f":"V2.0",        // Counterfeit V2.0
            "71e703a0fc":"V2.5",        // Counterfeit V2.5
            "fc9d6d1ff2":"v1.0 fp16",   // SukiyakiMix v1.0
            "6e350084a6":"anime_3.1_A", // 7th_anime_3.1_A
            "a916690d6d":"Anime V1",    // ourt AI Diffusion Anime V1
            "7a5574856e":"Anime V2",    // ourt AI Diffusion Anime V2
            "09184cfb61":"Anime V3",    // ourt AI Diffusion Anime V3
            "c53b90ad34":"Anime V3.5",  // ourt AI Diffusion Anime V3.5
            "1b5f8211ec":"v1.0 F16",    // Aurora v1.0
            "6772b99463":"v9b",         // blue_pencil_v9b
            "3a105af1a6":"v10",         // blue_pencil_v10
            "0fd9832365":"EX",          // blue_pencil_EX
            "b1fce039e2":"V1",          // milktea_mild_V1
            "e4a30e4607":"v6"           // majicmixRealistic_v6
        }
        if(override || (modelVersion.value === "" && img.modelHash !== "")){
            if(versions[img.modelHash]){
                modelVersion.value = versions[img.modelHash]
            } else {
                modelVersion.value = ""
            }
        }
        if(override || (prompt.value === "" && img.prompt)){
            prompt.value = img.prompt
        }
        if(override || (negativePrompt.value === ""  && img.comment && img.comment.uc)){
            negativePrompt.value = img.comment.uc
        }
        if(override || (noise.value === ""  && img.comment && img.comment.noise)){
            noise.value = img.comment.noise
        }
        if(override || (steps.value === ""  && img.comment && img.comment.steps)){
            steps.value = img.comment.steps
        }
        if(override || (scale.value === ""  && img.comment && img.comment.scale)){
            scale.value = img.comment.scale
        }
        if(override || (seed.value === ""  && img.comment && img.comment.seed)){
            seed.value = img.comment.seed
        }
        if(override || (sampler.value === ""  && img.comment && img.comment.sampler)){
            sampler.value = img.comment.sampler
        }
        if(override || (strength.value === ""  && img.comment && img.comment.strength)){
            strength.value = img.comment.strength
        }
        if(override || (maskBlur.value === ""  && img.comment && img.comment.maskBlur)){
            maskBlur.value = img.comment.maskBlur
        }
        if(override || (clipSkip.value === ""  && img.comment && img.comment.clipSkip)){
            clipSkip.value = img.comment.clipSkip
        }
        if(override || (controlNetEnabled.value === ""  && img.comment && img.comment.controlNetEnabled)){
            controlNetEnabled.value = img.comment.controlNetEnabled
        }
        if(override || (controlNetModule.value === ""  && img.comment && img.comment.controlNetModule)){
            controlNetModule.value = img.comment.controlNetModule
        }
        if(override || (controlNetModel.value === ""  && img.comment && img.comment.controlNetModel)){
            controlNetModel.value = img.comment.controlNetModel
        }
        if(override || (controlNetWeight.value === ""  && img.comment && img.comment.controlNetWeight)){
            controlNetWeight.value = img.comment.controlNetWeight
        }
        if(override || (ensd.value === ""  && img.comment && img.comment.ensd)){
            ensd.value = img.comment.ensd
        }
        if(override || (hiresUpscale.value === ""  && img.comment && img.comment.hiresUpscale)){
            hiresUpscale.value = img.comment.hiresUpscale
        }
        if(override || (hiresUpscaler.value === ""  && img.comment && img.comment.hiresUpscaler)){
            hiresUpscaler.value = img.comment.hiresUpscaler
        }
        if(override || (rawInfo.value === "" && img.rawInfo)){
            rawInfo.value = img.rawInfo
        }
        if(override || img.vae){
            setVAE([img.vae])
        }
        if(override || img.gpu){
            setGPU([img.gpu])
        }
        if(override || img.vram){
            setVRAM([img.vram])
        }
    }

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [dialogButton,setDialogButton] = useState()
    function dialog(title,message,button){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
        setDialogButton(button)
    }

    // エラーメッセージ
    const [message, setMessage] = useState('')
    const [messageShow, setMessageShow] = useState('none')

    const [title, setTitle] = useState('')
    const [ageLimit, setAgeLimit] = useState('')
    const [sexualExpression,setSexualExpression] = useState('')
    const [styleOfPainting, setStyleOfPainting] = useState('')
    const [sdStyleOfPainting, setSdStyleOfPainting] = useState('all')
    const [scaleTargetStyle, setScaleTargetStyle] = useState('illustration')
    const [vae, setVAE] = useState()
    const [gpu, setGPU] = useState()
    const [vram, setVRAM] = useState()

    const nenrei = [
      { name: t("upload.image.ageLimitG"), value: '1' },
      { name: t("upload.image.ageLimitPG12"), value: '2' },
      { name: t("upload.image.ageLimitR15"), value: '3' },
      { name: t("upload.image.ageLimitR18"), value: '4' },
      { name: t("upload.image.ageLimitR18G"), value: '5' }
    ]

    const radioKoukai = [
        { name: '全体公開', value: '1' },
        { name: '限定公開', value: '2' },
        { name: '非公開', value: '3' }
    ]

    const styles = [
        { name: t("upload.image.illustration"), value: '1' },
        { name: t("upload.image.semirealism"), value: '3' },
        { name: t("upload.image.photorealistic"), value: '2' },
    ]

    const yesOrNoRadio = [
        { name: t("common.no"), value: "2" },
        { name: t("common.yes"), value: "1" },
    ]

    const [limitDiv,setLimitDiv] = useState("public")
    const [selectionPlans,setSelectionPlans] = useState([])
    const columns = [
        { field: 'name', headerName: 'プラン名', width: 130, sortable: false, disableColumnMenu: true },
        { field: 'amount', headerName: '月額', width: 130, sortable: false, disableColumnMenu: true },
        {
          field: 'count',
          headerName: '支援者数',
          type: 'number',
          width: 90,
          sortable: false,
          disableColumnMenu: true
        },
        { field: 'age_limit', headerName: '年齢制限', width: 130, sortable: false, disableColumnMenu: true },
    ]  
    const [rows,setRows] = useState([])
    const [unitSell,setUnitSell] = useState("2")
    const [unitAmount,setUnitAmount] = useState(500)

    useEffect(() => {
        if(unitSell === "1"){
            setUnitAmount(500)
        } else {
            setUnitAmount(-1)
        }
    },[unitSell])

    const [fanart,setFanart] = useState("2")
    useEffect(() => {
        if(fanart === "2"){
            setSelectedCharacterList([])
        }
    },[fanart])

    function sendFileList(file){
        if(fileList.length === 0){
            imageSet([file],true)
        } else {
            imageAdd([file],true)
        }
        setEditImageNo(fileList.length)
        alert("投稿一覧に追加しました。")
    }
    const [serverStatus,setServerStatus] = useState([])
    const [serverWaitingStatus,setServerWaitingStatus] = useState(-1)
    const serverWaitingCount = useRef(-1)
    const [serverWaitingProcId,setserverWaitingProcId] = useState("")
    const [generateBookingCount,setBenerateBookingCount] = useState(0)
    const [before2SDTestCount,setBefore2SDTestCount] = useState(0)
    const [before24SDAllCount,setBefore24SDAllCount] = useState(0)
    const [before24DALLE3Count,setBefore24DALLE3Count] = useState(0)
    const [before24SD3Count,setBefore24SD3Count] = useState(0)
    const [srcGroupId,setSrcGroupId] = useState("")
    const [srcDetailId,setSrcDetailId] = useState("")
    const [srcTitle,setSrcTitle] = useState("")
    const [srcFavorite,setSrcFavorite] = useState("")
    const [generateProgress,setGenerateProgress] = useState(0)
    const [showGeneratedPanel,setShowGeneratedPanel] = useState(false)
    const [generatedInfo,setGeneratedInfo] = useState()
    const [generatedImageFile,setGeneratedImageFile] = useState()
    const [generatedImage,setGeneratedImage] = useState()
    const [generatedImageBase64,setGeneratedImageBase64] = useState()
    const [showGeneratedInfo,setShowGeneratedInfo] = useState(false)
    const [showGenerateSamples,setShowGenerateSamples] = useState(false)
    const [generateSamplesLoading,setGenerateSamplesLoading] = useState(false)
    const generateInterval = useRef(1000)
    const generateTimerId = useRef(null)
    
    const [deleteCheckCount,setDeleteCheckCount] = useState(0)
    const [selectMode,setSelectMode] = useState(false)
    const [generateZoom,setGenerateZoom] = useState(false)
    const [generateSettingShow,setGenerateSettingShow] = useState(false)
    useEffect(() => {
        let count = 0
        document.querySelectorAll(".delete-check").forEach(input => {
            if(input !== undefined && input.checked){
                count++
            }
        })
        // 一括選択されている場合
        setSelectMode(aiGenerateImageList.length == count && count > 0)
        console.log(aiGenerateImageList.length,count)
    },[deleteCheckCount])
    const keyEvent = (e) => {
        if(showGeneratedInfo && e.key === "Escape"){
            setShowGeneratedInfo(false)
        }
        if(e.key === "ArrowLeft"){
            if(aiGenerateImageList.length > 0 && generatedImageIndex > 0){
                setGeneratedInfo(aiGenerateImageList[generatedImageIndex-1])
                setGeneratedImageIndex(generatedImageIndex-1)
            }
        }
        if(e.key === "ArrowRight"){
            if(aiGenerateImageList.length > generatedImageIndex + 1){
                setGeneratedInfo(aiGenerateImageList[generatedImageIndex+1])
                setGeneratedImageIndex(generatedImageIndex+1)
            }
        }
    }
    document.onkeydown = keyEvent
    function isSmartPhone() {
        if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            return true;
        } else {
            return false;
        }
    }
    function statusCountUpdate(){
        getStatusCount().then(r =>{
            setServerStatus([])
            setserverWaitingProcId("")
            let aiProccessingButton = document.querySelectorAll(".ai-proccessing-button")
            let info = document.querySelectorAll(".ai-proccessing-info")
            if(!r.result){
                aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
            }
            if(r.data === undefined || r.data.status === undefined){
                return
            }
            if(r.data.status === 1 || r.data.status === 2){
                setAiProccessing(() => true)
                // 1の時のみキャンセル可能とする
                if(r.data.status === 2){
                    aiProccessingButton.forEach(e => e.setAttribute("disabled",true))
                }
            }
            setTraining(r.data.trainStatus !== 0)
            if(r.data.status === 1){
                info.forEach(e => e.innerText = " " + r.data.count + "枚が待機中です。予想残:"+r.data.time+"分")
                procId = r.data.procId
                setserverWaitingProcId(procId)
                setTimer()
            } else if(r.data.status === 2) {
                info.forEach(e => e.innerText = "予想残:"+r.data.time+"分")
                procId = r.data.procId
                setGenerateProgress(r.data.progress)
                setTimer()
            } else if(r.data.status === 0){
                info.forEach(e => e.innerText = "")
                setGenerateProgress(0)
                // 1または2のレコードがなく、現在処理中のproc_idがある場合はその後のステータスを取得する
                if(procId !== ""){
                    clearAllInterval()
                    clearTimeout(generateTimerId.current)
                    generateTimerId.current = false
                    getStatus(procId).then(r => {
                        if(r.data.status === 3) {
                            setGenerateProgress(100)
                            info.forEach(e => e.innerText = " 生成完了")
                            //let imageFile = base64ToFile(r.data.base64img.replace(/^.*,/, ''),procId + ".png","image/png")
                            setSrcGroupId(r.data.src_group_id)
                            setSrcDetailId(r.data.src_detail_id)
                            setSrcTitle(r.data.src_title)
                            setSrcFavorite(r.data.src_favorite)
                            //setReceivedImageFile(imageFile)
                            clearAllInterval()
                            clearTimeout(generateTimerId.current)
                            generateTimerId.current = false
                            setAiProccessing(false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                            /*ImageUtil.load(undefined,imageFile,0,(data1,data2,base64) => {
                                setGenerateProgress(0)
                                setShowGeneratedPanel(true)
                                setGeneratedInfo(r.data)
                                setGeneratedImageFile(imageFile)
                                setGeneratedImage(data1)
                                setGeneratedImageBase64(base64)
                                aiProccessingCall()
                            })*/
                            setGenerateProgress(0)
                            if(isSmartPhone()){
                                setShowGeneratedPanel(true)
                                setGeneratedInfo(r.data)
                            }
                            //aiProccessingCall()
                            setTimer()

                            // 生成履歴再取得
                            setAIGenerateReset(!aiGenerateReset)
                            setAIGenerateImagePage(1)
                        } else if(r.data.status === 4) {
                            let mes = ""
                            if(r.data.api_status != 0){
                                if(r.data.api_status == 1){
                                    mes = " 処理失敗:プロンプトが拒否されました。"
                                }
                                if(r.data.api_status == 2){
                                    // mes = " 処理失敗:システムに生成結果の画像の内容がブロックされました。ブロックが多い場合は生成機能が利用できなくなります。"
                                    mes = " 処理失敗:システムに生成結果の画像の内容がブロックされました。"
                                }
                                if(r.data.api_status == 400){
                                    mes = " 処理失敗：リクエスト無効"
                                }
                                if(r.data.api_status == 402){
                                    mes = " 処理失敗：予算不足のため実行されませんでした。"
                                }
                                if(r.data.api_status == 403){
                                    mes = " 処理失敗：プロンプトが拒否されました。"
                                }
                                if(r.data.api_status == 429){
                                    // 10秒間に150を超える場合
                                    mes = " 処理失敗：リクエストが多すぎるため拒否されました。"
                                }
                                if(r.data.api_status == 500){
                                    mes = " 処理失敗：連携先のシステムでエラーが発生しました。"
                                }
                            } else {
                                mes = " 処理失敗"
                            }
                            dialog("",mes)
                            info.forEach(e => e.innerHTML = mes)

                            clearAllInterval()
                            clearTimeout(generateTimerId.current)
                            generateTimerId.current = false
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        } else if(r.data.status === 5) {
                            info.forEach(e => e.innerText = " 処理中断")
                            clearAllInterval()
                            clearTimeout(generateTimerId.current)
                            generateTimerId.current = false
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        } else if(r.data.status === 6) {
                            if(loginInfo.age18 === 1){
                                let mes = " 生成結果がブロックされました。ブロックが多い場合は生成機能が利用できなくなります。SMS認証でブロック基準が緩和されます。" + (loginInfo.age18 === 1 && loginInfo.r18_display_flag === 1 ? "また、NSFWやR18の生成は<a href='/generate_unlimit'>コイン決済</a>をご利用ください。" : "")
                                //dialog("",<>生成結果がブロックされました。ブロックが多い場合は生成機能が利用できなくなります。SMS認証でブロック基準が緩和されます。 {(loginInfo.age18 === 1 && loginInfo.r18_display_flag === 1 ? <>また、NSFWやR18の生成は<a href='/generate_unlimit'>コイン決済</a>をご利用ください。</> : "")}</>)
                                dialog("",<>生成結果がブロックされました。SMS認証でブロック基準が緩和されます。 {(loginInfo.age18 === 1 && loginInfo.r18_display_flag === 1 ? <>また、NSFWやR18の生成は<a href='/generate_unlimit'>年齢認証等</a>を行ってください。</> : "")}</>)
                                info.forEach(e => e.innerHTML = mes)
                            } else {
                                //let mes = " 生成結果がブロックされました。ブロックが多い場合は生成機能が利用できなくなります。"
                                let mes = " 生成結果がブロックされました。"
                                dialog("",mes)
                                info.forEach(e => e.innerText = mes)
                            }
                            clearAllInterval()
                            clearTimeout(generateTimerId.current)
                            generateTimerId.current = false
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        } else if(r.data.status === 7) {
                            if(loginInfo.age18 === 1){
                                //let mes = " 生成結果がブロックされました。児童ポルノに該当する可能性のある画像は生成できません。ブロックが多い場合は生成機能が利用できなくなります。"
                                let mes = " 生成結果がブロックされました。児童ポルノに該当する可能性のある画像は生成できません。"
                                dialog("",mes)
                                info.forEach(e => e.innerHTML = mes)
                            }
                            clearAllInterval()
                            clearTimeout(generateTimerId.current)
                            generateTimerId.current = false
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        }
                        if(r.data.status === 4 || r.data.status === 5){
                            getPoint().then(r => {
                                if(r.result){
                                    setPoint(r.point)
                                }
                            })
                        }
                        //aiProccessingCall()
                    })
                } else {
                    setTimer()
                }
                setServerStatus(r.data)
                setBefore2SDTestCount(r.data.servers.before24SD)
                setBefore24SDAllCount(r.data.servers.before24SDAll)
                setBefore24DALLE3Count(r.data.servers.before24DALLE3)
                setBefore24SD3Count(r.data.servers.before24SD3)
            }
            setServerWaitingStatus(r.data.status)
            serverWaitingCount.current = r.data.count
            setBenerateBookingCount(r.data.servers.booking)
            if(!generateTimerId.current){
                setTimer()
            }
        })
    }
    function setTimer(){
        let interval = 3000
        if(serverWaitingCount.current === 0){
            interval = 3000
        } else if(serverWaitingCount.current > 0){
            interval = (serverWaitingCount.current - 1) * 20000 + 3000
        }
        generateInterval.current = interval
        //console.log("インターバル：",generateInterval.current)
        //console.log("count：",serverWaitingCount.current)
        generateTimerId.current = setTimeout(() =>{
            statusCountUpdate()
        },generateInterval.current)
    }
    function getMaxBookingCount(){
        switch(loginInfo.plan){
            case undefined:
            case "":
                return 1
            case "basic":
                return 5
            case "certification":
                return 50
            case "unlimited":
            case "plus":
                return 50
        }
    }
    function base64ToFile(base64,filename,mime){
        let bin = atob(base64.replace(/^.*,/, ''));
        let buffer = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
        }
        return new File([buffer.buffer], filename, {type: mime});
    }
    function download(blob){
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a")
        document.body.appendChild(a)
        a.download = 'foo.pdf'
        a.href = url
        a.click()
    }
    function aiProccessingCall(){
        let aiProccessingButton = document.querySelectorAll(".ai-proccessing-button")
        getPoint().then(r => {
            if(r.result){
                setPoint(r.point)
                aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
            } else {
                dialog("エラー",r.errors)
                aiProccessingButton.forEach(e => e.setAttribute("disabled",false))
            }
        })
        getStatusCount().then(r =>{
            statusCountUpdate()
            if(r.result){
                /*generateTimerId.current = setTimeout(() =>{
                    statusCountUpdate()
                },generateInterval.current)*/
            } else {
                setAiProccessing(() => false)
                aiProccessingButton.forEach(e => e.setAttribute("disabled",false))
            }
        })
    }
    function clearAllInterval(){
        for (var i = 1; i < 99999; i++)
            window.clearInterval(i)
    }
    function setCanvas(file){
        let data = file.useMosaic === "1" ? file.imageDataEdited : file.imageDataOriginal
        let canvas = document.createElement("canvas")
        canvas.id = "canvas"
        let ctx = canvas.getContext("2d")

        let img = document.createElement("img")
        img.src = data
        img.onload = () => {
            let w = 0
            let h = 0
            if(img.naturalWidth > img.naturalHeight){
                w = window.innerWidth
                h = img.naturalHeight * (window.innerWidth / img.naturalWidth)
            } else {
                w = img.naturalWidth * ((window.innerHeight - 110) / img.naturalHeight)
                h = window.innerHeight - 110
            }
            w = img.naturalWidth
            h = img.naturalHeight
            canvas.width = w
            canvas.height = h
            //canvas.style.border = "5px solid #FFFFFF"
            canvas.style.zIndex = "5"
            canvas.style.margin = "0"
            canvas.style.padding = "0"
            canvas.onmouseup = (e) => canvasMouseUp(e)
            canvas.onmousedown = (e) => canvasMouseDown(e)
            canvas.onmousemove = (e) => canvasMouseMove(e)

            ctx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,w,h)
            document.getElementById("canvas-area").textContent = ""
            document.getElementById("canvas-area").append(canvas)

            if(file.useMosaic === "1"){
                let originalImage = document.createElement("img")
                originalImage.src = file.imageDataOriginal
                originalImage.onload = () => {
                    setOriginalImage(originalImage)
                }
            } else {
                setOriginalImage(img)
            }
            // モザイクサイズの最小値を長辺の1/10にする
            let mosaicStrength = parseInt(getMosaicStrength())
            let minMosaicStrength = parseInt((w > h ? w : h) / 100)
            if(mosaicStrength < minMosaicStrength){
                mosaicStrength = minMosaicStrength
                setMosaicStrength(mosaicStrength)
            }
            setMinMosaicStrength(minMosaicStrength)
            setMosaicImage()
        }
        return true
    }
    function setMosaicImage(){
        let originalImage = getOriginalImage()
        let ctx = originalImage.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        mosaicCanvas.width = originalImage.width
        mosaicCanvas.height = originalImage.height
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let imgData = ctx.getImageData(0, 0, originalImage.width, originalImage.height)
        if (imgData !== "") {
            if(getMosaicStyle() === "dot"){
                let mosaicSize = parseInt(getMosaicStrength(), 10)
                for (let y = 0; y < imgData.height; y+=mosaicSize) {
                    for (let x = 0; x < imgData.width; x+=mosaicSize) {
                        let cR = imgData.data[(y * imgData.width + x) * 4]
                        let cG = imgData.data[(y * imgData.width + x) * 4 + 1]
                        let cB = imgData.data[(y * imgData.width + x) * 4 + 2]
                        mosaicCtx.fillStyle = "rgb("+cR+","+cG+","+cB+")"
                        mosaicCtx.fillRect(x,y,x + mosaicSize,y + mosaicSize)
                    }
                }
            } else if(getMosaicStyle() === "blur"){
                let tempImg = document.createElement("canvas")
                tempImg.width = originalImage.width
                tempImg.height = originalImage.height
                let imageData = ctx.getImageData(0,0,originalImage.width,originalImage.height)
                let tempCtx = tempImg.getContext("2d")
                tempCtx.putImageData(imageData,0,0)

                mosaicCtx.filter = "blur(" + getMosaicStrength() + "px)"
                mosaicCtx.drawImage(tempImg,0,0)
            }
        }
    }
    function mosaicCanvas(){
        setImageEditFlag(1)
        let drawCanvas = document.getElementById("canvas")
        let ctx = drawCanvas.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let mosaicImgData = mosaicCtx.getImageData(0, 0, drawCanvas.width, drawCanvas.height)
        ctx.putImageData(mosaicImgData,0, 0)
    }
    function getMosaicImage() {
        return document.getElementById("mosaic-image")
    }
    let mousePress = false
    function canvasMouseUp(e) {
        mousePress = false
    }
    function canvasMouseDown(e) {
        mousePress = true
        canvasMouseMove(e)
    }
    function setDrawFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.selectdrawflag = flag
    }
    function getDrawFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.selectdrawflag
    }
    function setOriginalImage(img){
        let original = document.getElementById("original-image")
        original.width = img.naturalWidth
        original.height = img.naturalHeight
        let originalCtx = original.getContext("2d")
        // console.log(img.naturalWidth,img.naturalHeight)
        originalCtx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,img.naturalWidth,img.naturalHeight)
    }
    function getOriginalImage(){
        return document.getElementById("original-image")
    }
    function setMosaicSize(size){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicsize = size
    }
    function getMosaicSize(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicsize
    }
    function setMosaicStrength(strength){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstrength = strength
        document.querySelector("#mosaic-strength").value = strength
    }
    function getMosaicStrength(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstrength
    }
    function setMosaicStyle(style){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstyle = style
    }
    function getMosaicStyle(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstyle
    }
    function canvasMouseMove(e) {
        if(!mousePress) return
        let drawFlag = getDrawFlag()
        let mosaicSize = getMosaicSize()
        // 描画モード
        if(drawFlag === "1"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            // console.log(e.pageY,client.top,client.y,window.scrollY)
            let x = e.pageX - client.x - window.scrollX - mosaicSize / 2
            let y = e.pageY - client.y - window.scrollY - mosaicSize / 2

            let mosaicImageCtx = getMosaicImage().getContext("2d")
            let ctx = e.currentTarget.getContext("2d")

            let imageData = mosaicImageCtx.getImageData(x,y,mosaicSize,mosaicSize)
            ctx.putImageData(imageData,x,y)
        }
        // 消しゴムモード
        if(drawFlag === "2"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            let x = e.pageX - client.x - mosaicSize / 2
            let y = e.pageY - client.y - mosaicSize / 1

            let ctx = e.currentTarget.getContext("2d")
            ctx.drawImage(getOriginalImage(),x,y,mosaicSize,mosaicSize,x,y,mosaicSize,mosaicSize)
        }
    }
    function resetCanvas() {
        setImageEditFlag(0)
        let canvas = document.getElementById("canvas")
        let ctx = canvas.getContext("2d")
        let img = document.createElement("img")
        img.src = fileList[editImageTargetNo].imageDataOriginal
        img.onload = () => {
            ctx.drawImage(img,0,0)
        }
    }
    // 変更内容を保存
    function saveEdit() {
        fileList[editImageTargetNo].useMosaic = getImageEditFlag()
        fileList[editImageTargetNo].imageDataEdited = document.getElementById("canvas").toDataURL("image/png")
        setFileList(fileList.concat())
        setInsideThumbnail()
        setOutsideThumbnail()
        setSelectedImageFilename()
        setEditImageTargetNo(-1)
    }
    // 保存せず閉じる
    function closeEdit() {
        setEditImageTargetNo(-1)
    }
    function setImageEditFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.imageeditflag = flag
    }
    function getImageEditFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.imageeditflag
    }
    let costList = [
        {width:"512",height:"512",cost:5,stepsPer:1,stepsLimit:150,coinCost:10},
        {width:"768",height:"768",cost:10,stepsPer:2,stepsLimit:150,coinCost:14},
        {width:"1152",height:"1152",cost:35,stepsPer:7,stepsLimit:150,coinCost:20},
        {width:"1536",height:"1536",cost:70,stepsPer:21,stepsLimit:150,coinCost:56},

        {width:"384",height:"768",cost:7,stepsPer:1,stepsLimit:150,coinCost:10},
        {width:"512",height:"768",cost:7,stepsPer:1,stepsLimit:150,coinCost:12},
        {width:"768",height:"1152",cost:15,stepsPer:5,stepsLimit:150,coinCost:17},
        {width:"768",height:"1536",cost:25,stepsPer:7,stepsLimit:150,coinCost:25},
        {width:"1024",height:"1536",cost:30,stepsPer:10,stepsLimit:150,coinCost:30},

        {width:"768",height:"384",cost:7,stepsPer:1,stepsLimit:150,coinCost:10},
        {width:"768",height:"512",cost:7,stepsPer:1,stepsLimit:150,coinCost:12},
        {width:"1152",height:"768",cost:15,stepsPer:5,stepsLimit:150,coinCost:17},
        {width:"1536",height:"768",cost:25,stepsPer:7,stepsLimit:150,coinCost:25},
        {width:"1536",height:"1024",cost:30,stepsPer:10,stepsLimit:150,coinCost:30},

        {width: "480",height: "270",cost: 15,stepsPer: 5,coinCost: 8},
        {width: "960",height: "540",cost: 15,stepsPer: 5,coinCost: 15},
        {width:"1280",height:"720",cost:15,stepsPer:5,stepsLimit:150,coinCost:17},
        {width:"1600",height:"900",cost:30,stepsPer:10,stepsLimit:150,coinCost:25},
        {width:"1920",height:"1080",cost:45,stepsPer:15,stepsLimit:150,coinCost:40},

        {width:"270",height:"480",cost:15,stepsPer:5,coinCost:8},
        {width:"540",height:"960",cost:15,stepsPer:5,coinCost:15},
        {width:"720",height:"1280",cost:15,stepsPer:5,stepsLimit:150,coinCost:17},
        {width:"900",height:"1600",cost:30,stepsPer:10,stepsLimit:150,coinCost:25},
        {width:"1080",height:"1920",cost:45,stepsPer:15,stepsLimit:150,coinCost:40},

        {width:"1024",height:"1024",cost:30,stepsPer:7,stepsLimit:150,coinCost:20},
        {width:"2048",height:"2048",cost:120,stepsPer:28,stepsLimit:150,coinCost:80},
        {width:"896",height:"1152",cost:28,stepsPer:7,stepsLimit:150,coinCost:20},
        {width:"1792",height:"2304",cost:112,stepsPer:28,stepsLimit:150,coinCost:80},
        {width:"1152",height:"896",cost:28,stepsPer:7,stepsLimit:150,coinCost:20},
        {width:"2304",height:"1792",cost:112,stepsPer:28,stepsLimit:150,coinCost:80},
        {width:"640",height:"1280",cost:20,stepsPer:6,stepsLimit:150,coinCost:20},
        {width:"1280",height:"2560",cost:80,stepsPer:24,stepsLimit:150,coinCost:80},
        {width:"1280",height:"640",cost:20,stepsPer:6,stepsLimit:150,coinCost:20},
        {width:"2560",height:"1280",cost:80,stepsPer:24,stepsLimit:150,coinCost:80},
    ]
    const preset = [
        {"SD1.5":
            [
                {label:"縦長"},
                {width:"768",height:"1152",label:"",isFree:true,hires:true},
                {width:"1024",height:"1536",label:"",isFree:true,hires:true},
                {width:"512",height:"768",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"正方形"},
                {width:"768",height:"768",label:"",isFree:true,hires:false},
                {width:"1152",height:"1152",label:"",isFree:true,hires:true},
                {width:"1536",height:"1536",label:"",isFree:true,hires:true},
                {width:"512",height:"512",label:"低解像度検証向き",isFree:true,hires:false},,
                {label:"縦長 1:2"},
                {width:"768",height:"1536",label:"",isFree:true,hires:true},
                {width:"384",height:"768",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"横長"},
                {width:"1152",height:"768",label:"",isFree:true,hires:true},
                {width:"1536",height:"1024",label:"",isFree:true,hires:true},
                {width:"768",height:"512",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"横長 2:1"},
                {width:"1536",height:"768",label:"",isFree:true,hires:true},
                {width:"768",height:"384",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"横長 16:9"},
                {width:"960",height:"540",label:"",isFree:true,hires:true},
                {width:"1280",height:"720",label:"",isFree:true,hires:true},
                {width:"1600",height:"900",label:"",isFree:true,hires:true},
                {width:"1920",height:"1080",label:"",isFree:true,hires:true},
                {width:"480",height:"270",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"縦長 9:16"},
                {width:"540",height:"960",label:"",isFree:true,hires:true},
                {width:"720",height:"1280",label:"",isFree:true,hires:true},
                {width:"900",height:"1600",label:"",isFree:true,hires:true},
                {width:"1080",height:"1920",label:"",isFree:true,hires:true},
                {width:"270",height:"480",label:"低解像度検証向き",isFree:true,hires:false},
            ]
        },
        {"SD3":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},

            {label:"縦長 2:3"},
            {width:"832",height:"1216",label:"",isFree:false,hires:false},

            {label:"縦長 9:16"},
            {width:"768",height:"1344",label:"",isFree:false,hires:false},

            {label:"縦長 9:21"},
            {width:"640",height:"1536",label:"",isFree:false,hires:false},

            {label:"横長 3:2"},
            {width:"1216",height:"832",label:"",isFree:false,hires:false},

            {label:"横長 16:9"},
            {width:"1344",height:"768",label:"",isFree:false,hires:false},

            {label:"横長 21:9"},
            {width:"1536",height:"640",label:"",isFree:false,hires:false},

        ]},
        {"SD3.5":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},

            {label:"縦長 2:3"},
            {width:"832",height:"1216",label:"",isFree:false,hires:false},

            {label:"縦長 9:16"},
            {width:"768",height:"1344",label:"",isFree:false,hires:false},

            {label:"縦長 9:21"},
            {width:"640",height:"1536",label:"",isFree:false,hires:false},

            {label:"横長 3:2"},
            {width:"1216",height:"832",label:"",isFree:false,hires:false},

            {label:"横長 16:9"},
            {width:"1344",height:"768",label:"",isFree:false,hires:false},

            {label:"横長 21:9"},
            {width:"1536",height:"640",label:"",isFree:false,hires:false},

        ]},
        {"SDXL":[
            {label:"縦長"},
            {width:"896",height:"1152",label:"",isFree:true,hires:false},
            {width:"1792",height:"2304",label:"高解像度",isFree:true,hires:true},
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:true,hires:false},
            {width:"2048",height:"2048",label:"高解像度",isFree:true,hires:true},
            {label:"縦長 1:2"},
            {width:"640",height:"1280",label:"",isFree:true,hires:false},
            {width:"1280",height:"2560",label:"高解像度",isFree:true,hires:true},
            {label:"横長"},
            {width:"1152",height:"896",label:"",isFree:true,hires:false},
            {width:"2304",height:"1792",label:"高解像度",isFree:true,hires:true},
            {label:"横長 2:1"},
            {width:"1280",height:"640",label:"",isFree:true,hires:false},
            {width:"2560",height:"1280",label:"高解像度",isFree:true,hires:true},
        ]},
        {"DALL-E3":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},
        ]},
        {"GPT-Image-1":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},
        ]},
        {"VertexAI":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},

            {label:"縦長 3:4"},
            {width:"896",height:"1280",label:"",isFree:false,hires:false},

            {label:"縦長 9:16"},
            {width:"768",height:"1408",label:"",isFree:false,hires:false},

            {label:"横長 4:3"},
            {width:"1280",height:"896",label:"",isFree:false,hires:false},

            {label:"横長 16:9"},
            {width:"1408",height:"768",label:"",isFree:false,hires:false},
        ]},
        {"FLUX.1":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},

            {label:"縦長 2:3"},
            {width:"832",height:"1216",label:"",isFree:false,hires:false},

            {label:"縦長 9:16"},
            {width:"768",height:"1344",label:"",isFree:false,hires:false},

            {label:"縦長 9:21"},
            {width:"640",height:"1536",label:"",isFree:false,hires:false},

            {label:"横長 3:2"},
            {width:"1216",height:"832",label:"",isFree:false,hires:false},

            {label:"横長 16:9"},
            {width:"1344",height:"768",label:"",isFree:false,hires:false},

            {label:"横長 21:9"},
            {width:"1536",height:"640",label:"",isFree:false,hires:false},
        ]},
        {"Mid":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},
        ]},
        {"NovelAI-Diffusion":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},
            {label:"縦長"},
            {width:"832",height:"1216",label:"",isFree:false,hires:false},
            {label:"横長長"},
            {width:"1216",height:"832",label:"",isFree:false,hires:false},
        ]}
    ]
    const freeList = [
        {width:"384",height:"768"},
        {width:"768",height:"384"},
        {width:"512",height:"512"},
        {width:"512",height:"768"},
        {width:"768",height:"512"},
        {width:"768",height:"768"},
        {width:"1024",height:"1024"},
        {width:"1152",height:"1152"},
        {width:"1536",height:"1536"},
        {width:"896",height:"1152"},
        {width:"768",height:"1152"},
        {width:"768",height:"1536"},
        {width:"1024",height:"1536"},
        {width:"1152",height:"768"},
        {width:"1152",height:"896"},
        {width:"1536",height:"768"},
        {width:"1536",height:"1024"},
        {width:"480",height:"270"},
        {width:"960",height:"540"},
        {width:"1280",height:"640"},
        {width:"1280",height:"720"},
        {width:"1600",height:"900"},
        {width:"1920",height:"1080"},
        {width:"270",height:"480"},
        {width:"540",height:"960"},
        {width:"640",height:"1280"},
        {width:"720",height:"1280"},
        {width:"900",height:"1600"},
        {width:"1080",height:"1920"},
    ]
    const testList = [
        {width:"384",height:"768"},
        {width:"768",height:"384"},
        {width:"512",height:"512"},
        {width:"512",height:"768"},
        {width:"768",height:"512"},
        {width:"480",height:"270"},
        {width:"270",height:"480"},
    ]
    const withoutHires = [
        {"width":"512","height":"512"},
        {"width":"512","height":"768"},
        {"width":"768","height":"512"},
        {"width":"384","height":"768"},
        {"width":"768","height":"384"},
        {"width":"480","height":"270"},
        {"width":"270","height":"480"}
    ];
    const SDXLHires = [
        {"width":"2048","height":"2048"},
        {"width":"1792","height":"2304"},
        {"width":"1280","height":"2560"},
        {"width":"2304","height":"1792"},
        {"width":"2560","height":"1280"}
    ];
    const [hires,setHires] = useState(false)
    function calcCost() {
        let resolution = sdResolution.split("x")
        let sampler = sdSampler
        let steps = document.getElementById("sd-steps")
        let jpCost = document.getElementById("sd-jp-prompt").value.length
        let width = 512
        let height = 512
        let hires = true
        if(resolution.length === 2){
            // txt2img
            if(generateTabKey === "txt2img" || img2ImgFile === undefined && inpaintFile === undefined){
                resolution = sdResolution.split("x")
                width = resolution[0]
                height = resolution[1]
                if(modelType === "SDXL"){
                    hires = SDXLHires.find(d => d.width === width && d.height === height) !== undefined
                } else {
                    hires = withoutHires.find(d => d.width === width && d.height === height) === undefined
                }
            } else if(img2ImgFile !== undefined || inpaintFile !== undefined){
                // img2img
                resolution = sdResolution.split("x")
                width = resolution[0]
                height = resolution[1]
                hires = false
            }
            //setSdResolution(width + "x" + height)
        } else {
            width = resolution[0]
            height = resolution[1]
            hires = true
        }
        setHires(hires)

        // コスト計算
        let cost = 0
        let coinCost = 0
        let per = 1
        for(let i = 0;i < costList.length;i++){
            if(width === costList[i].width && height === costList[i].height){
                cost = costList[i].cost
                per = costList[i].stepsPer
                coinCost = costList[i].coinCost
            }
        }
        if(steps.value > 10){
            cost += Math.floor(steps.value * per * 0.3) + parseInt(steps.value) - 10
        }
        if(steps.value > 30){
            coinCost += steps.value - 30
        }
        const longTimeSamplers = ["DPM++ SDE","DPM++ SDE Karras","DPM++ 2S a","DPM++ 2S a Karras","DPM2 Karras","DPM2 a Karras","Restart"];
        if(longTimeSamplers.find(d => d === sampler) !== undefined){
            cost += Math.floor(steps.value * per)
            coinCost *= 2
        }
        if(hires){
            cost *= 2.5
            cost = Math.floor(cost)
        }
        if(generateTabKey !== "txt2img" && (img2ImgFile !== undefined || inpaintFile !== undefined)){
            cost *= 1.2
            cost = Math.floor(cost)
        }
        let currentCost = cost
        let currentCoinCost = coinCost
        if(enterJpPrompt){
            currentCost = cost+jpCost
            currentCoinCost = coinCost+Math.floor(jpCost/5)
            setPointCost(cost+jpCost)
            setCoinCost(currentCoinCost)
        } else {
            currentCost = cost
            currentCoinCost = coinCost
            setPointCost(cost)
            setCoinCost(coinCost)
        }
        // slowモード
        if(paymentMethod === "point"){
            if(sdStyle === "slow"){
                for(let i = 0;i < freeList.length;i++){
                    if(width === freeList[i].width && height === freeList[i].height){
                        if(enterJpPrompt && ((loginInfo.plan !== "unlimited" && loginInfo.plan !== "plus") || isFullMode)){
                            currentCost = jpCost
                            setPointCost(jpCost)
                        } else {
                            currentCost = 0
                            setPointCost(0)
                        }
                        break;
                    }
                }
            } else {
                if((sdStyle !== "gpt-image-1" && sdStyle !== "imagen-3.0" && sdStyle !== "imagen-4.0" && sdStyle !== "dall-e-3" && sdStyle !== "nai-diffusion-3" && !isFastMode) && loginInfo.plan == "certification" && before2SDTestCount < 100 && steps.value <= 30){
                    for(let i = 0;i < testList.length;i++){
                        if(width === testList[i].width && height === testList[i].height){
                            if(enterJpPrompt){
                                currentCost = jpCost
                                setPointCost(jpCost)
                            } else {
                                currentCost = 0
                                setPointCost(0)
                            }
                            break;
                        }
                    }
                }
            }
        }
        // freelistは無制限キャンペーン中のみ
        if(paymentMethod === "point"){
            if(freePeriodInfo.enabled === 1){
                for(let i = 0;i < freeList.length;i++){
                    if(width === freeList[i].width && height === freeList[i].height){
                        if(enterJpPrompt && ((loginInfo.plan !== "unlimited" && loginInfo.plan !== "plus") || isFastMode)){
                            currentCost = jpCost
                            setPointCost(jpCost)
                        } else {
                            currentCost = 0
                            setPointCost(0)
                        }
                        break;
                    }
                }
            }
        }
        // stepsが30以下かつ解像度が1536x1536、1920x1080、1080x1920以外の場合でプレミアムプランユーザーなら消費ポイント0
        if(!isFullMode){
            if(loginInfo.plan === "certification"){
                if(before24SDAllCount < 100 && steps.value <= 30 && !(width == 1536 && height == 1536)
                    && !(width == 1920 && height == 1080)
                    && !(width == 1080 && height == 1920)
                    && !(hires && modelType === "SDXL")){
                    currentCost = 0
                    setPointCost(0)
                }
            } else if(loginInfo.plan === "unlimited"){
                if(before24SDAllCount < 400 && steps.value <= 30 && !(width == 1536 && height == 1536)
                    && !(width == 1920 && height == 1080)
                    && !(width == 1080 && height == 1920)
                    && !(hires && modelType === "SDXL")){
                    currentCost = 0
                    setPointCost(0)
                }
            } else if(loginInfo.plan === "plus"){
                if(steps.value <= 50){
                    currentCost = 0
                    setPointCost(0)
                }
            }
        }
        if(sdStyle === "dall-e-3" || sdStyle === "gpt-image-1" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || sdStyle === "sd3-large" || sdStyle === "sd3-large-turbo" || sdStyle === "sd3.5-large" || sdStyle === "sd3.5-large-turbo"
            || sdStyle === "flux-schnell" || sdStyle === "ultra"
            || sdStyle === "mid-journey" || sdStyle === "niji-journey"){
            if(!isFullMode && (sdStyle !== "gpt-image-1" && sdStyle !== "imagen-3.0" && sdStyle !== "imagen-4.0" && (loginInfo.plan === "unlimited" || loginInfo.plan === "plus"))){
                if(enterJpPrompt){
                    currentCost = jpCost
                    setPointCost(jpCost)
                } else {
                    currentCost = 0
                    setPointCost(0)
                }
            } else {
                let baseCost = 3000
                if(sdStyle === "ultra" || sdStyle === "sd3-large" || sdStyle === "sd3-large-turbo" || sdStyle === "sd3.5-large" || sdStyle === "sd3.5-large-turbo"){
                    baseCost = 6000
                }
                if(sdStyle === "flux-schnell"){
                    baseCost = 500
                }
                if(sdStyle === "mid-journey" || sdStyle === "niji-journey"){
                    baseCost = 400
                }
                if(enterJpPrompt){
                    currentCost = baseCost+jpCost
                    setPointCost(baseCost+jpCost)
                } else {
                    currentCost = baseCost
                    setPointCost(baseCost)
                }
            }
            // コイン
            let baseCoinCost = 50
            if(sdStyle === "gpt-image-1"){
                baseCoinCost = 50
            }
            if(sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "sd3-large-turbo" || sdStyle === "sd3.5-large-turbo"){
                baseCoinCost = 40
            }
            if(sdStyle === "flux-schnell"){
                baseCoinCost = 20
            }
            if(sdStyle === "mid-journey" || sdStyle === "niji-journey"){
                baseCoinCost = 30
            }
            if(enterJpPrompt){
                currentCoinCost = baseCoinCost+Math.floor(jpCost/5)
                setCoinCost(currentCoinCost)
            } else {
                currentCoinCost = baseCoinCost
                setCoinCost(baseCoinCost)
            }
        }
        if(sdImagesCount === "4"){
            currentCost *= 4
            currentCoinCost *= 4
            setPointCost(currentCost)
            setCoinCost(currentCoinCost)
        }
        if(modelType === "SDXL"){
            currentCost *= 2
            setPointCost(currentCost)
        }
        if(isScaleUpx2){
            currentCost *= 4
            currentCoinCost *= 4
            setPointCost(currentCost)
            setCoinCost(currentCoinCost)
        }
        if(useControlnet){
            currentCost *= 2
            setPointCost(currentCost)
        }
        if(modelIdentifiedName === "ourt_AI_Diffusion_XL_Anime_V1" && modelType === "SDXL" && steps.value <= 30){
            //currentCost = 0
            //setPointCost(currentCost)
        }
        if(freePeriodInfo.enabled === 0 && enterEnhancePrompt){
            currentCost += 300
            setPointCost(currentCost)
        }
    }

    useEffect(() => {
        calcCost()
    },[sdStyle,sdImagesCount,sdResolution,sdSampler,sdSteps,jpCost,enterJpPrompt,enterEnhancePrompt,img2ImgFile,inpaintFile,inpaintMask,generateTabKey,modelType,modelIdentifiedName,isFullMode,isFastMode,isScaleUpx2,useControlnet])

    function calcUpscaleCost(){
        if(selectedImageWidth > 0 && selectedImageHeight > 0){
            let max = 10240 * 10240;
            let point = Math.ceil((Math.floor(selectedImageWidth * scaleBy) * Math.floor(selectedImageHeight * scaleBy)) / max * 100000);
            let coin = Math.ceil((Math.floor(selectedImageWidth * scaleBy) * Math.floor(selectedImageHeight * scaleBy)) / max * 500);
            //console.log(point,selectedImageWidth,selectedImageHeight,Math.floor(selectedImageWidth * scaleBy),Math.floor(selectedImageHeight * scaleBy))
            if(loginInfo.plan === "plus"){
                setUpscalePointCost(Math.ceil(point * 0.1))
            } else if(loginInfo.plan === "unlimited"){
                setUpscalePointCost(Math.ceil(point * 0.5))
            } else if(loginInfo.plan === "certification"){
                setUpscalePointCost(Math.ceil(point * 0.9))
            } else {
                setUpscalePointCost(point)
            }
            setUpscaleCoinCost(coin)
        } else {
            setUpscalePointCost(0)
        }
    }

    useEffect(() => {
        calcUpscaleCost()
    },[scaleBy,selectedImageWidth,selectedImageHeight,img2ImgFile,loginInfo])

    useEffect(() => {
        if(sdResolution !== undefined){
            let spl = sdResolution.split("x")
            setSdWidth(parseInt(spl[0]))
            setSdHeight(parseInt(spl[1]))
        }
    },[sdResolution])

    const modelListold = 
    
    {
        // fast 0:無効 1:LCM 2:TensorRT 3:LCM+TensorRT 4:DPM++ 2M Turbo,steps:8,scale:5 5:LCM Lora
        "AgelesnateV2":{"name":"AgelesnateV2","description":"","type":"SD1","fast":"0"},
        "animagineXLV3_v30":{"name":"Animagine XL V3","description":"SD1系モデルに比べ、より繊細な表現ができます。","type":"SDXL","fast":"0"},
        "asyncsMIX_v6":{"name":"Async's MIX v6","description":"繊細な表現ができます。","type":"SD1","fast":"0"},
        "swampmachine_v20":{"name":"SwampMachine v2.0","description":"SD1系モデルに比べ、より繊細な表現ができます。","type":"SDXL","fast":"0"},
        "blue_pencil_v10":{"name":"blue pencil v10","description":"","type":"SD1","fast":"0"},
        "blue_pencil_EX":{"name":"blue pencil EX","description":"","type":"SD1","fast":"0"},
        "bluePencilXL_v310":{"name":"bluePencil-XL v3.1.0","description":"SD1系モデルに比べ、より繊細な表現ができます。","type":"SDXL","fast":"0"},
        "majicmixFantasy_v20":{"name":"majicMIX fantasy 麦橘幻想 v2.0","description":"","type":"SD1","fast":"0"},
        "majicmixHorror_v1":{"name":"majicMIX horror 麦橘恐怖 v1","description":"","type":"SD1","fast":"0"},
        "majicmixRealistic_v6":{"name":"majicMIX realistic 麦橘写实 v6","description":"","type":"SD1","fast":"0"},
        "majicmixRealistic_v7":{"name":"majicMIX realistic 麦橘写实 v7","description":"","type":"SD1","fast":"0"},
        "majicmixAlpha_v1":{"name":"majicMIX alpha 麦橘男团 v1.0","description":"","type":"SD1","fast":"0"},
        "milktea_mild_V1":{"name":"milktea mild V1","description":"","type":"SD1","fast":"0"},
        "milkteaV2":{"name":"milkteaV2","description":"","type":"SD1","fast":"0"},
        "Rabbit_v1.3":{"name":"Rabbit v1.3","description":"","type":"SD1","fast":"0"},
        "blazingDrive_V09i":{"name":"blazingDrive_V09i","description":"","type":"SD1","fast":"0"},
        "FiaMix_Reboot_V2":{"name":"FiaMix_Reboot_V2","description":"老若男女問わないキャラクターの生成向き","type":"SD1","fast":"0"},
        "endlessMixRenatusV2":{"name":"endlessMixRenatusV2","description":"『realistic』『cuteやkawaii』などのスタイル変更プロンプトを加えることで、2D～2.8Dぐらいまで幅広く出力可能。 by 作者","type":"SD1","fast":"0"},
        "darkSushiMixMix_225D":{"name":"Dark Sushi Mix 大颗寿司Mix 2.25D","description":"","type":"SD1","fast":"0"},
        "coquett_v1":{"name":"Coquett v1.0","description":"キュートなジト目が特徴的なモデルです。","type":"SD1","fast":"0"},
        "LycheeMix":{"name":"LycheeMix","description":"","type":"SD1","fast":"0"},
        "hotarubreedTypeASemi_v1a":{"name":"HotaruBreed Type A (semi realistic 2.5D style)","description":"若干リアル寄りな2.5D系","type":"SD1","fast":"0"},
        "hotarubreedTypeBGeneral_v1a":{"name":"HotaruBreed Type B (general purpose 2D style)","description":"標準的2Dイラスト向け","type":"SD1","fast":"0"},
        "hotarubreedTypeCSemi_v1a":{"name":"HotaruBreed Type C (semi anime style)","description":"ややアニメ塗り","type":"SD1","fast":"0"},
        "hotarubreedTypeDModern_v1a":{"name":"HotaruBreed Type D (modern anime style)","description":"アニメ塗り","type":"SD1","fast":"0"},
        "hotarubreedTypeEClassic_v1a":{"name":"HotaruBreed Type E (classic anime style)","description":"セル画風の強いアニメ塗り","type":"SD1","fast":"0"},
        "torafurrymix_v2":{"name":"ToraFurryMix v2.0","description":"このモデルは「furry」タグの使用を念頭に置いてチューニングされました。","type":"SD1","fast":"0"},
        "flat2DAnimerge_v4":{"name":"Flat-2D Animerge","description":"漫画的なアニメスタイル","type":"SD1","fast":"0"},
        "ourt_AI_Diffusion_Anime_V4":{"name":"ourt AI Diffusion (Anime V4)","description":"公式イラスト系モデル","type":"SD1","fast":"1"},
        "ourt_AI_Diffusion_Anime_V4_niji_style_Beta":{"name":"ourt AI Diffusion (Anime V4 niji-style Beta 20231203)","description":"公式イラスト系モデル。niji-styleのベータ版","type":"SD1","fast":"0"},
        "ourt_AI_Diffusion_Anime_V5":{"name":"ourt AI Diffusion (Anime V5)","description":"公式イラスト系モデル","type":"SD1","fast":"0"},
        "ourt_AI_Diffusion_Anime_V6":{"name":"ourt AI Diffusion (Anime V6)","description":"公式イラスト系モデル","type":"SD1","fast":"0"},
        "ourt_AI_Diffusion_Pastel":{"name":"ourt_AI_Diffusion_Pastel","description":"公式パステル調モデル","type":"SD1","fast":"0"},
        "dall-e-3":{"name":"DALL-E3","description":<>様々な種類の画像が生成できるモデルです。コストの都合上、生成に失敗した場合でもポイントは戻りません。
        <br /><Link onClick={() => planDialog(dialog)}>プレミアムプランユーザーはDALL-E3が直近30日あたり50回までポイント消費0(翻訳分以外)で利用可能です！</Link></>,"type":"DALL-E3","fast":"0"},
        "nai-diffusion-3":{"name":"NAI Diffusion Anime V3","description":<>NovelAI社の最先端のモデルで、アニメ系に強く表現力も高いです。コストの都合上、生成に失敗した場合でもポイントは戻りません。</>,"type":"NovelAI-Diffusion","fast":"0"},
        "slow":{"name":"slowモード","description":<>モデルは時間帯によりランダムで、翻訳以外のポイント消費がありません。全年齢対象以外は生成できません。センシティブフィルター：強</>,"type":"SDXL","fast":"0"},
    }
    const [oldModelType,setOldModelType] = useState(localStorage.getItem("model_type"))
    useEffect(() => {
        if(loginInfo.plan === "" && loginInfo.sms_auth === 0 && sdStyle !== "slow"){
            /*dialog("",<>現在SMS認証不要のslowモードを使用中です。<br />
            slowモード以外を利用する場合、スタンダードプラン、プレミアムプランに加入するかSMS認証を行う必要があります。<br /><Button variant='warning' onClick={() => planDialog(dialog)}>プラン詳細</Button></>)
            setSdStyle("slow")
            return*/
        }
        if(modelList.length > 0 && modelList.find(d => d.i_name === sdStyle) !== undefined){
            let model = modelList.find(d => d.i_name === sdStyle)
            setModelImage(model.sample ? model.sample : "/img/"+model.img)
            setModelName(model.upload_status === 1 ? model.model_name + " " + model.name : model.name)
            setModelIdentifiedName(model.i_name)
            setModelDescription(model.description)
            let type = model.model_type
            setModelType(type)
            let options = preset.find((d) => d[type])
            setModelOptions(options[type])
            let opt = options[type][1]
            if(oldModelType !== type){
                setSdResolution(opt.width+"x"+opt.height)
            }
            if(type !== "SDXL"){
                setUseControlnet(false)
            }
            setFastModeVer(model.lcm)
            if(model.lcm === 0){
                setIsFastMode(false)
            }
            setModelFullModeEnable(model.full)
            if(model.full === 0){
                setIsFullMode(false)
            }
            setRecommendPrompt(model.prompt)
            localStorage.removeItem("model_type")
            localStorage.setItem("model_type",type)
            setOldModelType(type)
            // モデルがSD系以外の場合はチェック外す
            if(sdStyle === "dall-e-3"){
                setIsScaleUpx2(false)
            }
        }
        if(sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0"){
            setSdResolution("1024x1024")
            setSdImagesCount("1")
        } else if(sdStyle === "nai-diffusion-3"){
            setSdResolution("832x1216")
            setSdImagesCount("1")
        } else if(sdStyle === "mid-journey" || sdStyle === "niji-journey"){
            setSdImagesCount("4")
        } else if(sdStyle === "Illustrious-XL-v0.1"){
            setSdScale(7)
            setSdSampler("Euler a")
            document.getElementById("sd-negative-prompt").value = "worst quality,bad quality,bad hands,very displeasing,extra digit,fewer digits,jpeg artifacts,signature,username,reference,mutated,lineup,manga,comic,disembodied,futanari,yaoi,dickgirl,turnaround,2koma,4koma,monster,cropped,amputee,text,bad foreshortening,what,guro,logo,bad anatomy,bad perspective,bad proportions,artistic error,anatomical nonsense,amateur,out of frame,multiple views,"
        } else {
            //setSdResolution("768x1152")
            if(sdStyle === "AgelesnateV2" || sdStyle === "agelesnate_v3"){
                setSdSampler("Euler a")
            } else {
                //setSdSampler("DPM++ 2M Karras")
            }
            if(isFastMode && fastModeVer === 4){
                setSdSampler("Euler A Turbo")
            }
        }
        /*if(modelList[sdStyle]["type"] === "SDXL"){
            if(loginInfo.certified_creator !== 1){
                if(loginInfo.plan === ""){
                    //dialog(modelList[sdStyle]["name"],<>このモデルはサブスクリプションに登録するか公認クリエイターの場合使用できます。<br /><LinkContainer to={"/legal"}><MuiButton variant='outlined'>詳細</MuiButton></LinkContainer></>)
                }
            }
        }*/
    },[sdStyle,modelList])

    useEffect(() => {
        if(isFastMode){
            if(fastModeVer === 4){
                setSdSampler("Euler A Turbo")
                setSdSteps(14)
                setSdScale(5)
            } else if(fastModeVer === 1){
                setSdSampler("Euler a")
                setSdSteps(6)
                setSdScale(2)
            } else {
                setSdSampler("Euler a")
            }
        } else {
            //setSdSampler("DPM++ 2M Karras")
            //setSdSteps(20)
            //setSdScale(7)
        }
    },[isFastMode])

    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-style");localStorage.setItem("sd-style",sdStyle)
        if(sdStyle === "imagen-3.0") setEnterJpPrompt(true)
    },[sdStyle])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("model-id");localStorage.setItem("model-id",modelId)
    },[modelId])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-resolution");localStorage.setItem("sd-resolution",sdResolution)
    },[sdResolution])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-sampler");localStorage.setItem("sd-sampler",sdSampler)
    },[sdSampler])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-fast");localStorage.setItem("sd-fast",isFastMode)
    },[isFastMode])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-upscaler");localStorage.setItem("sd-upscaler",sdUpscaler)
    },[sdUpscaler])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-steps");localStorage.setItem("sd-steps",sdSteps)
    },[sdSteps])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-scale");localStorage.setItem("sd-scale",sdScale)
    },[sdScale])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-denoising-strength");localStorage.setItem("sd-denoising-strength",sdDenoisingStrength)
    },[sdDenoisingStrength])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-seed");localStorage.setItem("sd-seed",sdSeed)
    },[sdSeed])
    useEffect(() => {
        if(srcMode) return
        localStorage.removeItem("sd-quality-tags");localStorage.setItem("sd-quality-tags",qualityTags)
    },[qualityTags])

    const [dragElm,setDragElm] = useState()
    // noと距離x,y
    const [len,setLen] = useState([-1,0,0])
    // 範囲内に存在する
    const [inRange,setInRange] = useState(false)
    // 選択中のno
    const [selectingNo,setSelectingNo] = useState(0)
    function dragStart(e,i){
        //console.log("dragStart",e)
        setDragElm("imgDrag"+i)
        //let img = document.querySelector("#imgDrag"+i)
        //console.log(img)
        if(e.type !== "touchstart"){
            let img = document.getElementById("dummy")
            e.dataTransfer.setDragImage(img,75, 75)
        }
        //e.dataTransfer.effectAllowed = "none"
    }
    // DPM Adaptiveは永遠に終わらなかった
    //let samplers = [{"name":"Euler a","aliases":["k_euler_a","k_euler_ancestral"],"options":{}},{"name":"Euler","aliases":["k_euler"],"options":{}},{"name":"LMS","aliases":["k_lms"],"options":{}},{"name":"Heun","aliases":["k_heun"],"options":{}},{"name":"DPM2","aliases":["k_dpm_2"],"options":{"discard_next_to_last_sigma":"True"}},{"name":"DPM2 a","aliases":["k_dpm_2_a"],"options":{"discard_next_to_last_sigma":"True"}},{"name":"DPM++ 2S a","aliases":["k_dpmpp_2s_a"],"options":{}},{"name":"DPM++ 2M","aliases":["k_dpmpp_2m"],"options":{}},{"name":"DPM++ SDE","aliases":["k_dpmpp_sde"],"options":{}},{"name":"DPM fast","aliases":["k_dpm_fast"],"options":{}},{"name":"DPM adaptive","aliases":["k_dpm_ad"],"options":{}},{"name":"LMS Karras","aliases":["k_lms_ka"],"options":{"scheduler":"karras"}},{"name":"DPM2 Karras","aliases":["k_dpm_2_ka"],"options":{"scheduler":"karras","discard_next_to_last_sigma":"True"}},{"name":"DPM2 a Karras","aliases":["k_dpm_2_a_ka"],"options":{"scheduler":"karras","discard_next_to_last_sigma":"True"}},{"name":"DPM++ 2S a Karras","aliases":["k_dpmpp_2s_a_ka"],"options":{"scheduler":"karras"}},{"name":"DPM++ 2M Karras","aliases":["k_dpmpp_2m_ka"],"options":{"scheduler":"karras"}},{"name":"DPM++ SDE Karras","aliases":["k_dpmpp_sde_ka"],"options":{"scheduler":"karras"}},{"name":"DDIM","aliases":[],"options":{}},{"name":"PLMS","aliases":[],"options":{}}]
    let samplers = [{"name":"Euler a","memo":"やわらかい表現"},
    {"name":"DPM++ 2M Karras","memo":""},
    {"name":"DPM++ SDE Karras","memo":"生成時間が長い"},

    {"name":"DPM++ 2M SDE Karras","memo":""},
    {"name":"DPM++ 2M SDE Exponential","memo":"stepsは25以上推奨"},
    {"name":"DPM++ 2M","memo":""},
    {"name":"DPM++ SDE","memo":"生成時間が長い"},
    {"name":"DPM++ 2M SDE Heun Karras","memo":"stepsは25以上推奨"},
    {"name":"DPM++ 2M SDE Heun Exponential","memo":""},
    {"name":"DPM++ 3M SDE","memo":"stepsは30以上推奨"},
    {"name":"DPM++ 3M SDE Karras","memo":"stepsは30以上推奨"},
    {"name":"DPM++ 3M SDE Exponential","memo":"stepsは30以上推奨"},
    {"name":"DPM++ 2S a","memo":"生成時間が長い"},
    {"name":"DPM++ 2S a Karras","memo":"生成時間が長い"},
    {"name":"DPM2 Karras","memo":"生成時間が長い"},
    {"name":"DPM2 a Karras","memo":"生成時間が長い、stepsは30以上推奨"},
    {"name":"Restart","memo":"生成時間が長い"},

    {"name":"DDIM","memo":""},{"name":"PLMS","memo":"stepsは35以上を推奨。色が強くでる"},{"name":"UniPC","memo":""},
    {"name":"Euler A Turbo","memo":""},
    {"name":"DPM++ 2M Turbo","memo":""},
    {"name":"DPM++ 2M SDE Turbo","memo":""}]
    let upscalers = [{"name":"Latent","memo":"やわらかい表現"},{"name":"Latent (nearest-exact)","memo":""},
        {"name":"Lanczos","memo":""},{"name":"R-ESRGAN 4x+ Anime6B","memo":"崩壊しにくい"}]
    function textareaSizing(labelElementId,elementId){
        let labelElement = document.querySelector(labelElementId)
        labelElement.style.lineHeight = "20px"
        let lineHeight = labelElement.style.lineHeight.replace(/[^0-9.]+/,'')
        let n = labelElement.value.match(/\n/g)
        if(n === null){
            n = 1
        } else {
            n = n.length + 1
        }
        if(n <= 5){
            n = 5
        }
        labelElement.style.height = lineHeight * n + 30 + "px"
        document.querySelector(elementId).style.height = lineHeight * n + 30 + "px"
    }

    // キャンバスのリサイズ
    const [canvasAreaHeight,setCanvasAreaHeight] = useState(window.innerHeight - 100)
    window.onresize = function () {
        setCanvasAreaHeight(window.innerHeight - 100)
    }
    const [showI2ICropper,setShowI2ICropper] = useState()
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCropper,setShowCropper] = useState()
    const [cropTarget,setCropTarget] = useState()
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
            let image = document.getElementById("load-image")
            let canvas = document.createElement("canvas")
            let ctx = canvas.getContext("2d")
            canvas.width = image.width
            canvas.height = image.height

            ctx.drawImage(image,0,0)

            const data = ctx.getImageData(croppedAreaPixels.x,croppedAreaPixels.y,croppedAreaPixels.width,croppedAreaPixels.height)

            canvas.width = croppedAreaPixels.width
            canvas.height = croppedAreaPixels.height

            ctx.putImageData(data,0,0)

            let thumb = canvas.toDataURL("image/png")

            setTempThumbnail(thumb)
      }, [])
    const [showQuestionnairePopup,setShowQuestionnairePopup] = useState(false)
    const [questionInfo,setQuestionInfo] = useState()
    document.onpaste = function(pasteEvent) {
        let item = pasteEvent.clipboardData.items[0];
     
        if (item.type.indexOf("image") === 0){
            let file = item.getAsFile();
            if(fileList.length === 0){
                imageSet([file])
            } else {
                imageAdd([file])
            }
        }
    }
    // シリーズ
    const [seriesList,setSeriesList] = useState([])
    const [series,setSeries] = useState("")

    // キャラクター
    const [characterList,setCharacterList] = useState([])
    const [selectedCharacterList,setSelectedCharacterList] = useState([])

    function displayAIGenerateInfo(){
        dialog("AI生成機能の説明",<div>
            AI生成機能ではプロンプトという文字列を入力して、画像を生成することができます。<br />
            生成にはポイントを使用し、ポイントは、
            活動実績に伴い翌日の基準ポイントが判定され、保有ポイントがその基準以下の場合に基準まで回復します。<br />
            また、これ以外にも「いいね」やコメント、画像を投稿することでポイントが少し付与されます。<br /><br />
            <Link to={"/legal"}>スタンダードプラン、プレミアムプラン</Link>に加入している場合はSMS認証、World ID認証、ポイント不要でAI生成機能を利用できます。<br />

            不明点は<a href="https://discord.gg/vQNvaCXYvu">Discord</a>よりお問い合わせください。<br />
            <hr />
            ■ポイント回復基準<br />
            前日までの活動実績に伴い変動
            <br />
            ※条件は定期的に見直されます。<br />
            <hr />
            混雑時にはSMS認証またはworld ID認証が必須となる場合があります。SMS認証は「設定」→「セキュリティ」タグから行えます<br />
            <Link to={"/legal"}>サブスク</Link>に加入している場合はSMS認証不要でAI生成機能を利用できます。<br />
        </div>)
    }

    // AI生成機能の時間帯別利用件数
    const [userList,setUserList] = useState([])

    function createGraphData(r,title){
        const graphData = {
            labels: 
                // 軸ラベル
                // 各ラベルを配列にすることで軸ラベルが改行されて表示される
                r.map(d => [d.ymdh+"時"])
            ,
            datasets: [
                // 表示するデータセット
                {
                    data: r.map(d => d.count),
                    label: title
                },
            ],
        }
        return graphData
    }

    const [tagSelected,setTagSelected] = useState([])

    function upScaleHandler(){
        if(img2ImgFile === undefined){
            dialog("エラー","画像を選択してください。")
            return
        }
        if(selectedImageWidth === 0 || selectedImageHeight === 0){
            dialog("エラー","画像が読み込まれていません。")
            return
        }
        if(parseInt(selectedImageWidth*scaleBy) > 10240 || parseInt(selectedImageHeight*scaleBy) > 10240){
            dialog("エラー","拡大後の解像度が縦横ともに10,240px以内に収まるようにしてください。")
            return
        }
        clearAllInterval()
        statusCountUpdate(true)
        if(!generateTimerId.current){
            aiProccessingCall()
        }

        upScale(img2ImgFile,scaleTargetStyle,scaleBy)

        document.querySelectorAll(".ai-proccesing-button").forEach(e => e.setAttribute("disabled",true))
    }
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const [paymentMethod, setPaymentMethod] = useState("point")
    function generateHandler(e,booking,random){
        let jpPrompt = document.getElementById("sd-jp-prompt").value
        let prompt = document.getElementById("sd-prompt").value
        let negativePrompt = document.getElementById("sd-negative-prompt").value
        let steps = document.getElementById("sd-steps").value
        let seed = document.getElementById("sd-seed").value
        let aiResolution = sdResolution
        let res = aiResolution.split("x")
        let width = res[0]
        let height = res[1].replace(/h/,"")
        let hires = false // hires判定はサーバーでやる
        if(tagSelected.length === 0 && prompt.trim().length === 0 && !styleSelected.find(d => d.prompt.length > 0) && enterJpPrompt && jpPrompt.length === 0){
            dialog("エラー","プロンプトを入力してください。")
            return
        }
        for(let i = 0;i < costList.length;i++){
            if(costList[i].width === width && costList[i].height === height){
                if(parseInt(steps) > costList[i].stepsLimit){
                    dialog("エラー",aiResolution + "の場合、stepsは最大" + costList[i].stepsLimit + "までにしてください。")
                    return
                }
            }
        }
        if(seed.length > 19){
            dialog("エラー","seedは最大19桁までにしてください。")
            return  
        }
        
        if(sdSampler === "DDIM" || sdSampler === "PLMS"){
            if(prompt.indexOf("AND") !== -1 || negativePrompt.indexOf("AND") !== -1){
                dialog("エラー","SamplerがDDIM/PLMSの場合はAND構文がサポートされていません。")
                return
            }
        }
        // プロンプトを記憶
        localStorage.removeItem("prompt")
        localStorage.removeItem("negativePrompt")
        localStorage.setItem("prompt",prompt)
        localStorage.setItem("negativePrompt",negativePrompt)
        prompt = prompt.replace(/{/g,"(")
        prompt = prompt.replace(/}/g,")")
        negativePrompt = negativePrompt.replace(/{/g,"(")
        negativePrompt = negativePrompt.replace(/}/g,")")

        prompt += (prompt.slice(-1) === "," ? "" : ",") + styleSelected.map(d => d.prompt.length > 0 ? (d.prompt.slice(-1) === "," ? d.prompt : d.prompt + ",") : "")
        negativePrompt += (negativePrompt.slice(-1) === "," ? "" : ",") + styleSelected.map(d => d.negative_prompt.length > 0 ? (d.negative_prompt.slice(-1) === "," ? d.negative_prompt : d.negative_prompt + ",") : "")

        if(qualityTags){
            if(sdStyle !== "ourt_AI_Diffusion_Anime_V4_niji_style_Beta" && sdStyle !== "ourt_AI_Diffusion_Anime_V6_niji-style_20240331"){
                if(sdStyle !== "nai-diffusion-3"){
                    prompt = "((masterpiece, best quality, extremely detailed, absurdres))," + prompt
                } else {
                    prompt = prompt + ",best quality, amazing quality, very aesthetic, absurdres"
                }
            }
            if(sdStyle === "nai-diffusion-3"){
                negativePrompt = "nsfw, lowres, {bad}, error, fewer, extra, missing, worst quality, jpeg artifacts, bad quality, watermark, unfinished, displeasing, chromatic aberration, signature, extra digits, artistic error, username, scan, [abstract]" + negativePrompt
            } else {
                if(modelType === "SDXL"){
                    negativePrompt = "(worst quality, low quality), nsfw, " + negativePrompt // blue_pencil-v9b
                } else {
                    negativePrompt = "(worst quality, low quality:1.1), nsfw, " + negativePrompt // blue_pencil-v9b
                }
            }
            //negativePrompt = "EasyNegative, extra fingers,fewer fingers," + negativePrompt
            //negativePrompt = "nsfw, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username,inaccurate limb," + negativePrompt
            //negativePrompt = "(KHFB, AuroraNegative),(worst quality, low quality:1.4),(monochrome:1.1)," + negativePrompt // 7th_test
        }
        if(tagSelected.length > 0){
            prompt = tagSelected.map(d => d.value).join(", ") + ", " + prompt
        }
        clearAllInterval()
        clearTimeout(generateTimerId.current)
        generateTimerId.current = false
        statusCountUpdate(true)
        //aiProccessingCall()
        
        let styleP = styleSelected.map(d => d.prompt.length > 0 ? (d.prompt.slice(-1) === "," ? d.prompt : d.prompt + ",") : "")
        let styleNP = styleSelected.map(d => d.negative_prompt.length > 0 ? (d.negative_prompt.slice(-1) === "," ? d.negative_prompt : d.negative_prompt + ",") : "")
        if(random){
            prompt = ""
            negativePrompt = ""
            styleP = ""
            styleNP = ""
        }
        if(generateTabKey === "extra" && inpaintFile !== undefined && inpaintMask !== undefined){
            img2img(booking,random,sdImagesCount,sdStyle,isFullMode,isFastMode,isScaleUpx2,inpaintFile,inpaintMask,enterJpPrompt,enterEnhancePrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdUpscaler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height)
        } else if(generateTabKey === "txt2img" && useControlnet){
            txt2imgControlnet(booking,random,sdImagesCount,sdStyle,isFullMode,isFastMode,isScaleUpx2,img2ImgFile,undefined,enterJpPrompt,enterEnhancePrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdUpscaler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height)
        } else if(img2ImgFile === undefined){
            txt2img(booking,random,sdImagesCount,sdStyle,isFullMode,isFastMode,isScaleUpx2,enterJpPrompt,enterEnhancePrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdUpscaler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height,hires)
        } else if(img2ImgFile !== undefined && generateTabKey === "txt2img" && !useControlnet){
            img2img(booking,random,sdImagesCount,sdStyle,isFullMode,isFastMode,isScaleUpx2,img2ImgFile,undefined,enterJpPrompt,enterEnhancePrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdUpscaler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height)
        }
        document.querySelectorAll(".ai-proccesing-button").forEach(e => e.setAttribute("disabled",true))
    }
    function aiGenInitHandler(isCallHome){
        let aiGenCloseButton = document.querySelector("#aiGenCloseButton")
        if(loginInfo.result === false){
            dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
            return
        }
        if(loginInfo.sms_auth === 0 && !loginInfo.pre_auth){
            displayAIGenerateInfo()
        }
        // setUseAiGenerate(!useAiGenerate)
        calcCost()
        if(useAiGenerate){
            // スタイルを取得する
            getStyleList().then(r => {
                if(r.result){
                    setStyleOptions(r.data)
                }
            })
            if(!generateTimerId.current){
                aiProccessingCall()
            }
            setAIGenerateImagePage(1)
            aiGenCloseButton.innerText = t("upload.image.closeAIGenerationPanel")
            // プロンプトを復元する
            let jpPrompt = document.getElementById("sd-jp-prompt")
            let prompt = document.getElementById("sd-prompt")
            let negativePrompt = document.getElementById("sd-negative-prompt")
            let jpP = localStorage.getItem("jpPrompt")
            let p = localStorage.getItem("prompt")
            let np = localStorage.getItem("negativePrompt")
            if(jpPrompt.value.length === 0 && jpP !== null){
                jpPrompt.value = jpP
            }
            if(prompt.value.length === 0 && p !== null){
                prompt.value = p
            }
            if(!qualityTags && (np === null || np === "")){
                np = "(worst quality, bad quality, low quality:1.1),(extra fingers, deformed hands, polydactyl:1.1), (monochrome:1.1),"
            }
            if(negativePrompt.value.length === 0 && np !== null){
                negativePrompt.value = np
            }
            // プロンプトエリアの幅調整
            textareaSizing("#sd-jp-prompt",".sd-jp-prompt-textarea")
            textareaSizing("#sd-prompt",".sd-prompt-textarea")
            textareaSizing("#sd-negative-prompt",".sd-negative-prompt-textarea")
        } else {
            clearAllInterval()
            setAiProccessing(false)
            aiGenCloseButton.innerText = t("upload.image.AIGeneration")
        }
    }
    function inputCheck(){
        if(title.trim().length === 0){
            return false
        }
        if(styleOfPainting.length === 0 ){
            return false
        }
        if(ageLimit === ""){
            return false
        }
        // 全年齢の場合、性的表現について必須
        if(ageLimit === "1" || ageLimit === "2"){
            if(ageLimit === "1" && sexualExpression === ""){
                return false
            }
        } else {
            if(sexualExpression !== ""){
                return false
            }
        }
        return true
    }
    useEffect(() => {
        setUploadReady(inputCheck())
    },[title,styleOfPainting,ageLimit,sexualExpression])

    function uploadHandler(e){
        let title = document.getElementById("title")
        let description = document.getElementById("description")
        let deletePassword = document.getElementById("delete-password")
        let batch = document.getElementById("batch").checked
        if(!batch && title.value.trim().length === 0 ){
            dialog("エラー","タイトルを入力して下さい。")
            return false
        }
        if(styleOfPainting.length === 0 ){
            dialog("エラー","画風を選択してください。")
            return false
        }
        /*if(description.value.trim().length === 0){
            dialog("エラー","概要を入力して下さい。")
            return false
        }*/
        if(bookingDate !== "" && bookingTime === ""){
            dialog("確認","予約投稿を行う場合は時分も入力してください。")
            return false
        }
        if(bookingDate === "" && bookingTime !== ""){
            dialog("確認","予約投稿を行う場合は年月日も入力してください。")
            return false
        }
        if(ageLimit === ""){
            dialog("エラー","年齢制限を指定して下さい。")
            return false
        }
        // 全年齢の場合、性的表現について必須
        if(ageLimit === "1" || ageLimit === "2"){
            if(ageLimit === "1" && sexualExpression === ""){
                dialog("エラー","PG12区分ありなしを指定して下さい。")
                return false
            }
        } else {
            if(sexualExpression !== ""){
                dialog("エラー","性的表現の指定は不要です。")
                return false
            }
        }
        let aiModel = document.getElementById("ai-model")
        let prompt = document.getElementById("prompt")
        let negativePrompt = document.getElementById("negative-prompt")
        let request = document.getElementById("request")
        for(let i = 0;i < fileList.length;i++){
            if(fileList[i].software === "" || fileList[i].software === "no-select"){
                //dialog("エラー",<Container>全ての画像に使用したモデルを入力してください。</Container>)
                //return false
            }
        }
        if(prompt.value.trim().length > 50000){
            dialog("エラー","生成テキスト、プロンプトの上限は50,000文字です。")
            return false
        }
        if(negativePrompt.value.trim().length > 50000){
            dialog("エラー","ネガティブプロンプトの上限は50,000文字です。")
            return false
        }
        if(request.value.trim().length > 50000){
            dialog("エラー","機能追加要望等の上限は50,000文字です。")
            return false
        }
        if(loginInfo.length === 0){
            if(deletePassword.value.trim().length === 0 && loginInfo.length === 0){
                dialog("エラー","削除パスワードを入力して下さい。")
                return false
            }
        }
        // ファイルサイズチェック
        let fileSize = 0
        for(let i = 0;i < fileList.length;i++){
            fileSize += fileList[i].file.size
        }
        // 104857600 100MB
        // 262144000 200MB
        // 107374182400 100GB
        if(fileSize > 31457280000){
            dialog("エラー","ファイルサイズの合計は30GBです。")
            return
        }
        if(fileList.length === 0){
            dialog("エラー","ファイルを選択して下さい。")
            return false
        }
        // ファイル数チェック
        if(fileList.length > 300){
            dialog("エラー","一度にアップロードできるのは300ファイルまでです。")
            return false
        }
        if(insideThumbnail === undefined){
            dialog("エラー","サムネイルを設定してください。")
            return false
        }
        /*
        if(outsideThumbnail === undefined){
            dialog("エラー","外部サイト向けサムネイルを設定してください。")
            return false
        }*/
        if(questionInfo !== undefined){
            if((questionInfo.deadlineDate.length === 0 && questionInfo.deadlineTime.length > 0)
                || (questionInfo.deadlineDate.length > 0 && questionInfo.deadlineTime.length === 0)){
                dialog(t("common.error"),"投票を作成する場合は日付と時間を両方指定してください。")
                return false
            }
        }
        //isLoggin().then(r=>{
        //    if(r){
                uploadSelect(fileList)
        //    } else {
        //        dialog("エラー","投稿するにはログインしてください。")
                // トップへ戻る
                //document.getElementById("logo").click();
        //    }
        //})
    }
    const [showGeneratedCount,setShowGeneratedCount] = useState(false)
    const [showTaiki,setShowTaiki] = useState(false)
    const [showLora,setShowLora] = useState(false)
    const [showEmbeddings,setShowEmbeddings] = useState(false)
    const getDefaultStyleWeight = useCallback((lora) => {
        let prompt = document.querySelector("#sd-prompt")
        let loraId = ""
        let loraRefName = (lora.isUserLora ? lora.fileId : lora.name).replace(/-/g, "\-")
        if(lora.isUserLora){
            loraId = "lora-" + lora.fileId
        } else {
            loraId = lora.name
        }
        let match = prompt.value.match("<lora:"+loraRefName+":([0-9.-]+)>")
        let weight = 0
        if(match !== null && match.length > 1){
            weight = match[1]
        } else {
            let range = document.querySelector("#"+loraId+"-range")
            if(range){
                weight = range.value
            }
        }
        prompt.value = prompt.value.replace("><",">,<")
        return weight
    })
    let loraList = ["ear-tarenagamimi_01",
    "ear-tarenagamimi_02",
    "emo-smile_01",
    "eye-allsclera",
    "eye-close_c",
    "eye-grgr_01",
    "eye-grgr_02",
    "eye-hanme_01",
    "eye-hanme_02",
    "eye-hanme_03",
    "eye-hanme_04",
    "eye-hanme_c_01",
    "eye-hanme_c_02",
    "eye-iris_width",
    "eye-kuma_01",
    "eye-kuma_02",
    "eye-lookleft_01",
    "eye-lookleft_02",
    "eye-lookright_01",
    "eye-lookright_02",
    "eye-lookup",
    "eye-nolight",
    "eye-nolight_02",
    "eye-nolight_03",
    "eye-pos_h",
    "eye-pos_v",
    "eye-shihaku",
    "eye-shiitake",
    "eye-turime",
    "hair-bangsstyle_01-16",
    "hair-bangsstyle_02-16",
    "hair-bangsstyle_03-16",
    "hair-bangsstyle_04-16",
    "hair-bangsstyle_05-16",
    "hair-bangsstyle_06-16",
    "hair-bangsstyle_07-16",
    "hair-bangsstyle_08-16",
    "line_softline",
    "mouth-open_h_01",
    "mouth-open_h_02",
    "nose-dot",
    "nuri-hadanuri_01",
    "nuri-hadanuri_02",
    "nuri-sanDka_01",
    "nuri-sanDka_02",
    "nuri-yawanuri",
    "style-dorodoro_01",
    "style-dorodoro_02",
    "dtl-illust2real",
    "body-necklength",
    "DynLighting",
    "BlurConditioner_A1823"]
    let convertedLoraList = loraList.map(name => {
        return {
            user_id: "",
            user_name: "",
            name: name,
            description: "",
            isUserLora: false,
            modelType: "SD1.5",
            modelId: "",
            versionId: "",
            fileId: "",
            sample: ""
        };
    });

    const [allLoraList,setAllLoraList] = useState([])
    const [loraFilter, setLoraFilter] = useState("")

    useEffect(() => {
        if(showLora){
            new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/loraList").then(r => r.json()).then(r => {
                if(r.result){
                    const converted = r.data.map(lora => {
                        return {
                            user_id: lora.user_id,
                            user_name: lora.user_name,
                            name: lora.name + " " + lora.ver,
                            description: lora.description,
                            isUserLora: true,
                            modelType: lora.model_type,
                            modelId: lora.model_id,
                            versionId: lora.id,
                            fileId: lora.file.replace(/\.safetensors/,""),
                            sample: lora.sample
                        };
                    });
                    setAllLoraList(convertedLoraList.concat(converted));
                    console.log("Lora List:", convertedLoraList.concat(converted));
                } else {
                    dialog("エラー",r.message)
                }
            })
        }
    },[showLora])

    // allLoRaListが更新されたとき、使用中のloraをリスト化する
    const [usedLoraList,setUsedLoraList] = useState([])
    useEffect(() => {
        if(allLoraList.length > 0){
            let used = allLoraList.filter(lora => {
                let prompt = document.querySelector("#sd-prompt")
                let loraId = ""
                let loraRefName = (lora.isUserLora ? lora.fileId : lora.name).replace(/-/g, "\-")
                if(lora.isUserLora){
                    loraId = "lora-" + lora.fileId
                } else {
                    loraId = lora.name
                }
                let match = prompt.value.match("<lora:"+loraRefName+":([0-9.-]+)>")
                return match !== null && match.length > 1 && parseFloat(match[1]) > 0
            })
            setUsedLoraList(used)
            console.log("Used LoRa List:", used);
        }
    },[showLora,allLoraList])

    const textualInversion = ["SimpleNegative","SimpleNegative2"]
    let convertedTextualInversionList = textualInversion.map(name => {
        return {
            user_id: "",
            user_name: "",
            name: name,
            description: "",
            isUserTextualInversion: false,
            modelType: "SD1.5",
            modelId: "",
            versionId: "",
            fileId: "",
            sample: ""
        };
    });
    const [allTextualInversionList,setAllTextualInversionList] = useState([])
    useEffect(() => {
        if(showEmbeddings){
            new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/textualInversionList").then(r => r.json()).then(r => {
                if(r.result){
                    const converted = r.data.map(ti => {
                        return {
                            user_id: ti.user_id,
                            user_name: ti.user_name,
                            name: ti.name + " " + ti.ver,
                            description: ti.description,
                            isUserTextualInversion: true,
                            modelType: ti.model_type,
                            modelId: ti.model_id,
                            versionId: ti.id,
                            fileId: ti.file.replace(/\.pt/,"").replace(/\.safetensors/,"").replace(/\.ckpt/,""),
                            sample: ti.sample
                        };
                    });
                    setAllTextualInversionList(convertedTextualInversionList.concat(converted));
                    console.log("Textual Inversion List:", convertedTextualInversionList.concat(converted));
                } else {
                    dialog("エラー",r.message)
                }
            })
        }
    },[showEmbeddings])

    function moveTo(name){
        let title = document.querySelector(name)
        let rect = title.getBoundingClientRect()
        window.scrollTo({top:window.scrollY+rect.top-100,left:0,behavior:"instant"})
    }
    const [uploadReady,setUploadReady] = useState(false)

    // モザイク強度最小値
    const [minMosaicStrength,setMinMosaicStrength] = useState(0)

    const [showModels,setShowModels] = useState(false)
    const [showModelRecommendedSettings,setShowModelRecommendedSettings] = useState(false)
    const [recommendPrompt,setRecommendPrompt] = useState("")

    const [selectedGenerateImageList,setSelectedGenerateImageList] = useState([])
    const [addFiles,setAddFiles] = useState(false)

    async function addFile(){

    }
    useEffect(() => {
        if(addFiles){
           //addFile()
        }
    },[addFiles])

    const [tipsImageNo,setTipsImageNo] = useState(1)
    const [isAd,setIsAd] = useState()
    const [adTitle,setAdTitle] = useState()
    const [adText,setAdText] = useState()
    const [adElement,setAdElement] = useState()

    const tipsList = [{"isAd":false,"title":"ドット絵の様な画像を生成するには","text":"プロンプトに「pixel art」を入力","element":""},
        {"isAd":false,"title":"水彩画の様な画像を生成するには","text":"プロンプトに「aquarelle」を入力","element":""},
        {"isAd":false,"title":"アニメのスクリーンショットの様な画像を生成するには","text":"「(anime:1.4)」を入力","element":<Image src='/img/tips/anime.webp' width={"100%"} />},
        {"isAd":true,"title":"身分証提出による認証マーク","text":<>公認クリエイターになって口座設定を行った場合、身分証提出による認証マークが付与されます。<Icon.ShieldFillCheck style={{display:"inline",color:"#E2B719",marginLeft:"10px"}} /></>,"element":""},
        {"isAd":false,"title":"画質を上げるには","text":"解像度を上げてみよう。","element":<Image src='/img/tips/scale.webp' width={"100%"} />},
    ]

    useEffect(() =>{
        if(aiProccessing){
            let lists = [tipsList]
            if(loginInfo.plan === ""){
                lists.push(adList.concat(adInfo.map(d => {
                    return {"isAd":true,"title":"","text":"","element":<><Link to={d.url} target='_blank'><Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/ad/"+d.user_id+"/"+d.img_id+".webp"} /></Link></>}
                })))
            }
            let list = arrayShuffle(lists)[0]

            const ad = arrayShuffle(list)[0]
            setTipsImageNo(Math.floor(Math.random() * 4 + 1))
            setIsAd(ad.isAd)
            setAdTitle(ad.title)
            setAdText(ad.text)
            setAdElement(ad.element)
        }
    },[aiProccessing])

    function isFastSampler(name,fastModeVer){
        if(fastModeVer === 4){
            return name.startsWith("Euler A Turbo") || name.startsWith("DPM++ 2M Turbo") || name.startsWith("DPM++ 2M SDE Turbo")
        } else {
            return name.startsWith("Euler a") || name.startsWith("DPM++ 2S a Karras")
        }
    }

    useEffect(() => {
        if(img2ImgFile === undefined){
            setSelectedImageWidth(0)
            setSelectedImageHeight(0)
        }
    },[img2ImgFile])
    return (
    <>
    <Dialog show={aiGenTerms.length > 0} title={"利用規約への同意"} message={
        <>
        <Container className='mb-3'>生成機能を利用するには利用規約への同意が必要です。</Container>
        <Container className='w-100 mb-3' dangerouslySetInnerHTML={{__html: aiGenTerms}} />
        <Container className='text-center'>
            <Button className='m-3' onClick={() => {
                termsAgree()
                setAIGenTerms("")
            }}>同意する</Button>
            <Button className='m-3' onClick={() => setAIGenTerms("")}>同意しない</Button>
        </Container>
        </>
    } />
    <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="img2img-file" onChange={(e) => {
        ImageUtil.load(undefined,e.currentTarget.files[0],0,(data1,data2,base64) => {
            Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = data1)
            setImg2ImgFile(base64)
            if(generateTabKey !== "extra"){
                setShowI2ICropper(true)
            }
            let img = document.createElement("img")
            img.onload = () => {
                setSelectedImageWidth(img.naturalWidth)
                setSelectedImageHeight(img.naturalHeight)
                console.log("読込後",img.naturalWidth,img.naturalHeight)
                img.remove()
            }
            img.src = base64
        })
        e.currentTarget.value = ""
    }} />
    <CropButton show={showI2ICropper} setShowCropper={setShowI2ICropper} aspect={sdWidth / sdHeight} onChange={(img) => {
        setImg2ImgFile(img)
        let elm = document.createElement("img")
        elm.onload = () => {
            setSelectedImageWidth(elm.naturalWidth)
            setSelectedImageHeight(elm.naturalHeight)
            console.log("クロップ後",elm.naturalWidth,elm.naturalHeight)
            elm.remove()
        }
        elm.src = img
        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = img)
    }}
    onCancel={() => {
        document.getElementById("img2img-file").value = ""
        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = "")
        setImg2ImgFile()
    }}
    src={img2ImgFile} />
    {showGeneratedPanel ? (
    <Dialog show={showGeneratedPanel} handleClose={() => setShowGeneratedPanel(false)} message={
        <>
        <Container className='text-center'>
            <MuiButton variant='outlined' className='m-1 p-1' onClick={() => setShowGeneratedPanel(false)}>{t("common.close")}</MuiButton>
            <Button variant='warning' className="m-1 p-1 ai-proccessing-button"
            onClick={(e) => {
                if(serverWaitingStatus === 1){
                    generateCancelHandler(serverWaitingProcId)
                } else {
                    generateHandler(e,false)
                    setShowGeneratedPanel(false)
                }
            }}>
            {aiProccessing ? <><Spinner animation="border" size="sm" />&nbsp;{jpPromptTranslating ? t("common.translating") : (
                serverWaitingStatus === 1 ? t("upload.image.cancel") : t("upload.image.generating")
            )}</> : t("upload.image.generate")}&nbsp;{paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} />&nbsp;{pointCost.toLocaleString()}</> : <>{Constants.CURRENCY_UNIT_LEFT_COIN}&nbsp;{coinCost.toLocaleString()}</>}
            {aiProccessing && generateProgress > 0 && (<><br /><ProgressBar className="ai-generate-progress" animated now={generateProgress} max={95} /></>)}
            </Button>
            <Button className='m-1 p-1'
            onClick={(e) => {
                e.stopPropagation()
                getAIGeneraleImageFile(generatedInfo.proc_id).then(r => {
                    if(r.result){
                        if(fileList.length === 0){
                            let imgs = r.data.img.map(img => {
                                return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                            })
                            imageSet(imgs,true,r.data)
                        } else {
                            let imgs = r.data.img.map(img => {
                                return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                            })
                            imageAdd(imgs,true,r.data)
                        }
                        dialog(t("common.info"),"投稿画面の画像一覧に追加しました。左上の「閉じる」から投稿画面に移動できます。また、投稿画面の「生成履歴から選択」ボタンからも選択できます。")
                        setShowGeneratedInfo(false)
                    }
                })
            }}
            >
                <Icon.PlusCircleFill style={{fontSize:"24px",color:"#EEEEEE",cursor:"pointer"}} onClick={(e) => {
                    e.stopPropagation()
                    getAIGeneraleImageFile(generatedInfo.proc_id).then(r => {
                        if(r.result){
                            if(fileList.length === 0){
                                let imgs = r.data.img.map(img => {
                                    return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                                })
                                imageSet(imgs,true,r.data)
                            } else {
                                let imgs = r.data.img.map(img => {
                                    return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                                })
                                imageAdd(imgs,true,r.data)
                            }
                            dialog(t("common.info"),"投稿画面の画像一覧に追加しました。左上の「閉じる」から投稿画面に移動できます。また、投稿画面の「生成履歴から選択」ボタンからも選択できます。")
                            setShowGeneratedInfo(false)
                        }
                    })
                }} />
                &nbsp;投稿
            </Button>
            <Button className="m-1 p-1 d-none" onClick={() => {
                navigator.clipboard.writeText(generatedInfo.seed)
                alert("seed値をクリップボードにコピーしました。")
            }}>{generatedInfo.seed}</Button>
            <Button className='m-1 p-1' onClick={() => {
                createShareId(generatedInfo.proc_id).then(r => {
                    if(r.result){
                        navigator.clipboard.writeText("https://ourt-ai.work/upload/image/generate?sid="+r.data.share_id)
                        dialog(t("common.info"),"共有リンクをクリップボードにコピーしました。")
                    } else {
                        dialog(t("common.error"),r.errors)
                    }
                    setShowGeneratedPanel(false)
                })
            }}><Icon.Share /></Button>
            <Button className="m-1 p-1" onClick={() => {
                deleteAIGeneraleImageFile([generatedInfo.proc_id]).then(r => {
                    if(r.result){
                        setAIGenerateReset(!aiGenerateReset)
                        setAIGenerateImagePage(1)
                        setShowGeneratedPanel(false)
                    } else {
                        dialog(t("common.error"),r.errors)
                    }
                })
            }}><Icon.Trash /></Button>
            <br /><br />
            {[...Array(generatedInfo.count)].map((d,i) => {
                return <Image
                style={{cursor:"pointer",width:generatedInfo.count === 1 ? "100%" : "50%"}}
                onClick={(e) => {
                    //setPreviewSource(ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+generatedInfo.mode+'/'+(generatedInfo.proc_id)+extNo+"_eco.webp")
                    setPreviewSource(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+generatedInfo.proc_id+"/1/"+i)
                    setPreviewFlg(true)
                }}
                src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+generatedInfo.proc_id+"/1/"+i} />
            })}
            <br /><br />
            <MuiButton variant='outlined' className="m-1 p-1" onClick={() => setShowGeneratedPanel(false)}>{t("common.close")}</MuiButton>
            <Button variant='warning' className="m-1 p-1 ai-proccessing-button"
            onClick={(e) => {
                if(serverWaitingStatus === 1){
                    generateCancelHandler(serverWaitingProcId)
                } else {
                    generateHandler(e,false)
                    setShowGeneratedPanel(false)
                }
            }}>
            {aiProccessing ? <><Spinner animation="border" size="sm" />&nbsp;{jpPromptTranslating ? t("common.translating") : (
                serverWaitingStatus === 1 ? t("upload.image.cancel") : t("upload.image.generating")
            )}</> : t("upload.image.generate")}&nbsp;{paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} />&nbsp;{pointCost.toLocaleString()}</> : <>{Constants.CURRENCY_UNIT_LEFT_COIN}&nbsp;{coinCost.toLocaleString()}</>}
            {aiProccessing && generateProgress > 0 && (<><br /><ProgressBar className="ai-generate-progress" animated now={generateProgress} max={95} /></>)}
            </Button>
            <Button className='m-1 p-1'
            onClick={(e) => {
                e.stopPropagation()
                getAIGeneraleImageFile(generatedInfo.proc_id).then(r => {
                    if(r.result){
                        if(fileList.length === 0){
                            let imgs = r.data.img.map(img => {
                                return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                            })
                            imageSet(imgs,true,r.data)
                        } else {
                            let imgs = r.data.img.map(img => {
                                return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                            })
                            imageAdd(imgs,true,r.data)
                        }
                        dialog(t("common.info"),"投稿画面の画像一覧に追加しました。左上の「閉じる」から投稿画面に移動できます。また、投稿画面の「生成履歴から選択」ボタンからも選択できます。")
                        setShowGeneratedInfo(false)
                    }
                })
            }}
            >
                <Icon.PlusCircleFill style={{fontSize:"24px",color:"#EEEEEE",cursor:"pointer"}} onClick={(e) => {
                    e.stopPropagation()
                    getAIGeneraleImageFile(generatedInfo.proc_id).then(r => {
                        if(r.result){
                            if(fileList.length === 0){
                                let imgs = r.data.img.map(img => {
                                    return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                                })
                                imageSet(imgs,true,r.data)
                            } else {
                                let imgs = r.data.img.map(img => {
                                    return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                                })
                                imageAdd(imgs,true,r.data)
                            }
                            dialog(t("common.info"),"投稿画面の画像一覧に追加しました。左上の「閉じる」から投稿画面に移動できます。また、投稿画面の「生成履歴から選択」ボタンからも選択できます。")
                            setShowGeneratedInfo(false)
                        }
                    })
                }} />
                &nbsp;投稿
            </Button>
            {generatedInfo.seed !== "" ? (
            <Button className="m-1 p-1 d-none" onClick={() => {
                navigator.clipboard.writeText(generatedInfo.seed)
                alert("seed値をクリップボードにコピーしました。")
            }}>{generatedInfo.seed}</Button>
            ) : ""}
            <Button className='m-1 p-1' onClick={() => {
                createShareId(generatedInfo.proc_id).then(r => {
                    if(r.result){
                        navigator.clipboard.writeText("https://ourt-ai.work/upload/image/generate?sid="+r.data.share_id)
                        dialog(t("common.info"),"共有リンクをクリップボードにコピーしました。")
                    } else {
                        dialog(t("common.error"),r.errors)
                    }
                    setShowGeneratedPanel(false)
                })
            }}><Icon.Share /></Button>
            <Button className="m-1 p-1" onClick={() => {
                deleteAIGeneraleImageFile([generatedInfo.proc_id]).then(r => {
                    if(r.result){
                        setAIGenerateReset(!aiGenerateReset)
                        setAIGenerateImagePage(1)
                        setShowGeneratedPanel(false)
                    } else {
                        dialog(t("common.error"),r.errors)
                    }
                })
            }}><Icon.Trash /></Button>
        </Container>
        {srcGroupId !== "" ? <Container>
            <p style={{fontWeight:"bold",borderBottom:"3px solid #555555"}}>参考元の{generatedInfo.random_src === "gacha" ? "キャラクター" : "作品"}</p>
            {generatedInfo.random_src === "gacha" ? <div className='d-flex justify-content-center'><CharacterProfileCard data={{group_id:srcGroupId,user_id:"",character_name:generatedInfo.character_name,character_name_kana:generatedInfo.character_name_kana}} /></div> : <Thumb data={{group_id:srcGroupId,id:srcDetailId,favorite:srcFavorite}} dialog={dialog} />}
            {srcTitle}
        </Container>
        : ""}
        </>
    } />
    ) : ""}
    <div style={{display:editImageTargetNo !== -1 ? "block" : "none",position:"fixed",top:0,width:"100%",height:"100%",background:"#000000",zIndex:4,opacity:"0.9"}}>
    </div>
    <div id="paint-tools" style={{display:editImageTargetNo !== -1 ? "block" : "none",position:"fixed",top:0,color:"#FFFFFF",margin:"0 auto",zIndex:4,width:"100%"}} className="text-center">
        <div style={{width:"100%"}} className="d-flex justify-content-center">
            <p style={{display:"block"}}>モザイクのスタイル：</p>
            <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicStyle(e.currentTarget.value)
                    setMosaicImage()
                }}>
                <option value="dot">ドット</option>
                <option value="blur">ぼかし</option>
            </Form.Select>
            <p style={{display:"block"}}>モザイクの大きさ：</p>
            <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicSize(e.currentTarget.value)
                }} defaultValue={30}>
                {[...Array(30)].map((v,i) => {
                    if((i+1)*2 < 29) return ""
                    return <option value={(i+1)*2} key={i}>{(i+1)*2}px</option>
                })}
            </Form.Select>
            <p style={{display:"block"}}>モザイク強度：</p>
            <Form.Control type="number" id="mosaic-strength" min={minMosaicStrength} className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicStrength(e.currentTarget.value)
                    setMosaicImage()
                }} defaultValue={20}>
            </Form.Control>
        </div>
        <Button variant={editLabel === "mosaic" ? 'light' : "primary"} onClick={() => {
            setDrawFlag(1)
            setEditLabel("mosaic")
        }}><Icon.BrushFill /></Button>
        <Button variant={editLabel === "eraser" ? 'light' : "primary"} style={{marginLeft:"3px"}} onClick={() => {
            setDrawFlag(2)
            setEditLabel("eraser")
        }}><Icon.EraserFill /></Button>
        <Button variant='primary' style={{marginLeft:"3px"}} onClick={() => {
            mosaicCanvas()
        }}>全体をモザイク</Button>
        <Button variant='success' style={{marginLeft:"3px"}} onClick={() => {
            saveEdit()
        }}>OK</Button>
        <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
            resetCanvas()
        }}>Reset</Button>
        <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
            closeEdit()
        }}>Close</Button>
        <br />
        <canvas id="tempCanvas" style={{display:"none"}} />
        <div id="canvas-area" className="m-0 p-0" data-selectdrawflag={1} data-mosaicsize={30} data-mosaicstrength={20} data-imageeditflag={0} data-mosaicstyle={"dot"} 
            style={{width:"auto",height:canvasAreaHeight,overflow:"auto"}}
        />
        <canvas id="original-image" style={{display:"none"}} />
        <canvas id="mosaic-image" style={{display:"none"}} />
    </div>
    <div className="wrapper">
        <CommonDialog open={show} onClose={() => setShow(false)} content={<><Alert severity='info'>{dialogTitle}</Alert><br />{dialogMessage}</>} fullScreen={false} />
        <Header />
        <Category />
        <div style={{margin:"0 auto",width:"360px",boxSizing:"border-box",position:"fixed",zIndex:"1",top:(window.innerHeight - 500) / 2,left:(window.innerWidth - 360) / 2,display:postedGroupId !== "" ? "block" : "none"}}>
            <Alert style={{position:"absolute"}}>
                <CloseButton style={{position:"absolute",right:"20px"}} onClick={() => {
                    setPostedGroupId("")
                    setURL("")
                    setImgURL("")
                }}/>
                <p>投稿完了しました。<br />
                   SNSで共有してたくさんの人に見てもらいましょう！<br />
                   ※新着には10分～数時間程で反映されます。<br />
                   </p>
                <p>
                    <a href={url} target="_blank" rel="noreferrer" style={{textDecoration:"none",padding:"8px 14px",borderRadius:"20px",backgroundColor:"#000000",color:"#FFFFFF",border:"1px solid #1D9BF0"}}>𝕏 Post</a>
                    <a href={urlAffi} target="_blank" rel="noreferrer" style={{textDecoration:"none",padding:"8px 14px",borderRadius:"20px",backgroundColor:"#000000",color:"#FFFFFF",border:"1px solid #1D9BF0"}}>𝕏 Post アフィリエイトリンク付き</a>
                </p>
                <div style={{width:"360px",height:"360px"}}>
                    <Link to={"/image/"+postedGroupId}><Image src={imgUrl} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"20px"}} /></Link>
                </div>
            </Alert>
        </div>
        <Container style={{display:postedGroupId !== "" ? "none" : "block"}}>
            <Tabs defaultActiveKey="image" className="mt-1" 
                onSelect={(s) => {if(s !== "audio") navigate("/upload/"+s)}}>
                <Tab eventKey="model" title={<><Icon.Magic /> {t("common.model")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/model")}></Tab>
                <Tab eventKey="character" title={<><Icon.Person /> {t("upload.character.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/character")}></Tab>
                <Tab eventKey="image" title={<><Icon.Image /> {t("upload.image.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/image")}></Tab>
                <Tab eventKey="video" title={<><Icon.FileText /> {t("upload.video.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/video")}></Tab>
                <Tab eventKey="text" title={<><Icon.FileText /> {t("upload.text.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/text")}></Tab>
                <Tab eventKey="audio" title={<><Icon.VolumeUp /> {t("upload.audio.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/audio")}>
                    準備中・・・
                </Tab>
                <Tab eventKey="event" title={<><Icon.Shop /> {t("upload.event.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/event")}></Tab>
            </Tabs>
            {false && odai ? <Link to={"/odai"} className='d-none d-md-block'><Alert variant='warning'>今日のお題「{odai}」</Alert></Link> : ""}
                    <pre style={{backgroundColor:"#555555",color:"#FFFFFF",padding:"10px",borderRadius:"5px",display:messageShow}}>{message}</pre>
                    <h5>①{t("upload.image.images")}</h5>
                    <div style={{display:"block"}}>
                        <InputGroup className="mb-3" style={{maxWidth:"450px"}}>
                            <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={notReadPromptInfo} id="read-prompt-info" onChange={(e) => {
                                setNotReadPromptInfo(e.currentTarget.checked)
                            }} />
                            <Form.Control type="text" value={t("upload.image.fileSelectReadPrompt")} readOnly />
                        </InputGroup>
                    </div>
                    <Container className="d-block mb-3" style={{border:"3px solid #000000",borderRadius:"5px",minHeight:"100px",overflow:"auto",cursor:"pointer"}} id="upload-area"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                            e.preventDefault()
                            const tags = ExifReader.load(e.dataTransfer.files[0],{includeUnknown: true})
                            tags.then(r => {
                                console.log(r)
                            })
                            if(fileList.length === 0){
                                imageSet(e.dataTransfer.files)
                            } else {
                                if(dragElm === undefined){
                                    imageAdd(e.dataTransfer.files)
                                }
                            }
                        }}
                        onDragEnd={() => setDragElm()}
                        onClick={(e) => {
                            e.stopPropagation()
                            if(fileList.length === 0){
                                document.getElementById("file").click()
                            } else {
                                document.getElementById("file_add").click()
                            }
                        }}
                        onDrag={(e) => {
                            if(dragElm){
                                let img = document.getElementById(dragElm)
                                let no = img.dataset.no
                                let imgClient = img.getBoundingClientRect()
                                let uploadClient = document.querySelector("#upload-area").getBoundingClientRect()
                                let bodyClient = document.querySelector("body").getBoundingClientRect()
                                // console.log(e.pageY,client.top,client.y,window.scrollY)
                                let x = e.pageX - window.scrollX
                                let y = e.pageY - window.scrollY
                                img.style.position = "fixed"
                                img.style.top = y - 75 +"px"
                                img.style.left = x - 75 + "px"
                                img.style.zIndex = "201"
                                //console.log(x,y,no )
                                let range = false
                                let l = len
                                let moreThan1 = false
                                fileList.forEach((elm,i) => {
                                    if(no === String(i)) return
                                    let targetImg = document.getElementById("imgDrag"+i)
                                    let client = targetImg.getBoundingClientRect()
                                    // 中心からの距離が一番近いもの？
                                    let targetX = client.x + (client.width / 2)
                                    let targetY = client.y + (client.height / 2)
                                    let lenX = Math.abs(x - targetX)
                                    let lenY = Math.abs(y - targetY)
                                    if(((l[1] >= lenX && l[2] >= lenY) || (lenX < 75 && lenY < 75)) || l[0] === -1){
                                        l = [i,lenX,lenY]
                                        //console.log(i,x,y,targetX,targetY,"近い要素："+l[0],lenX,lenY)
                                        moreThan1 = true
                                    }
                                })
                                setLen(l)
                                range = (l[1] < 75 && l[2] < 75) && l[0] !== -1 && moreThan1
                                setInRange(range)
                                setSelectingNo(no)
                                // console.log(x,y,img2.getBoundingClientRect())
                            }
                        }}
                        onDragEnter={(e) => {
                            //console.log("dragEnter",e)
                        }}
                        >
                        {fileList.map((imgFile,i) => {
                            if(imgFile.imageData !== undefined){
                                document.getElementById("img" + i).src = imgFile.imageData
                            } else {
                                ImageUtil.load(fileList,imgFile.file,i,(data,data2,data3)=>{
                                    if(data === false){
                                        imgFile.error = true
                                        setMessageShow("block")
                                        setMessage(message+"「"+imgFile.file.name+"」が読み込めませんでした。\r\n")
                                        // エラーなら削除
                                        setFileList(fileList.map(f=>f).filter((imgFile,idx)=>!imgFile.error))
                                    } else {
                                        let elm = document.getElementById("img"+i)
                                        if(elm) elm.src = data
                                        imgFile.imageData = data
                                        imgFile.imageDataMiddle = data2
                                        imgFile.imageDataOriginal = data3
                                        imgFile.imageDataEdited = data3
                                        if(i === editImageNo) document.getElementById("select-img").src = data
                                        //if(i === editImageNo) document.getElementById("select-img-ai").src = data2
                                        if(i === editImageNo) setMetaDataField(fileList[editImageNo],true)
                                        // サムネイル調整用の初期画像
                                        if(i === editImageNo) {
                                            document.getElementById("load-image").src = fileList[editImageNo].imageDataEdited
                                        }
                                    }
                                })
                            }
                            return (
                                <div className="m-1" style={{float:"left",width:"150px",height:"150px",position:"relative"}} key={i} data-no={i} id={"imgDiv"+i}
                                onTouchStart={(e) => dragStart(e,i)}
                                onDragStart={(e) => dragStart(e,i)}
                                onDragEnd={(e) => {
                                    e.preventDefault()
                                    //console.log("dragEnd",len)
                                    let img = document.getElementById(dragElm)
                                    img.style.top = ""
                                    img.style.left = ""
                                    img.style.zIndex = "1"
                                    img.style.position = "relative"
                                    setLen([-1,0,0])
                                    let no = parseInt(e.currentTarget.dataset.no)

                                    if(inRange){
                                        // 挿入 no(選択中の要素)とlen[0]                                        
                                        let list = fileList.concat()
                                        if(no < len[0]){
                                            if(len[0] - no === 1){
                                                let tmp = list[no]
                                                list[no] = list[len[0]]
                                                list[len[0]] = tmp
                                                setFileList(list)
                                                setEditImageNo(len[0])
                                            } else {
                                                list.splice(len[0]+1,0,list[no])
                                                setFileList(list.filter((d,i) => i !== no))
                                                setEditImageNo(len[0])
                                            }
                                        } else if(no > len[0]){
                                            list.splice(len[0],0,list[no])
                                            setFileList(list.filter((d,i) => i !== no+1))
                                            setEditImageNo(len[0])
                                        }
                                        setSelectingNo(no)
                                        setDragElm("imgDrag"+len[0])
                                    } else {
                                        setDragElm()
                                        setSelectingNo(no)
                                    }
                                }}
                                onDrag={(e) => {
                                    //console.log("onDrag")
                                }}
                                >
                                    <div style={{width:"150px",height:"150px",position:"relative",backgroundColor:"#FFFFFF",
                                    marginLeft:inRange && len[0] === i ? (len[0] > selectingNo ? "-50px" : "50px") : "0px"}} id={"imgDrag"+i} data-no={i}>
                                        <Image className="upload-thumb" alt={imgFile.file.name} id={"img"+i} style={{objectFit:"contain",position:"absolute",width:"100%",height:"100%",cursor:"grab",
                                            border:editImageNo === i ? "6px solid orange" : "none"}} onClick={(e) => {
                                            e.stopPropagation()
                                            setEditImageNo(i)
                                        }}
                                        onDrag={(e) => {
                                            e.preventDefault()
                                        }}
                                        onDragEnd={(e) => {
                                            e.preventDefault()
                                        }}
                                        />
                                        <Icon.PencilFill style={{fontSize:"24px",position:"absolute",right:"40px",top:"10px",borderRadius:"20px",backgroundColor:"#FFFFFF",
                                            color:imgFile.useMosaic === "1" ? "#FF0000" : "blue"}} onClick={(e) => {
                                            e.stopPropagation()
                                            // 編集対象として設定
                                            setEditImageTargetNo(i)
                                        }} title="モザイクをかける" />
                                        <CloseButton style={{position:"absolute",right:"10px",top:"10px",borderRadius:"20px",backgroundColor:"#FFFFFF"}} onClick={(e) => {
                                            e.stopPropagation()
                                            // リストから画像削除
                                            setFileList(fileList.map(f=>f).filter((file,idx)=>i!==idx))
                                            //if(fileList.length === 1) deleteFormValue() 削除されるのが面倒らしい
                                            if(editImageNo !== 0 && editImageNo >= i) setEditImageNo(editImageNo - 1)
                                        }} title="閉じる" />
                                        <Container style={{position:"absolute",bottom:"0",width:"100%",backgroundColor:"rgba(0,0,0,0.5)",color:"#FFFFFF",overflow:"hidden",whiteSpace:"nowrap"}}>{imgFile.file.name}</Container>
                                    </div>
                                </div>
                            )
                        })}
                        <Image id="dummy" src="/img/dot.png" style={{display:fileList.length > 0 ? "inline" : "none"}} />
                        {fileList.length === 0 ? (
                        <Container className="text-center p-3" style={{clear:"both",fontSize:"18px"}}>
                            <Icon.Upload style={{fontSize:"64px"}}/><br />
                            {t("upload.image.fileDragAndDrop")}<br />
                            {t("upload.image.paste")}<br />
                            <MuiButton variant='outlined' className='m-1'>{t("upload.image.selectFile")}</MuiButton>
                            <MuiButton variant='outlined'    className='m-1'
                                style={{display:loginInfo.result !== undefined && loginInfo.result ? "inline" : "none",marginRight:"10px"}}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    if(displayAIGeneratedPanel){
                                        setAIGenerateImageList([])
                                        setAIGenerateImagePage(-1)
                                        setDisplayAIGeneratedPanel(false)
                                    } else {
                                        setAIGenerateImagePage(1)
                                        setDisplayAIGeneratedPanel(true)
                                    }
                            }}>{t("upload.image.selectByGeneratedHistory")}</MuiButton>
                        </Container>
                        ) : (
                        <div className="m-1 file-add" style={{float:"left",borderRadius:"10px",width:"150px",height:"150px",marginTop:"10px",position:"relative",border:"3px solid #555555"}}>
                            <Icon.PlusLg style={{fontSize:"48px",marginTop:"45px"}} className="w-100" />
                        </div>
                        )}
                    </Container>
                    <p style={{display:fileList.length > 0 ? "inline" : "none"}}><Button variant='outline-primary'
                    onClick={(e) => {
                        e.stopPropagation()
                        // 編集対象として設定
                        setEditImageTargetNo(editImageNo)
                    }} title="モザイクをかける"
                    ><Icon.PencilFill style={{color:"#0000FF"}} /> モザイク編集</Button>
                    <Button className='m-1' variant='outline-secondary'
                        style={{display:loginInfo.result !== undefined && loginInfo.result ? "inline" : "none",marginRight:"10px"}}
                        onClick={(e) => {
                            e.stopPropagation()
                            if(displayAIGeneratedPanel){
                                setAIGenerateImageList([])
                                setAIGenerateImagePage(-1)
                                setDisplayAIGeneratedPanel(false)
                            } else {
                                setAIGenerateImagePage(1)
                                setDisplayAIGeneratedPanel(true)
                            }
                    }}>{t("upload.image.selectByGeneratedHistory")}</Button>
                    </p>
                    {displayAIGeneratedPanel ? (
                        <DynamicDialog autoSizing={true} switch={setDisplayAIGeneratedPanel} content={
                            <Container>
                                <Container className='text-center'>
                                    <Button className='m-3' onClick={() => {
                                        setDisplayAIGeneratedPanel(false)
                                        let images = []
                                        selectedGenerateImageList.forEach(d => {
                                            getAIGeneraleImageFile(d.proc_id).then(r => {
                                                if(r.result){
                                                    images = images.concat(r.data.img.map(img => {
                                                        return base64ToFile(img.replace(/^.*,/, ''),d.proc_id + ".png","image/png")
                                                    }))
                                                    return images
                                                } else {
                                                    return []
                                                }
                                            }).then(r => {
                                                if(selectedGenerateImageList.map(d => d.count).reduce((prev,current) => prev += current) === r.length){
                                                    getAIGeneraleImageFile(d.proc_id).then(info => {
                                                        imageAdd(images,true,info.data)
                                                        setSelectedGenerateImageList([])
                                                    })
                                                } else {

                                                }
                                            })
                                        })
                                    }}>OK</Button>
                                    <Button className='m-3' onClick={() => {
                                        setDisplayAIGeneratedPanel(false)
                                        setSelectedGenerateImageList([])
                                    }}>Cancel</Button>
                                    <Button className='m-3' onClick={() => {
                                        setSelectedGenerateImageList([])
                                    }}>解除</Button>
                                </Container>
                                <Container style={{border:"3px lightblue solid",borderRadius:"5px",overflow:"auto"}} className="d-flex flex-wrap justify-content-between mt-3">
                                    <div className='p-3'>
                                        サイズ<br />
                                        <Slider style={{width:"100px"}} onChange={(e) => {
                                            setGenerateImageListCols(e.target.value)
                                        }} value={generateImageListCols} min={1} max={5} aria-label="Default" />
                                    </div>
                                    <ImageList
                                        sx={{ width: "100%", height: generatedImageListHeight }}
                                        variant="quilted"
                                        cols={generateImageListCols}
                                        gap={8}
                                    >
                                    {aiGenerateImageList.map((data,i) => (
                                        <ImageListItem key={i} style={{position:"relative"}}>
                                            <Container style={{position:"absolute",width:"100%",height:"100%",zIndex:1,cursor:"pointer"}}
                                                onClick={(e) => {
                                                    setSelectedGenerateImageList(selectedGenerateImageList.concat(data))
                                                    if(selectedGenerateImageList.find(d => d.proc_id === data.proc_id) !== undefined){
                                                        setSelectedGenerateImageList(selectedGenerateImageList.filter(d => d.proc_id !== data.proc_id))
                                                    } else {
                                                        //setSelectedGenerateImageList([].concat(data.proc_id))
                                                    }
                                                }}
                                                >
                                                    <Container>
                                                        <input id={'generated'+data.proc_id} type="checkbox" className="delete-check"  onClick={(e) => {
                                                           
                                                        }}
                                                        style={{position:"absolute",zIndex:"1",width:"32px",height:"32px",top:"10px",right:"10px",cursor:"pointer"}}
                                                        defaultChecked={0} data-proc_id={data.proc_id}
                                                        checked={selectedGenerateImageList.find(d => d.proc_id === data.proc_id) !== undefined} />
                                                        <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"10px",right:"10px"}}>
                                                            {data.count > 1 ? <><Icon.Images style={{fontSize:"24px",color:"#EEEEEE"}} />&nbsp;</> : ""}
                                                            <Icon.InfoCircle style={{fontSize:"24px",color:"#EEEEEE",cursor:"pointer"}} onClick={(e) => {
                                                                setShowGeneratedInfo(true)
                                                                setGeneratedInfo(data)
                                                                setGeneratedImageIndex(i)
                                                            }} />
                                                        </Badge>
                                                    </Container>
                                                </Container>
                                            <img
                                                // ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+data.mode + (data.inpaint === 1 ? "_inpaint" : "") +'/'+(data.proc_id)+ApiFetch.API_THUMB_EXT
                                                src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/1/0"}
                                                alt={data.proc_id}
                                                data-no={i} data-type="generate" loading="lazy"
                                                id={"generated-"+data.proc_id}
                                            />
                                        </ImageListItem>
                                    ))}
                                    </ImageList>
                                </Container>
                                <Container className='text-center'>
                                    <Button className='m-3' onClick={() => {
                                        setDisplayAIGeneratedPanel(false)
                                        let images = []
                                        selectedGenerateImageList.forEach(d => {
                                            getAIGeneraleImageFile(d.proc_id).then(r => {
                                                if(r.result){
                                                    images = images.concat(r.data.img.map(img => {
                                                        return base64ToFile(img.replace(/^.*,/, ''),d.proc_id + ".png","image/png")
                                                    }))
                                                    return images
                                                } else {
                                                    return []
                                                }
                                            }).then(r => {
                                                if(selectedGenerateImageList.map(d => d.count).reduce((prev,current) => prev += current) === r.length){
                                                    getAIGeneraleImageFile(d.proc_id).then(info => {
                                                        imageAdd(images,true,info.data)
                                                        setSelectedGenerateImageList([])
                                                    })
                                                }
                                            })
                                        })
                                    }}>OK</Button>
                                    <Button className='m-3' onClick={() => {
                                        setDisplayAIGeneratedPanel(false)
                                        setSelectedGenerateImageList([])
                                    }}>Cancel</Button>
                                    <Button className='m-3' onClick={() => {
                                        setSelectedGenerateImageList([])
                                    }}>解除</Button>
                                </Container>
                            </Container>
                        }/>
                        ) : ""}
                    <Container id="crop-area">

                    </Container>
                    {showCropper ? (
                        <Container>
                        <Cropper
                            classes={{containerClassName: "cropper-container"}}
                            image={fileList.length > 0 && fileList[editImageNo].imageDataEdited}
                            crop={crop}
                            zoom={zoom}
                            aspect={cropTarget === "outside" ? 2 / 1 : 1 / 1}
                            onCropChange={setCrop}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                        />
                        <Container style={{position:"absolute",width:"300px",height:"110px",zIndex:3,left:window.innerWidth / 2 - 150,bottom:"120px",borderRadius:"10px",backgroundColor:"#EEEEEE"}} className="p-3">
                            <FloatingLabel controlId="crop-zoom" label="" className="mb-3"
                                style={{position:"absolute",zIndex:3,top:0,width:"90%",fontSize:"24px"}}
                            >
                                <Form.Range type="range" defaultValue={zoom} min={1} max={5} step={0.1} onChange={(e) => {
                                    setZoom(e.currentTarget.value)
                                }} />
                            </FloatingLabel>
                            <Button style={{position:"absolute",zIndex:3,left:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                if(cropTarget === "inside"){
                                    setInsideThumbnail(tempThumbnail)
                                } else {
                                    setOutsideThumbnail(tempThumbnail)
                                }
                                setShowCropper(false)
                                
                            }}>OK</Button>
                            <Button variant='secondary' style={{position:"absolute",zIndex:3,right:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                setShowCropper(false)
                            }}>Cancel</Button>
                            </Container>
                        </Container>
                    ) : ""}
                    <Container className='flex-wrap justify-content-center' style={{display:fileList.length > 0 ? "flex" : "none"}}>
                        <Container style={{border:"3px solid #000000",borderRadius:"5px",width:"250px",cursor:"pointer"}} className="p-2 text-center"
                            onClick={() => {
                                // スクロールを最上位に戻す
                                window.scrollTo({top:0,left:0,behavior:"instant"})
                                setShowCropper(true)
                                setCropTarget("inside")
                            }}
                        >

                            {t("common.thumbnail")} <Button variant='secondary'>{t("common.edit")}</Button><br />
                            <Container style={{width:"200px",height:"200px"}} className="p-0 mt-2">
                                {insideThumbnail === undefined ?
                                (<div style={{width:"200px",height:"200px",border:"1px solid #000000",paddingTop:"80px"}} >1:1</div>) : (
                                <Image id="crop-target-image" src={insideThumbnail} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"10px"}} className="" />
                                )}
                            </Container>
                        </Container>
                        <Container style={{border:"3px solid #000000",borderRadius:"5px",width:"380px",height:"250px",cursor:"pointer"}} className="mt-3 p-2 text-center"
                            onClick={() => {
                                // スクロールを最上位に戻す
                                window.scrollTo({top:0,left:0,behavior:"instant"})
                                setShowCropper(true)
                                setCropTarget("outside")
                            }}
                        >

                            {t("common.thumbnailsForOutside")}(任意) <Button variant='secondary'>{t("common.edit")}</Button><br />
                            <Container style={{width:"360px",height:"180px"}} className="p-0 mt-2">
                                {outsideThumbnail === undefined ?
                                (<div style={{width:"360px",height:"180px",border:"1px solid #000000",paddingTop:"60px"}}>2:1</div>) : (
                                <Image id="crop-target-image-outside" src={outsideThumbnail} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"10px"}} className="" />
                                )}
                            </Container>
                        </Container>
                    </Container>
                    {/* 読み込み用 */}
                    <Image id="load-image" className="d-none" />
                    {previewFlg ? (
                    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",zIndex:9999,cursor:"pointer"}} onClick={() => setPreviewFlg(false) }>
                        <div style={{position:"fixed",top:0,left:0,backgroundColor:"#000000",width:"100%",height:"100%",opacity:0.9}} />
                        <Image
                            src={previewSource}
                            id="preview"
                            style={{position:"fixed",objectFit:"contain",width:"100%",height:"100%"}}
                        />
                    </div>
                    ) : ""}
                    <Container style={{clear: "both"}} />
                    <Form style={{position:"relative"}}>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{display:fileList.length > 0 ? "block" : "none",margin:"0 auto",width:"100%"}}>
                            <Container>
                                {t("upload.image.fileCount")}：<span style={{color:fileList.length > 300 ? "#FF0000" : "#000000",fontWeight:fileList.length > 300 ? "bold" : "normal"}}>{fileList.length}</span> / 300 File(s)
                                <ProgressBar id="file-select-progress" animated now={Math.floor((fileList.length / 300) * 100)} label={`${Math.floor((fileList.length / 300) * 100)}%`} style={{marginBottom:"10px"}} />
                                {t("upload.image.fileSize")}：<span style={{color:fileSizeOver ? "#FF0000" : "#000000",fontWeight:fileSizeOver ? "bold" : "normal"}}>{fileSize}</span> / 30 GB
                                <ProgressBar id="filesize-progress" animated now={Math.floor(fileSizeByte / maxFileSize * 100)} label={`${Math.floor(fileSizeByte / maxFileSize * 100)}%`} style={{marginBottom:"10px"}} />
                            </Container>
                            {/*<p>拡張子：jpg、png、gif、webp</p>*/}
                            {/* .jpg,.jpe,.jpeg,.jfif,.png,.gif,.webp,.bmp */}
                            <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="file" multiple onChange={(e) => {
                                imageSet(e.currentTarget.files)
                                e.currentTarget.value = ""
                            }} />
                            <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="file_add" multiple onChange={(e) => {
                                imageAdd(e.currentTarget.files)
                                e.currentTarget.value = ""
                            }} />
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            <Button variant='outline-primary' id="aiGenCloseButton"
                                style={{marginRight:"10px",display:"none"}}
                                onClick={(e) => {
                                aiGenInitHandler()
                            }} disabled={false}>{t("upload.image.AIGeneration")}</Button>
                            <div className="m-0 p-0" style={{position:"fixed",overflow:"auto",top:"40px",left:0,width:"100%",height:"100%",backgroundColor:"#FFFFFF",zIndex:2,display:useAiGenerate ? "block" : "none"}}>
                            <Row className='p-3' style={{backgroundColor:"#EEEEEE",background:sdStyle === "" ? "none" : "url('/img/"+sdStyle+"_bg.webp')"}}>
                                <Col xs={12} sm={12} md={8} lg={8} xl={7} xxl={8} style={{margin:"0 auto"}}>
                                <MuiButton variant='outlined' onClick={() => {
                                    setUseAiGenerate(!useAiGenerate)
                                    clearAllInterval()
                                    setAiProccessing(false)
                                    document.getElementById("aiGenCloseButton").innerText = t("upload.image.AIGeneration")
                                    navigate(param.generate === "generate" ? "/upload/image/" : "/upload/image/generate")
                                }}>{t("common.close")}</MuiButton>
                                &nbsp;<MuiButton variant='contained' onClick={() => displayAIGenerateInfo() }>説明</MuiButton>
                                &nbsp;<Link to={"/generatedHistory/image/slow"}>みんなの生成履歴<Icon.ArrowUpRightSquare /></Link>
                                <Tabs defaultActiveKey="txt2img" activeKey={generateTabKey} id="generate-tab" className="mt-3 mb-3" onSelect={(key) => {
                                    if(key === "settings"){
                                        setShowSettings(true)
                                    } else {
                                        setShowSettings(false)
                                    }
                                    setGenerateTabKey(key)
                                }}>
                                    <Tab eventKey="txt2img" title={"画像生成"} style={{position:"relative"}} />
                                    <Tab eventKey="extra" title={"編集"} style={{position:"relative"}}>
                                        <Col xs={7} sm={6} md={7} lg={5} xl={4} xxl={3} className='text-center' style={{margin:"0 auto",display:generateTabKey !== "txt2img" && generateTabKey !== "extra" ? "none" : "block"}}>
                                            <span>{paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} /> <strong>{point.toLocaleString()}</strong></> : <>{Constants.CURRENCY_UNIT_LEFT_COIN} <strong>{coin.toLocaleString()}</strong></>}</span>
                                            {false ? <>{t("upload.image.getPoint")}:<b>{useOdai ? calcPointInfo.point * 2 : calcPointInfo.point}</b></> : ""}
                                            &nbsp;<span title='生成回数(直近24時間)' style={{cursor:"pointer"}} onClick={() => setShowGeneratedCount(true)}><Icon.Images /> {serverStatus && serverStatus.servers ? serverStatus.servers.before24 : ""}</span>
                                            &nbsp;<span title="待機人数" style={{cursor:"pointer"}} onClick={() => setShowTaiki(true)}><Icon.PersonFill /> {serverStatus && serverStatus.servers && serverStatus.servers.sv1 + serverStatus.servers.sv2 + serverStatus.servers.sv3 + serverStatus.servers.sv4 + serverStatus.servers.sv5 + serverStatus.servers.sv6 + serverStatus.servers.sv7 + serverStatus.servers.slow}</span>
                                            &nbsp;<Icon.QuestionCircle style={{fontSize:"20px",cursor:"pointer"}} onClick={() => {
                                                    dialog("info",<>
                                                    <DiamondIcon style={{color:"blue"}} /> 生成ポイント<br />
                                                    <Icon.Images /> 直近24時間の生成回数<br />
                                                    <Icon.PersonFill /> 待機人数。アイコンを押して詳細表示。<br />
                                                    </>)
                                            }} />
                                            {false && loginInfo.plan !== "unlimited" && loginInfo.plan !== "plus" ? <><br /><span style={{fontSize:"14px",textDecoration:"none",color:"blue",cursor:"pointer"}} onClick={() => planDialog(dialog)}>月額1,400円で毎日100枚を生成。広告非表示。 <Icon.ArrowUpRightSquare /></span></> : ""}
                                            <br />
                                            {freePeriodInfo.enabled === 1 ? <>
                                                <span style={{fontSize:"14px",cursor:"pointer"}} onClick={() => dialog("",<>
                                                    以下の期間中はほとんどのモデルで生成によるポイント消費が0になります！<br />
                                                    ∞マークのある解像度が対象です。<br />
                                                    期間：{freePeriodInfo.from}～{freePeriodInfo.to}<br />
                                                    ※著しく回数が多い場合は、サービスを均等に提供する観点から一時的に制限する場合があります。
                                                    </>)}>生成ポイント消費0期間</span>
                                            </> : ""}
                                        </Col>
                                        
                                        <span>部分修正(Inpaint)</span>
                                        <div style={{border:"1px solid #AAAAAA",borderRadius:"5px"}} className='p-1 mb-3'>
                                            {inpaintFile === undefined ? "" : <span className='m-2'>{paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} />&nbsp;{pointCost.toLocaleString()}</> : <>{Constants.CURRENCY_UNIT_LEFT_COIN}&nbsp;{coinCost.toLocaleString()}</>}</span>}
                                            <Button variant='warning' className="m-2 ai-proccessing-button" style={{width:"auto",height:"100%"}} disabled={inpaintMask === undefined}
                                                onClick={(e) => {
                                                    if(serverWaitingStatus === 1){
                                                        generateCancelHandler(serverWaitingProcId)
                                                    } else {
                                                        if(inpaintFile === undefined){
                                                            dialog("エラー","画像を選択してください。")
                                                            return
                                                        }
                                                        if(inpaintMask === undefined){
                                                            dialog("エラー","修正範囲を選択してください。")
                                                            return
                                                        }
                                                        generateHandler(e,false,false)
                                                    }
                                                }}>
                                                <Icon.Mask />&nbsp;
                                                {aiProccessing ? <><Spinner animation="border" size="sm" />&nbsp;{jpPromptTranslating ? t("common.translating") : (
                                                    serverWaitingStatus === 1 ? t("upload.image.waiting") : t("upload.image.cancel")
                                                )}</> : "修正"}
                                                {aiProccessing && generateProgress > 0 && (<><br /><ProgressBar className="ai-generate-progress" animated now={generateProgress} max={95} /></>)}
                                            </Button>
                                            <Inpaint img={inpaintFile}
                                            onFileReadComplete={(base64) => setInpaintFile(base64)}
                                            onChange={(base64) => setInpaintMask(base64)}
                                            onClose={() => {
                                                setInpaintFile()
                                                setInpaintMask()
                                            }} />
                                        </div>
                                        <span>画像を拡大</span>
                                        <div style={{border:"1px solid #AAAAAA",borderRadius:"5px"}} className='p-1'
                                            onDragOver={(e) => e.preventDefault()}
                                            onDrop={(e) => {
                                                e.preventDefault()
                                                let file = e.dataTransfer.files[0]
                                                ImageUtil.load(undefined,file,0,(data1,data2,base64) => {
                                                    Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = data1)
                                                    setImg2ImgFile(base64)
                                                    setShowGeneratedInfo(false)
                                                    setShowI2ICropper(false)
                                                    let img = document.createElement("img")
                                                    img.onload = () => {
                                                        setSelectedImageWidth(img.naturalWidth)
                                                        setSelectedImageHeight(img.naturalHeight)
                                                        console.log("読込後",img.naturalWidth,img.naturalHeight)
                                                        img.remove()
                                                    }
                                                    img.src = base64
                                                })
                                            }}
                                            onDragEnd={() => {}}
                                            onDrag={(e) => {

                                            }}
                                        >
                                            <div className='mb-1 d-block'>
                                                <Tooltip title="指定した画像を拡大します。" arrow>
                                                <div className='justify-content-center' style={{display:img2ImgFile === undefined ? "none" : "flex",cursor:"pointer",border:"1px solid #AAAAAA",borderRadius:"5px"}} onClick={() => {document.getElementById("img2img-file").click()}}>
                                                    <div style={{width:"200px",height:"200px",display:img2ImgFile === undefined ? "none" : "block",border:"1px solid #555555",cursor:"pointer"}}>
                                                        <Image className="img2img-thumb" style={{objectFit:"contain",width:"100%",height:"100%"}}
                                                            onClick={() => document.getElementById("img2img-file").click()}
                                                        />
                                                    </div>
                                                    <div style={{display:img2ImgFile === undefined ? "none" : "block"}}>
                                                        <CloseButton onClick={(e) => {
                                                            e.stopPropagation()
                                                            document.getElementById("img2img-file").value = ""
                                                            Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = "")
                                                            setImg2ImgFile()
                                                        }} />
                                                    </div>
                                                </div>
                                                </Tooltip>
                                                {img2ImgFile === undefined ? <Tooltip title="指定した画像を拡大します。" arrow><MuiButton variant='outlined' onClick={() => {
                                                console.log(sdResolution,sdWidth,sdHeight)
                                                document.getElementById("img2img-file").click()
                                                }} className='w-100' style={{height:"200px",fontSize:"24px"}}>画像を選択</MuiButton></Tooltip> : ""}
                                            </div>
                                            <div className='p-2'>
                                                倍率 x{scaleBy}<br />
                                                <Slider style={{width:"100%"}} valueLabelDisplay="auto" onChange={(e) => {
                                                    setScaleBy(e.target.value)
                                                }} value={scaleBy} min={1} max={8} step={0.05} />
                                            </div>
                                            <div className='p-2 mb-3'>
                                                {selectedImageWidth > 0 ? <>拡大後: {parseInt(selectedImageWidth*scaleBy)}x{parseInt(selectedImageHeight*scaleBy)}</> : ""}
                                            </div>
                                            <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                                                <InputLabel>画風</InputLabel>
                                                <Select
                                                    value={scaleTargetStyle}
                                                    label="画風"
                                                    onChange={(e) => setScaleTargetStyle(e.target.value)}
                                                >
                                                    {[
                                                        {"key":"illustration","name":"イラスト"},{"key":"photo","name":"写真"}].map(d => {
                                                        return <MenuItem value={d.key}>{d.name}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                            {paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} /> {upscalePointCost.toLocaleString()}</> : <>{Constants.CURRENCY_UNIT_LEFT_COIN} {upscaleCoinCost.toLocaleString()}</>}
                                            <Button variant='warning' className="m-2 ai-proccessing-button" style={{width:"auto",height:"100%"}}
                                                onClick={(e) => {
                                                    upScaleHandler()
                                                }}>
                                                <AspectRatioIcon />&nbsp;
                                                {aiProccessing ? <><Spinner animation="border" size="sm" />&nbsp;{jpPromptTranslating ? t("common.translating") : (
                                                    serverWaitingStatus === 1 ? t("upload.image.cancel") : t("upload.image.generating")
                                                )}</> : t("upload.image.generate")}
                                                {aiProccessing && generateProgress > 0 && (<><br /><ProgressBar className="ai-generate-progress" animated now={generateProgress} max={95} /></>)}
                                            </Button>
                                            <ul>
                                                <li><UserMark plan="certification" dialog={() => window.location.href = "/legal"} /> スタンダード：消費ポイント10%引き</li>
                                                <li><UserMark plan="unlimited" dialog={() => window.location.href = "/legal"} /> プレミアム：消費ポイント50%引き</li>
                                                <li><UserMark plan="plus" dialog={() => window.location.href = "/legal"} /> プレミアムプラス：消費ポイント90%引き</li>
                                            </ul>
                                        </div>
                                    </Tab>
                                    {/*<Tab eventKey="training" title={t("common.training")}>
                                        画像を使ってモデルを学習します。<br />
                                        <TextField
                                            label="名前"
                                            id="training-name"
                                            sx={{ m: 1, width: '25ch' }}
                                            onChange={(e) => {
                                                setTrainingName(e.currentTarget.value)
                                            }}
                                            disabled={training}
                                        />
                                        <LoadingButton sx={{ m: 1 }} variant='outlined'
                                        loading={training}
                                        onClick={() => {
                                            setTraining(true)
                                            trainLoRa(trainingName,trainingImageList.map(d => d.img)).then(r => {
                                                if(r.result){
                                                    dialog("","学習を開始します。")
                                                } else {
                                                    dialog("",r.errors)
                                                }
                                                setTraining(false)
                                            })
                                        }}
                                        >学習開始 {Constants.CURRENCY_UNIT_LEFT_COIN} 700</LoadingButton>
                                        {trainingImageList.length > 0 ? <><span style={{fontSize:"28px"}}>{trainingImageList.length}</span> <span style={{fontWeight:"bold",fontSize:"14px"}}>/ 50枚</span></> : ""}
                                        <div
                                        {...getRootProps()}
                                        style={{
                                            display:training ? "none" : "block",
                                            border: "2px dashed #cccccc",
                                            borderRadius: "10px",
                                            padding: "20px",
                                            textAlign: "center",
                                            backgroundColor: isDragActive ? "#f0f8ff" : "#fafafa",
                                            cursor: "pointer",
                                        }}
                                        >
                                        <input {...getInputProps()} disabled={training} />
                                        {isDragActive ? (
                                            <p>ファイルをここにドロップ...</p>
                                        ) : (
                                            <p>ここにファイルをドラッグアンドドロップ、またはクリックしてファイルを選択</p>
                                        )}
                                        </div>
                                        <ImageList
                                        sx={{ width: "100%", height: generatedImageListHeight }}
                                        cols={3}
                                        gap={8}
                                        id="training-image-list"
                                        >
                                        {trainingImageList.map((data,i) => (
                                            <ImageListItem key={i} style={{position:"relative"}}>
                                                <Container style={{position:"absolute",width:"100%",height:"100%",zIndex:1,cursor:"pointer"}}
                                                    onMouseOver={(e) => {
                                                        
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        
                                                    }}
                                                    onClick={(e) => {
                                                        setPreviewFlg(true)
                                                        setPreviewSource(data.img)
                                                        console.log(data)
                                                    }}
                                                >
                                                    <Container>
                                                        <input type="checkbox" className="d-none train-delete-check" onClick={(e) => {
                                                            e.stopPropagation()
                                                            
                                                        }}
                                                        style={{position:"absolute",zIndex:"1",width:"32px",height:"32px",top:"10px",right:"10px",cursor:"pointer"}}
                                                        defaultChecked={0} data-name={data.name} />
                                                        <Badge className='d-none' bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"10px",right:"10px"}}>
                                                            {data.count > 1 ? <><Icon.Images style={{fontSize:"24px",color:"#EEEEEE"}} />&nbsp;</> : ""}
                                                            <Icon.InfoCircle style={{fontSize:"24px",color:"#EEEEEE",cursor:"pointer"}} onClick={(e) => {
                                                                e.stopPropagation()
                                                            }} />
                                                        </Badge>
                                                    </Container>
                                                </Container>
                                                <img
                                                    className='lazy'
                                                    src={data.img}
                                                    alt={data.name}
                                                    data-no={i} data-type="training" loading="lazy"
                                                />
                                            </ImageListItem>
                                        ))}
                                        </ImageList>
                                    </Tab>*/}
                                    <Tab eventKey="settings" title={t("common.settings")}>
                                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:generateTabKey === "settings" ? "block" : "none"}} className='d-xl-none'>
                                            <p>Model</p>
                                            <CommonDialog content={<>
                                                <table>
                                                    <tr><th>prompt</th><td className='p-1'>{recommendPrompt?.length > 0 ? <><MuiButton variant='outlined' onClick={() => {document.getElementById("sd-prompt").value += recommendPrompt;setShowModelRecommendedSettings(false)}}>追加</MuiButton></> : ""}</td></tr>
                                                </table>
                                            </>} open={showModelRecommendedSettings} onClose={() => setShowModelRecommendedSettings(false)} onClick={() => setShowModelRecommendedSettings(false)} />
                                            <Tooltip title="画像生成モデルを選択します。モデルによって画風や得意な構図が異なります。" arrow>
                                            <div onClick={() => setShowModels(true)}
                                                style={{cursor:"pointer",border:"1px solid #AAAAAA",borderRadius:"5px"}} className='p-1'>
                                                <div style={{textAlign:"center"}}><b>{modelName}</b> <MuiButton onClick={() => setShowModels(true)}>モデル一覧</MuiButton> <MuiButton onClick={(e) => {e.stopPropagation(); setShowModelRecommendedSettings(true)}}>推奨設定</MuiButton></div>
                                                <div className='d-flex'>
                                                    <div className='d-flex'>
                                                        <div className='m-1'>
                                                            <Image src={modelImage} width={100} height={100} />
                                                        </div>
                                                        <div className='m-1'>
                                                            {modelDescription}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </Tooltip>
                                            <Container className='text-center'>
                                                <Tooltip title={<>
                                                    白黒の線画に色を付けます。色はプロンプトで指定します。<br />
                                                    <img width={128} src="/img/color_before.webp" /> <img width={128} src="/img/color_after.webp" />
                                                    </>}>
                                                    <FormControlLabel style={{marginLeft:"20px"}} control={<Checkbox checked={useControlnet && modelType === "SDXL"} disabled={modelType !== "SDXL"} onChange={(d => setUseControlnet(d.target.checked))} />} label={<span style={{fontSize:"12px"}}>彩色</span>} />
                                                </Tooltip>
                                                <FormControlLabel control={<Checkbox checked={isFastMode && fastModeVer !== 0} disabled={fastModeVer === 0} onChange={(d => setIsFastMode(d.target.checked))} />} label="高速化" />
                                                {loginInfo.result && loginInfo.age18 === 1 ? (
                                                <Tooltip title={<>NGワードなしで生成できるモードです。特定の条件を満たしている場合利用できます。条件は定期的に見直されます。また、サブスク対象外です。<br />
                                                SMS認証かつ、身分証確認またはWorld ID認証が必要です。
                                                <br /><br />
                                                生成されたコンテンツについてガイドラインにおいて本サービスに投稿するにあたりモザイク等の隠蔽処理が必要な場合はモザイク等の処理を行ってください。<br />
                                                フル版は特定のモデルのみ対応しています。
                                                </>}>
                                                    <FormControlLabel style={{marginLeft:"20px"}} control={<Checkbox checked={isFullMode && modelFullModeEnable !== 0} disabled={modelFullModeEnable === 0} onChange={(d => setIsFullMode(d.target.checked))} />} label={<span style={{fontSize:"12px"}}>フル版</span>} />
                                                </Tooltip>
                                                ) : ""}
                                            </Container>
                                        </Col>
                                        <Col xs={12} sm={8} md={6} lg={5} xl={3} xxl={3} style={{margin:"0 auto",display:showSettings ? "block" : "none"}} className='d-xl-none'>
                                            <span>{t("upload.image.resolution")}</span>
                                            <Form.Select className="mb-3 ai-resolution" value={sdResolution} onChange={(e) => {
                                                setSdResolution(e.currentTarget.value)
                                            }}>
                                                {modelOptions.length > 0 && modelOptions.map(d => {
                                                    if(d.width === undefined){
                                                        return <option value="" disabled>【{d.label}】</option>
                                                    } else {
                                                        return <option value={d.width+"x"+d.height} selected={d.width+"x"+d.height === sdResolution}>{d.width}x{d.height} {d.isFree && free ? "∞" : ""} {d.label}</option>
                                                    }
                                                })}
                                            </Form.Select>
                                        </Col>
                                        <Col xs={12} sm={8} md={6} lg={5} xl={3} xxl={3} style={{margin:"0 auto"}} className='d-xl-none'>
                                            <span>sampler</span>
                                            <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("samplerとは",
                                                <span>生成される画像に影響します、鮮やかさや出力される絵の特徴などが変化します。</span>)} />
                                            <Form.Select disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "SD3" || modelType === "FLUX.1" || modelType === "Mid"} className="mb-3 sd-sampler" value={sdSampler} onChange={(e) => {
                                                setSdSampler(e.currentTarget.value)
                                            }}>
                                            {isFastMode ? samplers.filter(d => isFastSampler(d.name,fastModeVer)).map((s,i) => {
                                                return <option value={s.name} key={i}>{s.name}{s.memo.length > 0 ? "："+s.memo : ""}</option>
                                            }) : samplers.map((s,i) => {
                                                if(img2ImgFile !== undefined && (s.name.startsWith("PLMS") || s.name.startsWith("UniPC")) || sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "SD3" || modelType === "FLUX.1" || modelType === "Mid") return ""
                                                return <option value={s.name} key={i}>{s.name}{s.memo.length > 0 ? "："+s.memo : ""}</option>
                                            })}
                                            </Form.Select>
                                        </Col>
                                        <Col xs={12} sm={8} md={6} lg={5} xl={3} xxl={3} style={{margin:"0 auto"}} className='d-xl-none'>
                                            <span>upscaler</span>
                                            <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("upscalerとは",
                                                <span>高解像度の生成時に使用します。出力される絵の特徴などが変化します。</span>)} />
                                            <Form.Select disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "SD3" || modelType === "FLUX.1" || modelType === "Mid"} className="mb-3 sd-sampler" value={sdUpscaler} onChange={(e) => {
                                                setSdUpscaler(e.currentTarget.value)
                                            }}>
                                            {upscalers.map((s,i) => {
                                                if(sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "SD3" || modelType === "FLUX.1" || modelType === "Mid") return ""
                                                return <option value={s.name} key={i}>{s.name}{s.memo.length > 0 ? "："+s.memo : ""}</option>
                                            })}
                                            </Form.Select>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                            steps
                                            <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("stepsとは",
                                                <span>一定の値までは大きいほど画像の精度が上がりますが生成に時間がかかります。上げすぎると品質が落ちる場合があります。初期値：20 <Link to={"/image/82726bdb-0571-4148-aaff-da8772f132a7"}>Stepsによる違い</Link></span>)} />
                                            &nbsp;{t("upload.image.current")}：{sdSteps}
                                            <FloatingLabel controlId="sd-steps" label="" className="mb-3 w-100">
                                                <Form.Range disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "SD3" || modelType === "FLUX.1" || modelType === "Mid" || isFastMode} type="range" value={sdSteps} min={1} max={70} onChange={(e) => {
                                                    setSdSteps(e.currentTarget.value)
                                                }} />
                                            </FloatingLabel>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                            scale
                                            <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("scaleとは",
                                                <span>小さいほどプロンプトとかけ離れますが品質は高くなり、大きいと品質は落ちますがプロンプトに忠実になります。初期値：7</span>)} />
                                            &nbsp;{t("upload.image.current")}：{sdScale}
                                            <FloatingLabel controlId="sd-scale" label="" className="mb-3 w-100">
                                                <Form.Range disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "SD3" || modelType === "FLUX.1" || modelType === "Mid" || isFastMode} type="range" value={sdScale} min={1} max={30} step={0.5} onChange={(e) => {
                                                    setSdScale(e.currentTarget.value)
                                                }} />
                                            </FloatingLabel>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:hires || img2ImgFile !== undefined || inpaintFile !== undefined ? "block" : "none"}}>
                                            denoising strength
                                            <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("denoising strengthとは",
                                                <span>小さいほど元画像との差がでにくく、大きいと品質は上がりますが元画像とはかけ離れます。初期値：0.35</span>)} />
                                            &nbsp;{t("upload.image.current")}：{sdDenoisingStrength}
                                            <FloatingLabel controlId="sd-denoising-strength" label="" className="mb-3 w-100">
                                                <Form.Range disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "SD3" || modelType === "FLUX.1" || modelType === "Mid"} type="range" defaultValue={sdDenoisingStrength} min={0} max={1} step={0.01} onChange={(e) => {
                                                    setSdDenoisingStrength(e.currentTarget.value)
                                                }} />
                                            </FloatingLabel>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                            <Container className='d-flex' style={{verticalAlign:"middle"}}>
                                                <FloatingLabel controlId="sd-seed" label="seed" className="mb-3">
                                                    <Form.Control disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "Mid"} type="number" defaultValue={sdSeed} min={-1} max={4294967295} step={1} onChange={(e) => {
                                                        setSdSeed(e.currentTarget.value)
                                                    }} />
                                                </FloatingLabel>
                                                &nbsp;<Icon.Dice3 style={{fontSize:"24px",cursor:"pointer"}} onClick={() => {
                                                    if(sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "Mid") return
                                                    document.querySelector("#sd-seed").value = -1
                                                    setSdSeed(-1)
                                                }} />
                                                <Icon.QuestionCircle style={{marginLeft:"15px",cursor:"pointer"}} onClick={() => dialog("seedとは",
                                                    <span>整数を指定し、この数値をもとに生成します。この値が異なると生成される画像が変化します。同じ値を使用すると、他の設定も同じであれば同じ画像が生成されます。-1を指定するとランダムな値が使用されます。</span>)} />
                                            </Container>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"10px auto"}}>
                                            <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                                <InputGroup.Checkbox aria-label="Quality Tags" style={{cursor:"pointer"}} checked={qualityTags && modelType !== "Mid"} id="quality-tags" onChange={(e) => {
                                                    setQualityTags(e.currentTarget.checked)
                                                }} disabled={modelType === "Mid"} />
                                                <Form.Control type="text" defaultValue="Quality Tags" readOnly />
                                                <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("Quality Tagsとは",
                                                <span>生成する画像の品質向上の為のプロンプトを自動的に追加します。</span>)} />
                                            </InputGroup>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"10px auto"}}>
                                            <FloatingLabel style={{display:modelType === "DALL-E3" || modelType === "GPT-Image-1" || modelType === "VertexAI" || modelIdentifiedName === "sd3-large-turbo" || modelType === "FLUX.1" || modelType === "Mid" ? "none" : "block"}} controlId="sd-negative-prompt" label={t("upload.image.negativePrompt")} className="mb-3 w-100"
                                                onInput={(e) => textareaSizing("#sd-negative-prompt",".sd-negative-prompt-textarea")}>
                                                <Form.Control className="sd-negative-prompt-textarea" as="textarea" required onChange={(e) => {
                                                // プロンプトを記憶
                                                localStorage.removeItem("negativePrompt")
                                                localStorage.setItem("negativePrompt",e.currentTarget.value)
                                            }}/>
                                            </FloatingLabel>
                                            {modelType === "DALL-E3" || modelType === "GPT-Image-1" || modelType === "VertexAI" || modelIdentifiedName === "sd3-large-turbo" || modelType === "FLUX.1" || modelType === "Mid" ? <p>ネガティブプロンプト非対応</p> : ""}
                                        </Col>
                                    </Tab>
                                </Tabs>
                                <Col xs={7} sm={6} md={7} lg={5} xl={4} xxl={3} className='text-center' style={{margin:"0 auto",display:generateTabKey !== "txt2img" ? "none" : "block"}}>
                                    <span>{paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} /> <strong>{point.toLocaleString()}</strong></> : <>{Constants.CURRENCY_UNIT_LEFT_COIN} <strong>{coin.toLocaleString()}</strong></>}</span>
                                    {false ? <>{t("upload.image.getPoint")}:<b>{useOdai ? calcPointInfo.point * 2 : calcPointInfo.point}</b></> : ""}
                                    &nbsp;<span title='生成回数(直近24時間)' style={{cursor:"pointer"}} onClick={() => setShowGeneratedCount(true)}><Icon.Images /> {serverStatus && serverStatus.servers ? serverStatus.servers.before24 : ""}</span>
                                    &nbsp;<span title="待機人数" style={{cursor:"pointer"}} onClick={() => setShowTaiki(true) }><Icon.PersonFill /> {serverStatus && serverStatus.servers && serverStatus.servers.sv1 + serverStatus.servers.sv2 + serverStatus.servers.sv3 + serverStatus.servers.sv4 + serverStatus.servers.sv5 + serverStatus.servers.sv6 + serverStatus.servers.sv7 + serverStatus.servers.slow}</span>
                                    &nbsp;<Icon.QuestionCircle style={{fontSize:"20px",cursor:"pointer"}} onClick={() => {
                                            dialog("info",<>
                                            <DiamondIcon style={{color:"blue"}} /> 生成ポイント<br />
                                            <Icon.Images /> 直近24時間の生成回数<br />
                                            <Icon.PersonFill /> 待機人数。アイコンを押して詳細表示。<br />
                                            </>)
                                    }} />
                                    {false && loginInfo.plan !== "unlimited" && loginInfo.plan !== "plus" ? <><br /><span style={{fontSize:"14px",textDecoration:"none",color:"blue",cursor:"pointer"}} onClick={() => planDialog(dialog)}>月額1,400円で毎日100枚を生成。広告非表示。 <Icon.ArrowUpRightSquare /></span></> : ""}
                                    <br />
                                    {freePeriodInfo.enabled === 1 ? <>
                                        <span style={{fontSize:"14px",cursor:"pointer"}} onClick={() => dialog("",<>
                                            以下の期間中はほとんどのモデルで生成によるポイント消費が0になります！<br />
                                            ∞マークのある解像度が対象です。<br />
                                            期間：{freePeriodInfo.from}～{freePeriodInfo.to}<br />
                                            ※著しく回数が多い場合は、サービスを均等に提供する観点から一時的に制限する場合があります。
                                            </>)}>生成ポイント消費0期間</span>
                                    </> : ""}
                                </Col>
                                {false ? <Col xs={7} sm={6} md={7} lg={5} xl={4} xxl={3} style={{margin:"10px auto",display:img2ImgFile !== undefined && !showSettings ? "block" : "none"}}>
                                    <div style={{width:"256px",height:"256px",display:img2ImgFile === undefined ? "none" : "block",border:"3px solid #555555",cursor:"pointer"}} className='mb-3'>
                                        <Image className="img2img-thumb" style={{objectFit:"contain",width:"100%",height:"100%"}}
                                            onClick={() => document.getElementById("img2img-file").click()}
                                        />
                                    </div>
                                    <CropButton show={showI2ICropper} setShowCropper={setShowI2ICropper} aspect={sdWidth / sdHeight} onChange={(img) => {
                                        setImg2ImgFile(img)
                                        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = img)
                                    }}
                                    onCancel={() => {
                                        document.getElementById("img2img-file").value = ""
                                        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = "")
                                        setImg2ImgFile()
                                    }}
                                    src={img2ImgFile} />
                                    <MuiButton variant='outlined' onClick={() => {
                                        console.log(sdResolution,sdWidth,sdHeight)
                                        document.getElementById("img2img-file").click()
                                    }}>生成元の画像を指定する</MuiButton>
                                    <MuiButton variant='outlined' style={{marginLeft:"10px"}} onClick={() => {
                                        document.getElementById("img2img-file").value = ""
                                        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = "")
                                        setImg2ImgFile()
                                    }}>クリア</MuiButton><br />
                                </Col> : ""}
                                <div className='mb-1 d-block d-xl-none'>
                                    <Tooltip title="参考画像を土台に画像を生成します。" arrow>
                                    <div className='justify-content-center' style={{display:img2ImgFile === undefined ? "none" : "flex",cursor:"pointer",border:"1px solid #AAAAAA",borderRadius:"5px"}} onClick={() => {document.getElementById("img2img-file").click()}}>
                                        <div style={{width:"100px",height:"100px",display:img2ImgFile === undefined ? "none" : "block",border:"1px solid #555555",cursor:"pointer"}}>
                                            <Image className="img2img-thumb" style={{objectFit:"contain",width:"100%",height:"100%"}}
                                                onClick={() => document.getElementById("img2img-file").click()}
                                            />
                                        </div>
                                        <div style={{display:img2ImgFile === undefined ? "none" : "block"}}>
                                            <CloseButton onClick={(e) => {
                                                e.stopPropagation()
                                                document.getElementById("img2img-file").value = ""
                                                Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = "")
                                                setImg2ImgFile()
                                            }} />
                                        </div>
                                    </div>
                                    </Tooltip>
                                    {img2ImgFile === undefined ? <Tooltip title="参考画像を土台に画像を生成します。" arrow><MuiButton variant='outlined' onClick={() => {
                                    console.log(sdResolution,sdWidth,sdHeight)
                                    document.getElementById("img2img-file").click()
                                    }} className='w-100'>画像を参照</MuiButton></Tooltip> : ""}
                                </div>
                                {false && fileList.length > 0 && fileList[editImageNo] ? (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="m-1">
                                    <Container style={{width:"240px",height:"auto",display:"block"}}>
                                        <Container className='text-center'>{t("upload.image.edittingInfo")}</Container>
                                        <Container className='d-flex justify-content-between mb-3'>
                                            <Button onClick={() => {
                                                if(editImageNo > 0){
                                                    setEditImageNo(editImageNo - 1)
                                                }
                                                }} disabled={editImageNo === 0}>
                                                <Icon.ArrowLeft /></Button>
                                            <Button onClick={() => {
                                                if(editImageNo < fileList.length){
                                                    setEditImageNo(editImageNo + 1)
                                                }
                                                }} disabled={editImageNo === fileList.length - 1} >
                                                <Icon.ArrowRight /></Button>
                                        </Container>
                                        <Image alt={fileList[editImageNo].file.name} src={fileList[editImageNo].imageDataMiddle} id="select-img-ai" style={{objectFit:"contain",width:"100%",height:"100%",cursor:"pointer"}}
                                        onClick={(e) => {
                                            setPreviewSource(fileList[editImageNo].useMosaic === "1" ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataOriginal)
                                            setPreviewFlg(true)
                                        }} />
                                    </Container>
                                </Col>
                                ) : ""}
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto",display:generateTabKey !== "txt2img" ? "none" : "block"}}>
                                    <span className='d-none'>日本語入力は予算の上限に達したため一時的に停止しています。<br /></span>
                                    <Icon.QuestionCircle style={{fontSize:"20px",cursor:"pointer"}} onClick={() => {
                                            dialog("info",<>
                                            <p style={{fontSize:"18px",fontWeight:"bold",textDecoration:"underline"}}>ランダム</p>
                                            プロンプトが公開されている作品からランダムで生成します。<br /><br />

                                            <p style={{fontSize:"18px",fontWeight:"bold",textDecoration:"underline"}}>予約</p>
                                            生成を予約することができます。<br />
                                            数分間生成がなかった場合に予約したものが1件処理されます。<br />
                                            1分ごとに他の利用者も含めた予約が処理されます。<br />
                                            空きがない場合は処理されません。<br />

                                            一般：1件 ベーシック：5件 スタンダード：50件 プレミアム：100件<br />
                                            <Link to={"/legal"}>支援プラン詳細</Link>
                                            </>)
                                    }} />
                                    <div className='d-flex mb-3'>
                                        <div>
                                            <MuiButton variant='contained' className="m-1 p-1 ai-proccessing-button" onClick={(e) => {
                                                if(serverWaitingStatus === 1){
                                                    generateCancelHandler(serverWaitingProcId)
                                                } else {
                                                    generateHandler(e,false,true)
                                                }
                                            }}>
                                            ランダム
                                            </MuiButton>
                                            <MuiButton variant='contained' className="m-1 p-1 generate-booking-button"
                                            onClick={(e) => {
                                                if(serverWaitingStatus === 1){
                                                    generateCancelHandler(serverWaitingProcId)
                                                } else {
                                                    generateHandler(e,true,false)
                                                }
                                            }} disabled={sdStyle === "slow"}>{t("common.yoyaku")}{generateBookingCount > 0 ? <>({generateBookingCount}/{getMaxBookingCount()})</> : ""}</MuiButton>
                                            &nbsp;
                                            <PaymentMethodSelector pointCost={pointCost} coinCost={coinCost} onChange={(method) => setPaymentMethod(method)} modelType={modelType} />
                                            <br />
                                            <ButtonGroup className="m-1 sd-images-count" variant="outlined" aria-label="生成枚数">
                                                <Button variant={sdImagesCount === "1" ? "secondary" : "outline-secondary"} onClick={() => setSdImagesCount("1")} disabled={sdStyle === "mid-journey" || sdStyle === "niji-journey"}><Icon.Image /> 1</Button>
                                                <Button variant={sdImagesCount === "4" ? "secondary" : "outline-secondary"} onClick={() => setSdImagesCount("4")} disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3"}><Icon.Images /> 4</Button>
                                            </ButtonGroup>
                                            <MuiButton variant='outlined' onClick={() => setAiTalkShow(!aiTalkShow)}>AIに相談</MuiButton>
                                        </div>
                                        <div>
                                            <Button variant='warning' className="m-1 ai-proccessing-button" style={{width:"120px",height:"100%"}}
                                            onClick={(e) => {
                                                if(serverWaitingStatus === 1){
                                                    generateCancelHandler(serverWaitingProcId)
                                                } else {
                                                    generateHandler(e,false,false)
                                                }
                                            }}>
                                            {aiProccessing ? <><Spinner animation="border" size="sm" />&nbsp;{jpPromptTranslating ? t("common.translating") : (
                                                serverWaitingStatus === 1 ? t("upload.image.cancel") : t("upload.image.generating")
                                            )}</> : t("upload.image.generate")}
                                            {aiProccessing && generateProgress > 0 && (<><br /><ProgressBar className="ai-generate-progress" animated now={generateProgress} max={95} />
                                            <span className="ai-proccessing-info" style={{fontSize:"12px"}}></span>
                                            <SubscriptionUpgradeLink 
                                                serverWaitingCount={serverWaitingCount.current}
                                                loginInfo={loginInfo}
                                                onUpgradeClick={() => planDialog(dialog)}
                                            />
                                            </>)}
                                            </Button>
                                        </div>
                                    </div>
                                    <CommonDialog open={aiTalkShow} onClose={() => setAiTalkShow(false)} content={<AITalk show={aiTalkShow} dialog={dialog} setPoint={setPoint} setAIAssistant={setAiTalkShow} />} fullScreen={false} />
                                    <span className='d-none'>12/9 13時より数時間メンテナンス予定です。<br /></span>
                                    {aiProccessing ? <>
                                        {loginInfo.plan !== "plus" ? <Link to={"/legal"} className='m-0 p-0 d-none' style={{textDecoration:"none"}}><Alert className='m-0 p-1'><UserMark plan="plus" dialog={() => false} />&nbsp;プレミアムプラス <b>(最初の1か月20% OFF)</b> <Icon.ArrowUpRightSquare /></Alert></Link> : ""}
                                        <Card style={{width:"360px"}}>
                                            <Card.Header>{isAd ? <>PR&nbsp;
                                                <Icon.InfoCircle style={{fontSize:"20px",cursor:"pointer"}} onClick={() => {
                                                    dialog("info",<>
                                                    広告主募集中。詳しくはお問合せください。
                                                    </>)
                                                }} />
                                            </> : "Tips"}</Card.Header>
                                            <Card.Body>
                                                <Card.Title>{adTitle}</Card.Title>
                                                <Card.Text>{!isAd ? <Image src={"/img/tips/"+tipsImageNo+".webp"} style={{width:"80px",height:"80px",marginRight:"20px"}} /> : ""}{adText}</Card.Text>
                                                {adElement}
                                            </Card.Body>
                                        </Card>
                                    </> : ""}
                                    <p className="ai-proccessing-info"></p>
                                    <SubscriptionUpgradeLink 
                                        serverWaitingCount={serverWaitingCount.current}
                                        loginInfo={loginInfo}
                                        onUpgradeClick={() => planDialog(dialog)}
                                    />
                                    {showTaiki ? (
                                        <CommonDialog open={showTaiki} onClose={() => setShowTaiki(false)} content={serverStatus && serverStatus.servers ? (
                                            <Table striped bordered hover style={{width:"600px",height:"auto"}}>
                                                <tbody>
                                                    <tr><td style={{color:serverStatus.servers.sv1 > 3 ? "red" : "black"}}>sv1</td><td>{serverStatus.servers.sv1}</td><td style={{width:"100px",verticalAlign:"middle"}}><LinearProgress variant="determinate" value={serverStatus.server_info && serverStatus.server_info[0] ? serverStatus.server_info[0].progress : 0} animated /></td><td style={{overflow:"auto"}}>{serverStatus.server_info && serverStatus.server_info[0] ? serverStatus.server_info[0].last_model.replace(".safetensors","") : ""}</td></tr>
                                                    <tr><td style={{color:serverStatus.servers.sv2 > 3 ? "red" : "black"}}>sv2</td><td>{serverStatus.servers.sv2}</td><td style={{verticalAlign:"middle"}}><LinearProgress variant="determinate" value={serverStatus.server_info && serverStatus.server_info[1] ? serverStatus.server_info[1].progress : 0} animated /></td><td style={{overflow:"auto"}}>{serverStatus.server_info && serverStatus.server_info[1] ? serverStatus.server_info[1].last_model.replace(".safetensors","") : ""}</td></tr>
                                                    <tr><td style={{color:serverStatus.servers.sv3 > 3 ? "red" : "black"}}>sv3</td><td>{serverStatus.servers.sv3}</td><td style={{verticalAlign:"middle"}}><LinearProgress variant="determinate" value={serverStatus.server_info && serverStatus.server_info[2] ? serverStatus.server_info[2].progress : 0} animated /></td><td style={{overflow:"auto"}}>{serverStatus.server_info && serverStatus.server_info[2] ? serverStatus.server_info[2].last_model.replace(".safetensors","") : ""}</td></tr>
                                                    <tr><td style={{color:serverStatus.servers.sv4 > 3 ? "red" : "black"}}>sv4</td><td>{serverStatus.servers.sv4}</td><td style={{verticalAlign:"middle"}}><LinearProgress variant="determinate" value={serverStatus.server_info && serverStatus.server_info[3] ? serverStatus.server_info[3].progress : 0} animated /></td><td style={{overflow:"auto"}}>{serverStatus.server_info && serverStatus.server_info[3] ? serverStatus.server_info[3].last_model.replace(".safetensors","") : ""}</td></tr>
                                                    <tr><td style={{color:serverStatus.servers.sv5 > 3 ? "red" : "black"}}>sv5</td><td>{serverStatus.servers.sv5}</td><td style={{verticalAlign:"middle"}}><LinearProgress variant="determinate" value={serverStatus.server_info && serverStatus.server_info[4] ? serverStatus.server_info[4].progress : 0} animated /></td><td style={{overflow:"auto"}}>{serverStatus.server_info && serverStatus.server_info[4] ? serverStatus.server_info[4].last_model.replace(".safetensors","") : ""}</td></tr>
                                                    <tr><td style={{color:serverStatus.servers.sv6 > 3 ? "red" : "black"}}>sv6H</td><td>{serverStatus.servers.sv6}</td><td style={{verticalAlign:"middle"}}><LinearProgress variant="determinate" value={serverStatus.server_info && serverStatus.server_info[5] ? serverStatus.server_info[5].progress : 0} animated /></td><td style={{overflow:"auto"}}>{serverStatus.server_info && serverStatus.server_info[5] ? serverStatus.server_info[5].last_model.replace(".safetensors","") : ""}</td></tr>
                                                    <tr><td style={{color:serverStatus.servers.sv7 > 3 ? "red" : "black"}}>sv7</td><td>{serverStatus.servers.sv7}</td><td style={{verticalAlign:"middle"}}><LinearProgress variant="determinate" value={serverStatus.server_info && serverStatus.server_info[6] ? serverStatus.server_info[6].progress : 0} animated /></td><td style={{overflow:"auto"}}>{serverStatus.server_info && serverStatus.server_info[6] ? serverStatus.server_info[6].last_model.replace(".safetensors","") : ""}</td></tr>
                                                    <tr><td style={{color:serverStatus.servers.slow > 3 ? "red" : "black"}}>slow</td><td>{serverStatus.servers.slow}</td><td style={{verticalAlign:"middle"}}><LinearProgress variant="determinate" value={serverStatus.server_info && serverStatus.server_info[7] ? serverStatus.server_info[7].progress : 0} animated /></td><td style={{overflow:"auto"}}>{serverStatus.server_info && serverStatus.server_info[7] ? serverStatus.server_info[7].last_model.replace(".safetensors","") : ""}</td></tr>
                                                </tbody>
                                            </Table>
                                        ) : ""} fullScreen={false} />
                                    ) : ""}
                                    <CommonDialog open={showGeneratedCount} onClose={() => setShowGeneratedCount(false)} content=
                                    {serverStatus && serverStatus.servers ? (
                                    <>
                                        {loginInfo?.role && loginInfo.role.findIndex(d => d.role_div === "admin") !== -1 ? <><GenerateCount /></> : ""}
                                        直近24時間
                                        <Table striped bordered hover style={{height:"auto"}}>
                                            <tbody>
                                                <tr><td>すべて</td><td>{serverStatus.servers.before24}</td></tr>
                                                <tr><td>検証用</td><td>{serverStatus.servers.before24SD}</td></tr>
                                                <tr><td>ポイント0</td><td>{serverStatus.servers.before24SDAll}</td></tr>
                                                <tr><td>DALL-E3</td><td>{serverStatus.servers.before24DALLE3}</td></tr>
                                                <tr><td>SD3</td><td>{serverStatus.servers.before24SD3}</td></tr>
                                            </tbody>
                                        </Table>
                                        直近1カ月
                                        <Table striped bordered hover style={{height:"auto"}}>
                                            <tbody>
                                                <tr><td>DALL-E3</td><td>{serverStatus.servers.before30MonthDALLE3}</td></tr>
                                                <tr><td>SD3</td><td>{serverStatus.servers.before30MonthSD3}</td></tr>
                                                <tr><td>FLUX.1 schnell</td><td>{serverStatus.servers.before30MonthFLUX1schnell}</td></tr>
                                            </tbody>
                                        </Table>
                                        </>
                                    ) : ""}
                                    />
                                    <Button className="m-1 p-1" variant='warning' onClick={() => setTagSelectorShow(!tagSelectorShow)}>簡単生成</Button>
                                    {loginInfo.result && loginInfo?.role && loginInfo.role.find(d => d.role_div === "admin") !== -1 ? <Button className="m-1 p-1" variant='info' onClick={() => setSampleCollectionShow(true)}>サンプル集</Button> : ""}
                                    {selectedSample && (
                                        <div className="mt-2 p-2" style={{ border: '1px solid #ddd', borderRadius: '5px', backgroundColor: '#f8f9fa' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <img 
                                                    src={selectedSample.thumbnail} 
                                                    alt={selectedSample.name}
                                                    style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '3px' }}
                                                />
                                                <div>
                                                    <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{selectedSample.name}</div>
                                                    <div style={{ fontSize: '12px', color: '#666' }}>選択中のサンプル</div>
                                                </div>
                                                <Button 
                                                    size="sm" 
                                                    variant="outline-secondary" 
                                                    onClick={() => {
                                                        setSelectedSample(null)
                                                        const promptField = document.querySelector("#sd-prompt");
                                                
                                                        if (promptField) {
                                                            promptField.removeAttribute("disabled");
                                                        }
                                                    }}
                                                    style={{ marginLeft: 'auto' }}
                                                >
                                                    解除
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                    <Tooltip title="通常の4倍の画素数で生成します。" placement='top'>
                                        <FormControlLabel className='m-1' control={<Checkbox checked={isScaleUpx2} disabled={modelType === "DALL-E3" || modelType === "GPT-Image-1" || modelType === "VertexAI" || modelType === "SD3" || modelType === "FLUX.1"} onChange={(d => setIsScaleUpx2(d.target.checked))} />} label={<span>画素数4倍 <AspectRatioIcon /></span>} />
                                    </Tooltip>
                                    <br />
                                    {i18n.language === "en" ? "" : (<><Switch id="jp-prompt-use" checked={enterJpPrompt} onChange={(e) => {
                                        setEnterJpPrompt(e.currentTarget.checked)
                                    }} /> <label for="jp-prompt-use" style={{cursor:"pointer"}}>{t("upload.image.enterInJapanese")}</label>
                                    </>)}
                                    <Tooltip title="入力したプロンプトを強化します。要望を入力するとそれにあったプロンプトが自動生成されます。" arrow>
                                        <Switch id="enhance-prompt-use" defaultChecked={enterEnhancePrompt} onChange={(e) => {
                                            setEnterEnhancePrompt(e.currentTarget.checked)
                                        }} /> <label for="enhance-prompt-use" style={{cursor:"pointer"}}><Icon.Magic /> プロンプト強化</label>
                                    </Tooltip>
                                    <CommonDialog open={tagSelectorShow} onClose={() => setTagSelectorShow(false)} content={<TagSelector show={tagSelectorShow} setSelected={setTagSelected} dialog={dialog} />} fullScreen={false} />
                                    <CommonDialog 
                                        open={sampleCollectionShow} 
                                        onClose={() => setSampleCollectionShow(false)} 
                                        title="AIサンプル集"
                                        maxWidth="1600px"
                                        minWidth="1200px"
                                        content={
                                            <SampleCollection show={sampleCollectionShow} onSelect={(sample) => {
                                                setSelectedSample(sample);
                                                setSampleCollectionShow(false);
                                                
                                                // プロンプトを自動入力
                                                const promptField = document.querySelector("#sd-prompt");
                                                const negativePromptField = document.querySelector("#sd-negative-prompt");
                                                
                                                if (promptField) {
                                                    promptField.value = sample.prompt
                                                    promptField.setAttribute("disabled", "disabled");
                                                }
                                                if (negativePromptField) negativePromptField.value = sample.negativePrompt;
                                                
                                                // その他の設定を適用
                                                setSdSteps(sample.steps);
                                                setSdScale(sample.cfgScale);
                                                setSdSampler(sample.sampler);
                                                setSdWidth(sample.width);
                                                setSdHeight(sample.height);
                                                setSdStyle(sample.model);
                                                
                                                dialog("サンプル適用", `${sample.name}の設定を適用しました。`);
                                            }} />
                                        } 
                                        fullScreen={false} 
                                    />
                                    {enterJpPrompt && loginInfo.plan !== "unlimited" && loginInfo.plan !== "plus" ? <><br />※日本語入力は翻訳する文字数分が無制限の対象外です。</> : ""}
                                    <FloatingLabel controlId="sd-jp-prompt" label={t("upload.image.jpPrompt")} className="mb-3 w-100"
                                        style={{display:enterJpPrompt ? "block" : "none"}}
                                        onInput={(e) => textareaSizing("#sd-jp-prompt",".sd-jp-prompt-textarea")}>
                                        <Form.Control className="sd-jp-prompt-textarea" as="textarea" required 
                                        style={{ height: '50px'}}
                                        onChange={(e) => {
                                            // プロンプトを記憶
                                            localStorage.removeItem("jpPrompt")
                                            localStorage.setItem("jpPrompt",e.currentTarget.value)
                                            setJpCost(e.currentTarget.value.length)
                                        }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel controlId="sd-prompt" label={t("upload.image.prompt")} className="mb-3 w-100"
                                        onInput={(e) => textareaSizing("#sd-prompt",".sd-prompt-textarea")} style={{display:enterJpPrompt ? "none" : "block"}}>
                                        <Form.Control className="sd-prompt-textarea" as="textarea" required 
                                        style={{ height: '50px' }}
                                        onChange={(e) => {
                                            // プロンプトを記憶
                                            localStorage.removeItem("prompt")
                                            localStorage.setItem("prompt",e.currentTarget.value)
                                        }}
                                        />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto",display:generateTabKey !== "txt2img" ? "none" : "block"}}>
                                    <div className='mb-3'>ネガティブプロンプトは「設定」タブに移動しました。</div>
                                    <Typeahead id="style-select" ref={styleRef} placeholder={"styles"}
                                    className="mb-3"
                                    multiple
                                    clearButton={true}
                                    onInputChange={(input) => {
                                        console.log(1)
                                        
                                    }}
                                    onChange={(selected) => {
                                        //let value = selected.length === 0 ? "no-select" : selected[0]
                                        setStyleSelected(selected)
                                    }}
                                    selected={styleSelected}
                                    defaultSelected={[]}
                                    options={styleOptions}
                                    />
                                    <SelectedLoRaList selectedLoRas={usedLoraList} onClick={() => {setShowLora(true)}}/>
                                    <div className='mb-3'>
                                        <Button variant='outline-secondary' title='現在の入力内容をスタイルとして保存'
                                        onClick={() => {
                                            dialog(t("upload.image.styleName"),
                                            <div>
                                            <FloatingLabel controlId="style-name" label={t("upload.image.styleName")} className="mb-3 w-100">
                                                <Form.Control type="text" placeholder="" required />
                                            </FloatingLabel>
                                            <Button onClick={() => {
                                                let styleName = document.getElementById("style-name").value
                                                let prompt = document.getElementById("sd-prompt").value
                                                let negativePrompt = document.getElementById("sd-negative-prompt").value
                                                setStyle(styleName,prompt,negativePrompt).then(r => {
                                                    if(r.result){
                                                        setStyleOptions(r.data)
                                                        dialog("確認","保存しました。")
                                                    } else {
                                                        dialog("エラー",r.errors)
                                                    }
                                                })
                                                setShow(false)
                                            }}>保存</Button>
                                            </div>)
                                        }}
                                        ><RIcon.FaSave /></Button>
                                        <Button variant='outline-secondary' title='選択中のスタイルを現在のプロンプトに反映'
                                        onClick={() => {
                                            let prompt = document.getElementById("sd-prompt")
                                            let negativePrompt = document.getElementById("sd-negative-prompt")
                                            prompt.value = (styleSelected.map(d => d.prompt.length > 0 ? (d.prompt.slice(-1) === "," ? d.prompt : d.prompt + ",") : "")).join("").slice(0,-1)
                                            negativePrompt.value = (styleSelected.map(d => d.negative_prompt.length > 0 ? (d.negative_prompt.slice(-1) === "," ? d.negative_prompt : d.negative_prompt + ",") : "")).join("").slice(0,-1)
                                            // プロンプトエリアの幅調整
                                            textareaSizing("#sd-prompt",".sd-prompt-textarea")
                                            textareaSizing("#sd-negative-prompt",".sd-negative-prompt-textarea")
                                        }}
                                        ><RIcon.FaClipboardList /></Button>
                                        <Button variant='outline-secondary' title='選択中のスタイルの内容を確認'
                                        onClick={() => {
                                            dialog("style info",
                                            <div>
                                                prompt:<br />
                                                {styleSelected.map(d => (d.prompt.length > 0 ? (d.prompt.slice(-1) === "," ? d.prompt : d.prompt + ",") : "")).join("").slice(0,-1)}<br /><br />
                                                negative prompt:<br />
                                                {styleSelected.map(d => (d.negative_prompt.length > 0 ? (d.negative_prompt.slice(-1) === "," ? d.negative_prompt : d.negative_prompt + ",") : "")).join("").slice(0,-1)}
                                            </div>)
                                        }}
                                        ><RIcon.FaInfo /></Button>
                                        <Button variant='outline-secondary' title='選択中のスタイルを削除'
                                        onClick={() => {
                                            dialog(t("common.confirm"),
                                            <div>
                                                <p>以下のスタイルを削除しますか？</p>
                                                <p>{styleSelected.map(d => d.label).join(",")}</p>
                                                <Button onClick={() => {
                                                    deleteStyleList(styleSelected.map(d => d.style_id)).then(r => {
                                                        if(r.result){
                                                            setStyleOptions(r.data)
                                                            setStyleSelected([])
                                                            dialog(t("common.confirm"),t("common.deleted"))
                                                        } else {
                                                            dialog(t("common.error"),r.errors)
                                                        }
                                                    })
                                                }}>OK</Button>
                                            </div>)
                                        }}
                                        ><RIcon.FaTrash /></Button>
                                        {showLora ? (
                                        <DynamicDialog switch={setShowLora} autoSizing={true} content={<Container style={{marginTop:"50px"}}>
                                            <Button variant='outline-primary' onClick={() => setShowLora(false)}>{t("common.close")}</Button><br /><br />
                                            <div>
                                            <div>
                                                <span style={{fontWeight:"bold"}}>flat2</span> 繊細 &lt;-&gt; フラット <span id='flat2'></span></div>
                                                <FloatingLabel label="" className="mb-3" style={{width:"90%",fontSize:"24px"}}>
                                                    <Form.Range type="range" defaultValue={0} min={-2} max={2} step={0.1} onChange={(e) => {
                                                        //e.currentTarget.value
                                                        let prompt = document.querySelector("#sd-prompt")
                                                        let match = prompt.value.match(/<lora:flat2:([0-9.-]+)>/)
                                                        if(match === null){
                                                            prompt.value += "<lora:flat2:1>"
                                                        } else {
                                                            let value = match[1]
                                                            prompt.value = prompt.value.replace(match[0],"<lora:flat2:"+e.currentTarget.value+">")
                                                        }
                                                        document.querySelector("#flat2").textContent = e.currentTarget.value
                                                    }} />
                                                </FloatingLabel>
                                            </div>
                                            {/* ここに検索ボックスを追加 */}
                                            <Form.Control
                                                type="text"
                                                placeholder="Lora名でフィルター"
                                                className="mb-3"
                                                value={loraFilter}
                                                onChange={e => setLoraFilter(e.target.value)}
                                                style={{ maxWidth: '400px' }}
                                            />
                                            {allLoraList.filter(lora => lora.name.toLowerCase().includes(loraFilter.toLowerCase())).map((lora,i) => {
                                                let weight = getDefaultStyleWeight(lora)
                                                return (
                                                <div key={i}>
                                                    <div className='d-flex'>
                                                        <div style={{width:"100px",height:"100px",overflow:"hidden"}}>
                                                            <Image src={lora.isUserLora ? lora.sample : "/img/lora/"+lora.name+".webp"} style={{objectFit:"contain", width:"100%",height:"100%",cursor:"pointer"}}
                                                                onClick={() => dialog(lora.name,<>
                                                                <Image src={lora.isUserLora ? lora.sample : "/img/lora/"+lora.name+".webp"} style={{width:"100%",height:"100%"}} />
                                                                {/* ユーザー名とリンク */}
                                                                {lora.isUserLora ? (
                                                                    <p>Uploaded by <Link to={"/user/"+lora.user_id}>{lora.user_name}</Link></p>
                                                                ) : ""}
                                                                {lora.description ? <p>{lora.description}</p> : ""}
                                                                </>)} />
                                                        </div>
                                                        <div className='m-1' style={{width:"100%"}}>
                                                            <span style={{fontWeight:"bold"}}>{lora.name}</span> <span id={lora.isUserLora ? "lora-" + lora.fileId : lora.name}>{weight}</span>
                                                            {lora.modelType ? (
                                                                <Chip
                                                                    label={lora.modelType}
                                                                    size="small"
                                                                    color="primary"
                                                                    style={{marginLeft: "8px", verticalAlign: "middle"}}
                                                                />
                                                            ) : ""}
                                                            <Form.Check // prettier-ignore
                                                                type="switch"
                                                                id={(lora.isUserLora ? "lora-" + lora.fileId : lora.name)+"-switch"}
                                                                label="Off/On"
                                                                defaultChecked={weight}
                                                                onChange={(e) => {
                                                                    let loraId = lora.isUserLora ? "lora-" + lora.fileId : lora.name
                                                                    let loraRefName = (lora.isUserLora ? lora.fileId : lora.name).replace(/-/g, "\-")
                                                                    let prompt = document.querySelector("#sd-prompt")
                                                                    let range = document.querySelector("#"+loraId+"-range")
                                                                    let match = prompt.value.match("<lora:"+loraRefName+":([0-9.-]+)>")
                                                                    if(e.currentTarget.checked){
                                                                        let value = range.value === "0" ? 1 : range.value
                                                                        prompt.value += "<lora:"+loraRefName+":"+value+">"
                                                                        document.querySelector("#"+loraId).textContent = value
                                                                        document.querySelector("#"+loraId+"-range").value = value
                                                                    } else {
                                                                        if(match !== null){
                                                                            prompt.value = prompt.value.replace(match[0],"")
                                                                        }
                                                                        document.querySelector("#"+loraId).textContent = ""
                                                                        document.querySelector("#"+loraId+"-range").value = 0
                                                                    }
                                                                    prompt.value = prompt.value.replace(/,+/g,",")
                                                                }}
                                                            />
                                                            <FloatingLabel label="" className="mb-3" style={{width:"90%",fontSize:"24px"}}>
                                                                <Form.Range type="range" id={(lora.isUserLora ? "lora-" + lora.fileId : lora.name)+"-range"} defaultValue={weight} min={-2} max={2} step={0.1} onChange={(e) => {
                                                                    //e.currentTarget.value
                                                                    let loraId = lora.isUserLora ? "lora-" + lora.fileId : lora.name
                                                                    let loraRefName = (lora.isUserLora ? lora.fileId : lora.name).replace(/-/g, "\-")
                                                                    let prompt = document.querySelector("#sd-prompt")
                                                                    let match = prompt.value.match("<lora:"+loraRefName+":([0-9.-]+)>")
                                                                    if(match === null){
                                                                        prompt.value += "<lora:"+loraRefName+":"+e.currentTarget.value+">"
                                                                    } else {
                                                                        prompt.value = prompt.value.replace(match[0],"<lora:"+loraRefName+":"+e.currentTarget.value+">")
                                                                    }
                                                                    document.querySelector("#"+loraId).textContent = e.currentTarget.value
                                                                    prompt.value = prompt.value.replace(/,+/g,",")
                                                                    
                                                                    let s = document.querySelector("#"+loraId+"-switch")
                                                                    s.checked = true
                                                                }} />
                                                            </FloatingLabel>
                                                        </div>
                                                    </div>
                                                </div>)
                                            })}
                                        </Container>}  show={true} />
                                        ) : ""}
                                        <Button variant='outline-secondary' onClick={() => setShowLora(true)}>🎴</Button>
                                        {showEmbeddings ? (
                                        <DynamicDialog switch={setShowEmbeddings} autoSizing={true} content={<Container style={{marginTop:"50px"}}>
                                            <Button variant='outline-primary' onClick={() => setShowEmbeddings(false)}>{t("common.close")}</Button><br /><br />
                                            <div>
                                                {allTextualInversionList.map((embedding, i) => {
                                                    let prompt = document.querySelector("#sd-negative-prompt")
                                                    let checked = prompt.value.includes(embedding.name) || embedding.fileId.length > 0 && prompt.value.includes(embedding.fileId) ? true : false
                                                    let refName = embedding.fileId.length > 0 ? embedding.fileId.replace(/-/g, "\-") : embedding.name
                                                    return (
                                                        <div key={i} className='d-flex'>
                                                            <div style={{width:"100px",height:"100px",overflow:"hidden"}}>
                                                                {embedding.sample === "" ? (
                                                                    // 空
                                                                    <div style={{width:"100%",height:"100%",backgroundColor:"#f0f0f0",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}
                                                                        onClick={() => dialog(embedding.name,<>
                                                                        {/* ユーザー名とリンク */}
                                                                        {embedding.isUserTextualInversion ? (
                                                                            <p>Uploaded by <Link to={"/user/"+embedding.user_id}>{embedding.user_name}</Link></p>
                                                                        ) : ""}
                                                                        {embedding.description ? <p>{embedding.description}</p> : ""}
                                                                        </>)}
                                                                    >
                                                                        <span>No Image</span>
                                                                    </div>
                                                                ) :
                                                                    <Image src={embedding.sample} style={{objectFit:"contain", width:"100%",height:"100%",cursor:"pointer"}}
                                                                    onClick={() => dialog(embedding.name,<>
                                                                    {/* ユーザー名とリンク */}
                                                                    {embedding.isUserTextualInversion ? (
                                                                        <p>Uploaded by <Link to={"/user/"+embedding.user_id}>{embedding.user_name}</Link></p>
                                                                    ) : ""}
                                                                    <Image src={embedding.sample} style={{width:"100%",height:"100%"}} />
                                                                    {embedding.description ? <p>{embedding.description}</p> : ""}
                                                                    </>)} />
                                                                }
                                                            </div>
                                                            <div className='m-1' style={{width:"100%"}}>
                                                                <span style={{fontWeight:"bold"}}>{embedding.name}</span>
                                                                {embedding.modelType ? (
                                                                <Chip
                                                                    label={embedding.modelType}
                                                                    size="small"
                                                                    color="primary"
                                                                    style={{marginLeft: "8px", verticalAlign: "middle"}}
                                                                />
                                                                ) : ""}
                                                                <Form.Check // prettier-ignore
                                                                    type="switch"
                                                                    id={"embedding-"+embedding.fileId+"-switch"}
                                                                    label="Off/On"
                                                                    defaultChecked={checked}
                                                                    onChange={(e) => {
                                                                        let prompt = document.querySelector("#sd-negative-prompt")
                                                                        if(e.currentTarget.checked){
                                                                            if(prompt.value.length > 0 && prompt.value[prompt.value.length-1] !== ","){
                                                                                prompt.value = prompt.value + ","    
                                                                            }
                                                                            prompt.value = prompt.value + refName
                                                                        } else {
                                                                            prompt.value = prompt.value.replace(refName,"")
                                                                        }
                                                                        prompt.value = prompt.value.replace(/,+/g,",")
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </Container>}  show={true} />
                                        ) : ""}
                                        <Button variant='outline-secondary' onClick={() => setShowEmbeddings(true)}>Ti</Button>
                                    </div>
                                    <Button variant='warning' className="m-1 p-1 ai-proccessing-button"
                                    onClick={(e) => {
                                        if(serverWaitingStatus === 1){
                                            generateCancelHandler(serverWaitingProcId)
                                        } else {
                                            generateHandler(e,false,false)
                                        }
                                    }}>
                                    {aiProccessing ? <><Spinner animation="border" size="sm" />&nbsp;{jpPromptTranslating ? t("common.translating") : t("upload.image.cancel")}</> : t("upload.image.generate")}&nbsp;{paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} />&nbsp;{pointCost.toLocaleString()}</> : <>{Constants.CURRENCY_UNIT_LEFT_COIN}&nbsp;{coinCost.toLocaleString()}</>}
                                    {aiProccessing && generateProgress > 0 && (<><br /><ProgressBar className="ai-generate-progress" animated now={generateProgress} max={95} /></>)}
                                    </Button>
                                    &nbsp;{t("upload.image.genSteps")}&nbsp;
                                    <Icon.QuestionCircle
                                        style={{cursor:"pointer"}}
                                        onClick={() => {
                                            dialog(t("upload.image.genSteps"),(
                                                <div>
                                                    ①{t("upload.image.genSteps1")}<br />
                                                    {t("upload.image.forExample")}：<br />
                                                    <ul style={{marginLeft:"10px"}}>
                                                        <li>dog,shibainu</li>
                                                        <li>1girl</li>
                                                        <li>1boy</li>
                                                        <li>clock</li>
                                                    </ul>
                                                    ②{t("upload.image.genSteps2")}<br />
                                                    ③{t("upload.image.genSteps3")}<br /><br />
                                                    ※{t("upload.image.genNotice1")}<br />
                                                    ※{t("upload.image.genNotice2")}<br />
                                                </div>
                                            ))
                                        }}
                                    />
                                    <br />
                                    <MuiButton variant='contained' className="mt-3" onClick={() => planDialog(dialog)}><DiamondIcon style={{color:"blue"}} />&nbsp;プレミアム</MuiButton><br />
                                    <p className="ai-proccessing-info"></p>
                                    <SubscriptionUpgradeLink 
                                        serverWaitingCount={serverWaitingCount.current}
                                        loginInfo={loginInfo}
                                        onUpgradeClick={() => planDialog(dialog)}
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"10px auto",display:generateTabKey !== "txt2img" ? "none" : "block"}}>
                                    <p className='mt-3'>
                                        <span>{t("upload.image.howToPoint")}</span><Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("ポイントが足りないときは",
                                        <>
                                        <ul>
                                            <li><Link to={"/legal"}>無制限プラン</Link>でポイント消費することなく生成できます。</li>
                                            <li>翌日まで待てばポイント回復。
                                                活動実績により変動。
                                                <br />
                                                「マイページ」の実績➡総利用ポイント<br />基準は定期的に見直されます。</li>
                                            <li>イラストを投稿することで数ポイント回復。</li>
                                            <li>過去6ヵ月間の平均閲覧数に応じて回復ポイントが変動。</li>
                                            <li>今日のお題に参加すると投稿時に回復するポイントが2倍。</li>
                                            <li>自分以外の作品に「いいね」やコメントをする。</li>
                                        </ul>
                                        </>
                                        )} />
                                    </p>
                                    <MuiButton variant='outlined' onClick={() => dialog("時間帯別利用件数(昨日基準)",userList)}>時間帯別利用件数</MuiButton>
                                </Col>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={4} xl={5} xxl={4} style={{backgroundColor:"rgba(230,230,230,0.5)",margin:"0 auto"}}>
                                    {showModels ?
                                        (<CommonDialog maxWidth={"auto"} open={showModels} onClose={() => setShowModels(false)} content={
                                            <Container style={{marginTop:"50px"}}>
                                                <div className='d-flex'>
                                                    <h3>モデル一覧</h3>&nbsp;
                                                    <MuiButton variant='outlined' onClick={() => setShowModels(false)}>{t("common.close")}</MuiButton>
                                                    <Button variant='warning' className="m-1 ai-proccessing-button"
                                                    onClick={(e) => {
                                                        if(serverWaitingStatus === 1){
                                                            generateCancelHandler(serverWaitingProcId)
                                                        } else {
                                                            generateHandler(e,false,false)
                                                            setShowModels(false)
                                                        }
                                                    }}>
                                                    {aiProccessing ? <><Spinner animation="border" size="sm" />&nbsp;{jpPromptTranslating ? t("common.translating") : t("upload.image.cancel")}</> : t("upload.image.generate")}&nbsp;{paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} />&nbsp;{pointCost.toLocaleString()}</> : <>{Constants.CURRENCY_UNIT_LEFT_COIN}&nbsp;{coinCost.toLocaleString()}</>}
                                                    {aiProccessing && generateProgress > 0 && (<><br /><ProgressBar className="ai-generate-progress" animated now={generateProgress} max={95} /></>)}
                                                    </Button>
                                                </div>
                                            <Container className='text-center'><b>{modelName}</b></Container>
                                            <Container className='text-center'>{modelDescription}</Container>
                                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                                <InputLabel>画風</InputLabel>
                                                <Select
                                                    value={sdStyleOfPainting}
                                                    label="画風"
                                                    onChange={(e) => setSdStyleOfPainting(e.target.value)}
                                                >
                                                    {[
                                                        {"key":"all","name":"すべて"},{"key":"illustration","name":t("upload.image.illustration")},{"key":"semirealism","name":t("upload.image.semirealism")},
                                                        {"key":"photorealistic","name":t("upload.image.photorealistic")},{"key":"common","name":"汎用"}].map(d => {
                                                        return <MenuItem value={d.key}>{d.name}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                                <InputLabel>モデル</InputLabel>
                                                <Select
                                                    value={tabKey}
                                                    label="モデル"
                                                    onChange={(e) => setTabKey(e.target.value)}
                                                >
                                                    {[
                                                        {"key":"all","name":"すべて"},{"key":"sd1.5","name":"SD1.5"},{"key":"sdxl","name":"SDXL"},{"key":"sd3","name":"SD3"},
                                                        {"key":"sd3.5","name":"SD3.5"},{"key":"vertexai","name":"VertexAI"},
                                                        {"key":"openai","name":"OpenAI"},{"key":"flux1","name":"FLUX.1"},{"key":"favorite","name":"お気に入り"},
                                                        {"key":"osusume","name":"おすすめ"},{"key":"new","name":"New"}].map(d => {
                                                        return <MenuItem value={d.key}>{d.name}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                            <TextField size='small' id="model-search" label="検索" variant="outlined" className='m-2'
                                            onChange={(e) => {
                                                setModelSearchWord(e.target.value)
                                            }} />
                                            <div className="mt-3 mb-3 w-100 d-flex justify-content-center" style={{flexWrap:"wrap",overflow:"auto"}}>
                                                {modelList.filter(d => {
                                                    let style = true
                                                    switch(sdStyleOfPainting){
                                                        case "illustration":
                                                            style = "illustration" === d.style
                                                            break
                                                        case "semirealism":
                                                            style = "semirealism" === d.style
                                                            break
                                                        case "photorealistic":
                                                            style = "photorealistic" === d.style
                                                            break
                                                        case "common":
                                                            style = "common" === d.style
                                                            break
                                                        default:
                                                            style = true
                                                    }
                                                    switch(tabKey){
                                                        case "mid":
                                                            return d.model_type === "Mid" && style
                                                        case "sd1.5":
                                                            return d.model_type === "SD1.5" && style
                                                        case "sdxl":
                                                            return d.model_type === "SDXL" && style
                                                        case "sd3":
                                                            return d.model_type === "SD3" && style
                                                        case "sd3.5":
                                                            return d.model_type === "SD3.5" && style
                                                        case "openai":
                                                            return (d.model_type === "DALL-E3" || d.model_type === "GPT-Image-1") && style
                                                        case "vertexai":
                                                            return d.model_type === "VertexAI" && style
                                                        case "flux1":
                                                            return d.model_type === "FLUX.1" && style
                                                        case "favorite":
                                                            return d.favorite === 1 && style
                                                        case "osusume":
                                                            return (d.i_name === "ourt_AI_Diffusion_Anime_V4"
                                                                || d.i_name === "himawarimix_v11" || d.i_name === "blue_pencil_v10"
                                                                || d.i_name === "animagine-xl-3.1" || d.i_name === "ourt_AI_Diffusion_Anime_V6_niji-style_20240331"
                                                                || d.i_name === "7thAnimeXLB_v10" || d.i_name === "ourt_AI_Diffusion_XL_Anime_V2"
                                                                || d.i_name === "dall-e-3" || d.i_name === "imagen-3.0" || d.i_name === "imagen-4.0" || d.i_name === "sd3.5-large" || d.i_name === "sd3.5-large-turbo" || d.i_name === "flux-schnell"
                                                                || d.i_name === "holodayo-xl-2.1" || d.i_name === "kivotos-xl-2.0"
                                                                || d.i_name === "animaPencilXL_v500" || d.i_name === "coffewithlotus_2" || d.i_name === "ultra"
                                                                || d.i_name === "Illustrious-XL-v0.1"
                                                            ) && style
                                                        case "new":
                                                            return d.new && style
                                                        default:
                                                            return true && style
                                                    }
                                                    }).filter(d => {
                                                        if(modelSearchWord !== ""){
                                                            return d.name.toLowerCase().indexOf(modelSearchWord.toLowerCase()) !== -1
                                                        } else {
                                                            return true
                                                        }
                                                    }).map(d => {
                                                    return <div style={{position:"relative"}}>
                                                        <Badge bg={d.favorite === 1 ? 'warning' : 'secondary'} style={{position:"absolute",top:"15px",right:"15px",cursor:"pointer"}} onClick={() => favorite(d.id,!(d.favorite === 1))}>{d.favorite === 1 ? <Icon.StarFill /> : <Icon.Star />}</Badge>
                                                        <Badge bg={d.model_type === "SD1.5" ? 'secondary' : "primary"} style={{position:"absolute",top:"15px",left:"15px"}}>{d.model_type}</Badge>
                                                        <Badge bg={"primary"} style={{position:"absolute",top:"120px",right:"15px",cursor:"pointer"}}
                                                            onClick={() => {
                                                            setSdStyle(d.i_name);
                                                            setModelId(d.id);
                                                            setShowGenerateSamples(true)
                                                            setGenerateSamplesLoading(true)
                                                            getImage(sdStyle,modelId).then(r => {
                                                                if(r.result){
                                                                    if(r.data.length > 0){
                                                                        setImageList([].concat(r.data))
                                                                        setImageListReset(false)
                                                                    } else {
                                                                        setImageList([])
                                                                    }
                                                                } else {
                                                                    setImageList([])
                                                                    dialog("確認",r.errors)
                                                                }
                                                                setGenerateSamplesLoading(false)
                                                            })
                                                        }}
                                                        ><Icon.Images /></Badge>
                                                        <div style={{width:"150px",height:"150px",overflow:"hidden",borderRadius:"5px",cursor:"pointer",border:sdStyle === d.i_name ? "5px solid orange" : "none"}} className='m-1'>
                                                            <Image src={d.sample ? d.sample : "/img/"+d.img} style={{objectFit:"contain",width:"100%",height:"100%"}} onClick={() => {
                                                                setSdStyle(d.i_name);setModelId(d.id);
                                                            }} />
                                                        </div>
                                                        <p style={{width:"150px"}}>{d.sample ? d.model_name : ""} {d.name}</p>
                                                    </div>
                                                })}
                                            </div>
                                            <MuiButton variant='outlined' onClick={() => setShowModels(false)}>{t("common.close")}</MuiButton>
                                            <Button variant='warning' className="m-1 ai-proccessing-button"
                                            onClick={(e) => {
                                                if(serverWaitingStatus === 1){
                                                    generateCancelHandler(serverWaitingProcId)
                                                } else {
                                                    generateHandler(e,false,false)
                                                    setShowModels(false)
                                                }
                                            }}>
                                            {aiProccessing ? <><Spinner animation="border" size="sm" />&nbsp;{jpPromptTranslating ? t("common.translating") : t("upload.image.cancel")}</> : t("upload.image.generate")}&nbsp;{paymentMethod === "point" ? <><DiamondIcon style={{color:"blue"}} />&nbsp;{pointCost.toLocaleString()}</> : <>{Constants.CURRENCY_UNIT_LEFT_COIN}&nbsp;{coinCost.toLocaleString()}</>}
                                            {aiProccessing && generateProgress > 0 && (<><br /><ProgressBar className="ai-generate-progress" animated now={generateProgress} max={95} /></>)}
                                            </Button>
                                        </Container>
                                        } fullScreen={true} />)
                                    : ""}
                                    {generateZoom ? <div style={{height:"300px"}}><img id='generated-preview' style={{objectFit:"contain",width:"100%",height:"100%"}} /></div> : <Container className='d-none d-xl-block'>
                                        <p>Model</p>
                                        <CommonDialog content={<>
                                            <table>
                                                <tr><th>prompt</th><td className='p-1'>{recommendPrompt?.length > 0 ? <><MuiButton variant='outlined' onClick={() => {document.getElementById("sd-prompt").value += recommendPrompt;setShowModelRecommendedSettings(false)}}>追加</MuiButton></> : ""}</td></tr>
                                            </table>
                                        </>} open={showModelRecommendedSettings} onClose={() => setShowModelRecommendedSettings(false)} onClick={() => setShowModelRecommendedSettings(false)} />
                                        <Tooltip title="画像生成モデルを選択します。モデルによって画風や得意な構図が異なります。" arrow placement="top" enterDelay={300}>
                                        <div onClick={() => setShowModels(true)}
                                            style={{cursor:"pointer",border:"1px solid #AAAAAA",borderRadius:"5px"}} className='p-1'>
                                            <div style={{textAlign:"center"}}><b>{modelName}</b> <MuiButton onClick={() => setShowModels(true)}>モデル一覧</MuiButton>
                                            <MuiButton onClick={(e) => {e.stopPropagation(); setShowModelRecommendedSettings(true)}}>推奨設定</MuiButton>&nbsp;
                                            <MuiButton onClick={(e) => {e.stopPropagation();
                                                setShowGenerateSamples(true)
                                                setGenerateSamplesLoading(true)
                                                getImage(sdStyle,modelId).then(r => {
                                                    if(r.result){
                                                        if(r.data.length > 0){
                                                            setImageList([].concat(r.data))
                                                            setImageListReset(false)
                                                        } else {
                                                            setImageList([])
                                                        }
                                                    } else {
                                                        setImageList([])
                                                        dialog("確認",r.errors)
                                                    }
                                                    setGenerateSamplesLoading(false)
                                                })  
                                            }}>生成例</MuiButton>&nbsp;
                                            </div>
                                            <div className='d-flex'>
                                                <div className='d-flex'>
                                                    <div className='m-1'>
                                                        {modelImage === "" ? <Skeleton width={100} height={100} animation="wave" /> : <div style={{width:"100px",height:"100px",border:"1px solid #777777",borderRadius:"5px"}}><Image src={modelImage} style={{objectFit:"contain",width:"100%",height:"100%"}} /></div>}
                                                    </div>
                                                    <div className='m-1'>
                                                        {modelDescription}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </Tooltip>
                                        <CommonDialog open={showGenerateSamples} onClose={() => {setShowGenerateSamples(false);setImageList([])}} content={<>
                                            <MuiButton onClick={() => {setShowGenerateSamples(false);setImageList([])}}>閉じる</MuiButton>
                                            <h5 style={{borderBottom:"3px",display:"inline"}}>生成例</h5>
                                            <div className='d-flex flex-row justify-content-start flex-wrap w-100'
                                            style={{overflow:"auto"}}
                                            >
                                                {generateSamplesLoading ? <Spinner size='xl' /> : (
                                                    imageList.map((data,i) => {
                                                        if(data.mute === 1 || (i > 0 && imageList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                                                            return <span data-no={i} className="lazy" key={i}></span>
                                                        }
                                                        return <Thumb data={data} i={i} dialog={dialog} key={i} observer={observer} list={imageList.filter(d => d.mute === 0)} listName={"samples"} />
                                                    })
                                                )}
                                            </div>
                                        </>} fullScreen={true} />
                                        <div className='d-flex'>
                                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small" className='mt-3'>
                                                <InputLabel>{t("upload.image.resolution")}</InputLabel>
                                                <Select
                                                    value={sdResolution}
                                                    label={t("upload.image.resolution")}
                                                    onChange={(e) => setSdResolution(e.target.value)}
                                                >
                                                    {modelOptions.length > 0 && modelOptions.map((d,i) => {
                                                        if(d.width === undefined){
                                                            return <MenuItem key={i} value="" disabled>【{d.label}】</MenuItem>
                                                        } else {
                                                            return <MenuItem key={i} value={d.width+"x"+d.height} selected={d.width+"x"+d.height === sdResolution}>{d.width}x{d.height} {d.isFree && free ? "∞" : ""} {d.label}</MenuItem>
                                                        }
                                                    })}
                                                </Select>
                                            </FormControl>
                                            <div className='mb-1'>
                                                <Tooltip title="参考画像を土台に画像を生成します。" arrow placement='top' enterDelay={300}>
                                                <div className='justify-content-center m-2'
                                                    style={{display:img2ImgFile === undefined ? "none" : "flex",cursor:"pointer",border:"1px solid #AAAAAA",borderRadius:"5px"}}
                                                    onClick={() => {document.getElementById("img2img-file").click()}}>
                                                    <div style={{width:"45px",height:"45px",display:img2ImgFile === undefined ? "none" : "block",border:"1px solid #555555",cursor:"pointer"}}>
                                                        <Image className="img2img-thumb" style={{objectFit:"contain",width:"100%",height:"100%"}}
                                                            onClick={() => document.getElementById("img2img-file").click()}
                                                        />
                                                    </div>
                                                    <div style={{display:img2ImgFile === undefined ? "none" : "block"}}>
                                                        <CloseButton onClick={(e) => {
                                                            e.stopPropagation()
                                                            document.getElementById("img2img-file").value = ""
                                                            Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = "")
                                                            setImg2ImgFile()
                                                        }} />
                                                    </div>
                                                </div>
                                                </Tooltip>
                                                {img2ImgFile === undefined ? <Tooltip title="参考画像を土台に画像を生成します。" arrow placement='top' enterDelay={300}><MuiButton className='m-3 w-100' style={{fontSize:"12px"}} variant='outlined' onClick={() => {
                                                console.log(sdResolution,sdWidth,sdHeight)
                                                document.getElementById("img2img-file").click()
                                                }} disabled={modelType === "DALL-E3" || modelType === "GPT-Image-1" || modelType === "VertexAI" || modelType === "SD3" || modelType === "FLUX.1" || modelType == "Mid"}>画像を参照</MuiButton></Tooltip> : ""}
                                            </div>
                                            <Tooltip title={<>
                                                白黒の線画に色を付けます。色はプロンプトで指定します。<br />
                                                <img width={128} src="/img/color_before.webp" /> <img width={128} src="/img/color_after.webp" />
                                                </>}>
                                                <FormControlLabel style={{marginLeft:"20px"}} control={<Checkbox checked={useControlnet && modelType === "SDXL"} disabled={modelType !== "SDXL"} onChange={(d => setUseControlnet(d.target.checked))} />} label={<span style={{fontSize:"12px"}}>彩色</span>} />
                                            </Tooltip>
                                            <FormControlLabel style={{marginLeft:"20px"}} control={<Checkbox checked={isFastMode && fastModeVer !== 0} disabled={fastModeVer === 0} onChange={(d => setIsFastMode(d.target.checked))} />} label={<span style={{fontSize:"12px"}}>高速化</span>} />
                                            {loginInfo.result && loginInfo.age18 === 1 ? (<>
                                                <Tooltip title={<>NGワードなしで生成できるモードです。特定の条件を満たしている場合利用できます。条件は定期的に見直されます。また、サブスク対象外です。<br />
                                                SMS認証かつ、身分証確認またはWorld ID認証が必要です。
                                                <br /><br />
                                                生成されたコンテンツについてガイドラインにおいて本サービスに投稿するにあたりモザイク等の隠蔽処理が必要な場合はモザイク等の処理を行ってください。<br />
                                                フル版は特定のモデルのみ対応しています。
                                                </>}>
                                                    <FormControlLabel style={{marginLeft:"20px"}} control={<Checkbox checked={isFullMode && modelFullModeEnable !== 0} disabled={modelFullModeEnable === 0} onChange={(d => setIsFullMode(d.target.checked))} />} label={<span style={{fontSize:"12px"}}>フル版</span>} />
                                                </Tooltip>
                                            </>
                                            ) : ""}
                                        </div>
                                    </Container>}
                                    <Container>
                                        <span style={{fontWeight:"bold",fontSize:"22px"}}>{t("category.generatedHistory")}</span>
                                        &nbsp;(保存期間 <span style={{fontWeight:"bold",fontSize:"20px",color:loginInfo.plan === "" || loginInfo.plan === "basic" ? "black" : "blue"}}>{loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? 30 : (loginInfo.plan === "certification" ? 7 : 3)}</span>日)
                                        &nbsp;<Tooltip title="サブスクに加入して保存期間を増やせます。またプレミアムプラスプランで生成回数が無制限になります。" arrow><Icon.PlusCircle style={{color:"blue",fontSize:"18px",cursor:"pointer"}} onClick={() => planDialog(dialog)} /></Tooltip>
                                    </Container>
                                    <Container>
                                        <Tooltip title="選択した画像を削除します。" arrow>
                                        <IconButton
                                        onClick={() => {
                                            let list = []
                                            document.querySelectorAll(".delete-check").forEach(input => {
                                                if(input !== undefined && input.checked){
                                                    list.push(input.dataset.proc_id)
                                                }
                                            })
                                            if(list.length > 0)
                                            deleteAIGeneraleImageFile(list).then(r => {
                                                if(r.result){
                                                    setAIGenerateReset(!aiGenerateReset)
                                                    setAIGenerateImagePage(1)
                                                    dialog("確認","削除しました。")
                                                    document.querySelectorAll(".delete-check").forEach(input => {
                                                        if(input !== undefined && input.checked){
                                                            input.checked = false
                                                            input.parentNode.parentNode.style.border = "3px solid #FFFFFF"
                                                            input.parentNode.parentNode.style.backgroundColor = "rgba(255,255,255,0)"
                                                        }
                                                    })
                                                    setDeleteCheckCount(0)
                                                } else {
                                                    dialog(t("common.error"),r.errors)
                                                }
                                            })
                                        }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                        </Tooltip>
                                        &nbsp;
                                        <Tooltip title="選択した画像をzipファイルにまとめてダウンロードします。" arrow>
                                        {!dlImages ? (
                                        <IconButton
                                        style={{cursor:"pointer"}}
                                            onClick={() => {
                                                setDLImages(true)
                                                let list = []
                                                document.querySelectorAll(".delete-check").forEach(input => {
                                                    if(input !== undefined && input.checked){
                                                        list.push(input.dataset.proc_id)
                                                        input.parentNode.parentNode.style.border = "3px solid #FFFFFF"
                                                        input.parentNode.parentNode.style.backgroundColor = "rgba(255,255,255,0)"
                                                    }
                                                })
                                                if(list.length === 0){
                                                    setDLImages(false)
                                                    return
                                                }
                                                createZipFile(list).then(r => {
                                                    if(r.result){
                                                        existZipFile().then(r => {
                                                            if(r.result){
                                                                const a = document.createElement("a")
                                                                a.download = "images.zip"
                                                                a.href = ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/dl"
                                                                document.body.appendChild(a)
                                                                a.click()
                                                                a.remove()
                                                            } else {
                                                                dialog("確認","zipファイルが存在しません。")
                                                            }
                                                            setDLImages(false)
                                                            document.querySelectorAll(".delete-check").forEach(input => {
                                                                if(input !== undefined && input.checked){
                                                                    input.checked = false
                                                                }
                                                            })
                                                            setDeleteCheckCount(0)
                                                        })
                                                    } else {
                                                        setDLImages(false)
                                                        dialog(t("common.error"),r.errors)
                                                    }
                                                })
                                            }}>
                                            <Icon.Download style={{fontSize:"24px"}}/>
                                        </IconButton>
                                        ) : <IconButton><Spinner size='sm' style={{verticalAlign:"middle"}} />&nbsp;<Icon.Download style={{fontSize:"24px"}}/></IconButton>}
                                        </Tooltip>

                                        <PopupState variant="popover">
                                        {(popupState) => (
                                            <div className="d-inline">
                                            <IconButton {...bindTrigger(popupState)}>
                                                <MoreHorizIcon />
                                            </IconButton>
                                            <Popover
                                                {...bindPopover(popupState)}
                                                anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'center',
                                                }}
                                                transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                                }}
                                            >
                                                <div className='p-3'>
                                                    サイズ<br />
                                                    <Slider style={{width:"100px"}} onChange={(e) => {
                                                        setGenerateImageListCols(e.target.value)
                                                    }} value={generateImageListCols} min={1} max={5} aria-label="Default" />
                                                </div>
                                            </Popover>
                                            </div>
                                        )}
                                        </PopupState>
                                        {deleteCheckCount > 0 ? <Chip variant='outlined' onClick={() => {
                                            let count = 0
                                            document.querySelectorAll(".delete-check").forEach(input => {
                                                if(input !== undefined){
                                                    input.checked = !selectMode
                                                    count++
                                                    input.parentNode.parentNode.style.border = !input.checked ? "3px solid #FFFFFF" : "3px solid #A68F8D"
                                                    input.parentNode.parentNode.style.backgroundColor = !input.checked ? "rgba(255,255,255,0)" : "rgba(255,255,255,0.5)"
                                                }
                                            })
                                            if(!selectMode){
                                                setDeleteCheckCount(count)
                                                setSelectMode(aiGenerateImageList.length == count && count > 0)
                                                console.log(aiGenerateImageList.length,count)
                                            } else {
                                                // 解除押した後
                                                setDeleteCheckCount(0)
                                            }
                                        }} label={!selectMode ? "すべて選択" : "すべて解除"} /> : ""}
                                        <Tooltip title="マウスオーバーでプレビューします。" arrow>
                                            <MuiToggleButtonGroup exclusive value={generateZoom} onChange={(e,n) => setGenerateZoom(n)} style={{marginLeft:"10px"}}>
                                                <MuiToggleButton value={true}>
                                                    <Icon.ZoomIn />{generateZoom ? <Icon.CheckLg /> : ""}
                                                </MuiToggleButton>
                                            </MuiToggleButtonGroup>
                                        </Tooltip>

                                        <Tooltip title={<>現在の設定<br /><span style={{fontSize:"14px"}}>sampler: {sdSampler}<br />upscaler: {sdUpscaler}</span></>}>
                                            <IconButton onClick={() => setGenerateSettingShow(true)} style={{marginLeft:"10px"}}>
                                                <Icon.GearFill />
                                            </IconButton>
                                        </Tooltip>
                                        <CommonDialog title="詳細設定" open={generateSettingShow} content={
                                            <>
                                                <div className='m-1'>
                                                    <span>sampler</span>
                                                    <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("samplerとは",
                                                        <span>生成される画像に影響します、鮮やかさや出力される絵の特徴などが変化します。</span>)} />    
                                                    <Form.Select disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "FLUX.1" || modelType === "SD3" || modelType === "Mid"} className="mb-3 sd-sampler" value={sdSampler} onChange={(e) => {
                                                        setSdSampler(e.currentTarget.value)
                                                    }}>
                                                    {isFastMode ? samplers.filter(d => isFastSampler(d.name,fastModeVer)).map((s,i) => {
                                                        return <option value={s.name} key={i}>{s.name}{s.memo.length > 0 ? "："+s.memo : ""}</option>
                                                    }) : samplers.map((s,i) => {
                                                        if(img2ImgFile !== undefined && (s.name.startsWith("PLMS") || s.name.startsWith("UniPC")) || sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "FLUX.1" || modelType === "SD3" || modelType === "Mid") return ""
                                                        return <option value={s.name} key={i}>{s.name}{s.memo.length > 0 ? "："+s.memo : ""}</option>
                                                    })}
                                                    </Form.Select>
                                                </div>
                                                <div>
                                                    <span>upscaler</span>
                                                    <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("upscalerとは",
                                                        <span>高解像度の生成時に使用します。出力される絵の特徴などが変化します。</span>)} />
                                                    <Form.Select disabled={sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3" || modelType === "FLUX.1" || modelType === "SD3" || modelType === "Mid"} className="mb-3 sd-sampler" value={sdUpscaler} onChange={(e) => {
                                                        setSdUpscaler(e.currentTarget.value)
                                                    }}>
                                                    {upscalers.map((s,i) => {
                                                        if(sdStyle === "dall-e-3" || sdStyle === "imagen-3.0" || sdStyle === "imagen-4.0" || sdStyle === "nai-diffusion-3"  || modelType === "FLUX.1" || modelType === "SD3" || modelType === "Mid") return ""
                                                        return <option value={s.name} key={i}>{s.name}{s.memo.length > 0 ? "："+s.memo : ""}</option>
                                                    })}
                                                    </Form.Select>
                                                </div>
                                            </>
                                        } onClick={() => {

                                        }} onClose={() => {
                                            setGenerateSettingShow(false)
                                        }} />
                                    </Container>
                                    {showGeneratedInfo ? (
                                    <CommonDialog open={showGeneratedInfo} onClose={() => {
                                        setShowGeneratedInfo(false)
                                    }} content={
                                        <Container>
                                            <div>
                                                <Button className='m-1' style={{float:"left"}} variant='outline-secondary' onClick={() => setShowGeneratedInfo(false)}>{t("common.close")}</Button>
                                                <div style={{float:"right"}}>
                                                    <Button className='m-1' variant='outline-secondary' onClick={() => {
                                                        setGeneratedInfo(aiGenerateImageList[generatedImageIndex-1])
                                                        setGeneratedImageIndex(generatedImageIndex-1)
                                                    }}>{t("common.prev")}</Button>
                                                    <Button className='m-1' variant='outline-secondary' onClick={() => {
                                                        setGeneratedInfo(aiGenerateImageList[generatedImageIndex+1])
                                                        setGeneratedImageIndex(generatedImageIndex+1)
                                                    }}>{t("common.next")}</Button>
                                                </div>
                                            </div>
                                            <div className='text-center m-2 d-flex flex-wrap' style={{clear:"both"}}>
                                            {[...Array(generatedInfo.count)].map((d,i) => {
                                                let extNo = i === 0 ? "" : "-"+(i+1)
                                                return (
                                                    <div style={{
                                                        position: 'relative', 
                                                        width: generatedInfo.count > 1 ? '50%' : '100%'
                                                    }}>
                                                        {generatedInfo.count > 1 ? (
                                                        <Chip label={i+1} color='primary' style={{
                                                            position: 'absolute',
                                                            top: '5px',
                                                            left: '5px',
                                                            padding: '2px 6px',
                                                            borderRadius: '3px',
                                                            zIndex: 1
                                                        }} />
                                                        ) : ""}
                                                        <Image
                                                            width="100%"
                                                            style={{cursor:"pointer"}}
                                                            src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+generatedInfo.proc_id+"/1/"+i}
                                                            onClick={() => {
                                                                setPreviewSource(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+generatedInfo.proc_id+"/1/"+i)
                                                                setPreviewFlg(true)
                                                            }}
                                                        />
                                                    </div>
                                                )
                                            })}
                                            </div>
                                            {loginInfo.plan === "" ? <Link to={"/legal"}><Alert severity='info'>サブスクに加入してロゴを削除</Alert></Link> : ""}
                                            <Container>
                                                {generatedInfo.create_datetime}<br />
                                                {generatedInfo.random_src === "gacha" && generatedInfo.prompt_public === 0 ? <>プロンプト非公開<br /></> : 
                                                    <>
                                                    prompt:<br />{generatedInfo.prompt}<br /><br />
                                                    negative prompt:<br />{generatedInfo.negative_prompt}<br /><br />
                                                    </>
                                                }
                                                steps: {generatedInfo.steps} scale: {generatedInfo.cfg_scale} denoising_strength: {generatedInfo.denoising_strength} seed: {generatedInfo.real_seed === "" ? generatedInfo.seed : generatedInfo.real_seed}<br />
                                                sampler: {generatedInfo.sampler}<br />
                                                Hires.fix: {generatedInfo.enable_hr === 1 ? "Yes" : "No"}<br />
                                                Hires Upscaler: {generatedInfo.enable_hr === 1 ? generatedInfo.hr_upscaler : ""}<br />
                                                resolution: {(generatedInfo.enable_hr === 1 ? generatedInfo.width * parseInt(generatedInfo.hr_scale) : generatedInfo.width) * (generatedInfo.extra === 1 && generatedInfo.mode !== "extraBatchImages" ? 2 : 1)}x{(generatedInfo.enable_hr === 1 ? generatedInfo.height * parseInt(generatedInfo.hr_scale) : generatedInfo.height) * (generatedInfo.extra === 1 && generatedInfo.mode !== "extraBatchImages" ? 2 : 1)}<br />
                                                mode: {generatedInfo.mode === "extraBatchImages" ? "画像拡大" : generatedInfo.mode}<br />
                                                model: {generatedInfo?.model_name || generatedInfo.sd_model_checkpoint}<br />
                                                VAE: {generatedInfo.sd_vae}<br />
                                                inpaint: {generatedInfo.inpaint === 1 ? "Yes" : "No"}<br />
                                                画像拡大: {generatedInfo.extra === 1 ? "Yes" : "No"}<br />
                                                彩色: {generatedInfo.controlnet_module === 'lineart_anime_denoise' ? "Yes" : "No"}<br />
                                                フル版: {generatedInfo.full === 1 ? "Yes" : "No"}<br />
                                                server: {generatedInfo.server_id}
                                                <Container className='text-center'>
                                                    <MuiButton  variant='outlined' className='m-1'
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        getAIGeneraleImageFile(generatedInfo.proc_id).then(r => {
                                                            if(r.result){
                                                                if(fileList.length === 0){
                                                                    let imgs = r.data.img.map(img => {
                                                                        return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                                                                    })
                                                                    imageSet(imgs,true,r.data)
                                                                } else {
                                                                    let imgs = r.data.img.map(img => {
                                                                        return base64ToFile(img.replace(/^.*,/, ''),generatedInfo.proc_id + ".png","image/png")
                                                                    })
                                                                    imageAdd(imgs,true,r.data)
                                                                }
                                                                dialog(t("common.info"),"投稿画面の画像一覧に追加しました。左上の「閉じる」から投稿画面に移動できます。また、投稿画面の「生成履歴から選択」ボタンからも選択できます。")
                                                                setShowGeneratedInfo(false)
                                                            } else {
                                                                dialog("",r.errors)
                                                            }
                                                        })
                                                    }}
                                                    >
                                                        <Icon.PlusCircleFill style={{fontSize:"24px",cursor:"pointer"}} />
                                                        &nbsp;投稿
                                                    </MuiButton>
                                                    <Tooltip title="生成情報を復元します。" arrow>
                                                    {[...Array(generatedInfo.count)].map((d,i) => {
                                                        let extNo = generatedInfo.count === 1 ? ""  : ""+(i+1)+""
                                                        return <MuiButton variant='outlined' className='m-1' onClick={() => {
                                                            //navigator.clipboard.writeText(data.real_seed)
                                                            document.querySelector("#sd-prompt").value = generatedInfo.prompt
                                                            document.querySelector("#sd-negative-prompt").value = generatedInfo.negative_prompt
                                                            if(generatedInfo.real_seed !== ""){
                                                                let seed = generatedInfo.real_seed.replace("[","").replace("]","").split(",")[i]
                                                                document.querySelector("#sd-seed").value = seed
                                                                setSdSeed(seed)
                                                            }
                                                            setQualityTags(false)
                                                            dialog("確認","プロンプトを反映しました。")
                                                            setShowGeneratedInfo(false)
                                                        }}><AssignmentReturnIcon />{extNo}</MuiButton>
                                                    })}
                                                    </Tooltip>
                                                    {generatedInfo.count > 1 ? <br /> : ""}
                                                    <Tooltip title="参考画像に設定して、生成情報を復元します。" arrow>
                                                    {[...Array(generatedInfo.count)].map((d,i) => {
                                                        let label = generatedInfo.count === 1 ? ""  : ""+(i+1)
                                                        let extNo = i === 0 ? ""  : "-"+(i+1)
                                                        return <MuiButton
                                                        variant='outlined'
                                                        className='m-1'
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            getAIGeneraleImageFile(generatedInfo.proc_id).then(r => {
                                                                if(r.result){
                                                                    let base64 = r.data.img[i].replace(/^.*,/, '')
                                                                    let file = base64ToFile(base64,generatedInfo.proc_id + extNo + ".png","image/png")
                                                                    ImageUtil.load(undefined,file,0,(data1,data2,base64) => {
                                                                        document.querySelector("#sd-prompt").value = generatedInfo.prompt
                                                                        document.querySelector("#sd-negative-prompt").value = generatedInfo.negative_prompt
                                                                        setQualityTags(false)

                                                                        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = data1)
                                                                        setImg2ImgFile(base64)
                                                                        setShowGeneratedInfo(false)
                                                                        setShowI2ICropper(true)
                                                                    })
                                                                }
                                                            })
                                                        }}><AssignmentReturnIcon /><Icon.Image />{label}</MuiButton>
                                                    })}
                                                    </Tooltip>
                                                    {generatedInfo.count > 1 ? <br /> : ""}
                                                    <Tooltip title="画像を拡大します。" arrow>
                                                    {[...Array(generatedInfo.count)].map((d,i) => {
                                                        let label = generatedInfo.count === 1 ? ""  : ""+(i+1)
                                                        let extNo = i === 0 ? ""  : "-"+(i+1)
                                                        return <MuiButton
                                                        variant='outlined'
                                                        className='m-1'
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            getAIGeneraleImageFile(generatedInfo.proc_id).then(r => {
                                                                if(r.result){
                                                                    let base64 = r.data.img[i].replace(/^.*,/, '')
                                                                    let file = base64ToFile(base64,generatedInfo.proc_id + extNo + ".png","image/png")
                                                                    ImageUtil.load(undefined,file,0,(data1,data2,base64) => {
                                                                        document.querySelector("#sd-prompt").value = generatedInfo.prompt
                                                                        document.querySelector("#sd-negative-prompt").value = generatedInfo.negative_prompt
                                                                        setQualityTags(false)

                                                                        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = data1)
                                                                        setImg2ImgFile(base64)
                                                                        setShowGeneratedInfo(false)
                                                                        setShowI2ICropper(false)
                                                                        setGenerateTabKey("extra")
                                                                        let img = document.createElement("img")
                                                                        img.onload = () => {
                                                                            setSelectedImageWidth(img.naturalWidth)
                                                                            setSelectedImageHeight(img.naturalHeight)
                                                                            console.log("読込後",img.naturalWidth,img.naturalHeight)
                                                                            img.remove()
                                                                        }
                                                                        img.src = base64
                                                                    })
                                                                }
                                                            })
                                                        }}><AspectRatioIcon />{label}</MuiButton>
                                                    })}
                                                    </Tooltip>
                                                    {generatedInfo.count > 1 ? <br /> : ""}
                                                    <Tooltip title="画像の一部を修正します(Inpaint)。" arrow>
                                                    {[...Array(generatedInfo.count)].map((d,i) => {
                                                        let label = generatedInfo.count === 1 ? ""  : ""+(i+1)
                                                        let extNo = i === 0 ? ""  : "-"+(i+1)
                                                        return <MuiButton
                                                        variant='outlined'
                                                        className='m-1'
                                                        onClick={(e) => {
                                                            e.target.disabled = true
                                                            e.stopPropagation()
                                                            getAIGeneraleImageFile(generatedInfo.proc_id).then(r => {
                                                                if(r.result){
                                                                    let base64 = r.data.img[i].replace(/^.*,/, '')
                                                                    let file = base64ToFile(base64,generatedInfo.proc_id + extNo + ".png","image/png")
                                                                    ImageUtil.load(undefined,file,0,(data1,data2,base64) => {
                                                                        setInpaintFile(base64)
                                                                        setShowGeneratedInfo(false)
                                                                        setShowI2ICropper(false)
                                                                        setGenerateTabKey("extra")
                                                                    })
                                                                }
                                                                e.target.disabled = false
                                                            })
                                                        }}><Icon.Mask />&nbsp;一部修正&nbsp;{label}</MuiButton>
                                                    })}
                                                    </Tooltip>
                                                    {generatedInfo.count > 1 ? <br /> : ""}
                                                    <Tooltip title="共有リンクをコピーします。" arrow>
                                                    <MuiButton
                                                        variant='outlined' className='m-1 p-1' onClick={() => {
                                                        createShareId(generatedInfo.proc_id).then(r => {
                                                            if(r.result){
                                                                navigator.clipboard.writeText("https://ourt-ai.work/upload/image/generate?sid="+r.data.share_id)
                                                                dialog(t("common.info"),"共有リンクをクリップボードにコピーしました。")
                                                            } else {
                                                                dialog(t("common.error"),r.errors)
                                                            }
                                                            setShowGeneratedInfo(false)
                                                        })
                                                    }}><Icon.Share /></MuiButton>
                                                    </Tooltip>
                                                    {generatedInfo.count > 1 ? <br /> : ""}
                                                    {loginInfo.plan != "" || generatedInfo.use_coin > 0 ? (<>
                                                    {[...Array(generatedInfo.count)].map((d,i) => {
                                                        let label = generatedInfo.count === 1 ? ""  : ""+(i+1)
                                                        let extNo = i === 0 ? ""  : "-"+(i+1)
                                                        return <Chip bg="secondary" className='m-1' label={
                                                            // ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+generatedInfo.mode+(generatedInfo.inpaint === 1 ? "_inpaint" : "")+'/'+(generatedInfo.proc_id)+extNo+".png"
                                                            <a href={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+generatedInfo.proc_id+"/3/"+i} download={"ourt-ai.work_"+generatedInfo.proc_id+"_"+(i+1)+".png"} style={{textDecoration:"none",display:"block"}}>
                                                                <Icon.CloudDownloadFill style={{fontSize:"24px"}} onClick={(e) => e.stopPropagation()} /> PNG{label}
                                                            </a>} />
                                                    })}
                                                    </>) : (<>
                                                        {[...Array(generatedInfo.count)].map((d,i) => {
                                                        let label = generatedInfo.count === 1 ? ""  : ""+(i+1)
                                                        return <Tooltip title="サブスクプランに加入してPNGファイルをダウンロード" arrow><Chip bg="secondary" className='m-1' label={
                                                                <Link to={"/legal"} style={{color:"#CCCCCC"}}><Icon.CloudDownloadFill style={{fontSize:"24px"}}/> PNG{label}</Link>
                                                            } /></Tooltip>
                                                        })}
                                                    </>)}
                                                    {generatedInfo.count > 1 ? <br /> : ""}
                                                    {[...Array(generatedInfo.count)].map((d,i) => {
                                                        let label = generatedInfo.count === 1 ? ""  : ""+(i+1)
                                                        let extNo = i === 0 ? ""  : "-"+(i+1)
                                                        return <Chip bg="secondary" className='m-1' label={
                                                            <a href={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+generatedInfo.proc_id+"/0/"+i} download={"ourt-ai.work_"+generatedInfo.proc_id+"_"+(i+1)+".jpg"} style={{textDecoration:"none",display:"block"}}>
                                                                <Icon.CloudDownloadFill style={{fontSize:"24px"}} onClick={(e) => e.stopPropagation()} /> JPG{label}
                                                            </a>} />
                                                    })}
                                                </Container>
                                                {generatedInfo.src_group_id !== undefined && generatedInfo.src_group_id !== "" ? <Container>
                                                    <p style={{fontWeight:"bold",borderBottom:"3px solid #555555"}}>参考元の{generatedInfo.random_src === "gacha" ? "キャラクター" : "作品"}</p>
                                                    {generatedInfo.random_src === "gacha" ? <div className='d-flex justify-content-center'><CharacterProfileCard data={{group_id:generatedInfo.src_group_id,user_id:"",character_name:generatedInfo.character_name,character_name_kana:generatedInfo.character_name_kana}} /></div> : <Thumb data={{group_id:generatedInfo.src_group_id,id:generatedInfo.src_detail_id,favorite:generatedInfo.src_favorite}} dialog={dialog} />}
                                                    {generatedInfo.src_title}
                                                </Container>
                                                : ""}
                                                {generatedInfo.mode !== undefined && generatedInfo.mode === "img2img" ? <Container>
                                                    <p style={{fontWeight:"bold",borderBottom:"3px solid #555555"}}>参考画像</p>
                                                    <img width={"100%"} src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageBaseDirect/"+generatedInfo.proc_id} />
                                                </Container>
                                                : ""}
                                            </Container>
                                        </Container>
                                    } fullScreen={false} />
                                    ) : ""}
                                    <div style={{height:window.innerHeight,overflow:"auto",marginBottom:"200px"}}>
                                        <ImageList
                                        sx={{ width: "100%", height: generatedImageListHeight }}
                                        variant="quilted"
                                        cols={generateImageListCols}
                                        gap={8}
                                        id="generated-image-list"
                                        >
                                        {aiGenerateImageList.map((data,i) => (
                                            <ImageListItem key={i} style={{position:"relative"}}>
                                                <Container style={{position:"absolute",width:"100%",height:"100%",zIndex:1,cursor:"pointer",border:data.status === 6 || data.status === 7 ? "3px solid #FF0000" : "3px solid #FFFFFF"}} id={data.proc_id+"-generate-thumb-image"}
                                                    onMouseOver={(e) => {
                                                        document.querySelectorAll(".default-hidden").forEach(d => {
                                                            d.style.opacity = 1
                                                            d.style.transition = "0.2s"
                                                        })
                                                        if(generateZoom){
                                                            document.getElementById("generated-preview").src = document.getElementById("generated-"+data.proc_id).src
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        document.querySelectorAll(".default-hidden").forEach(d => {
                                                            let input = d.getElementsByTagName("input")[0]
                                                            if(input === undefined || (input !== undefined && !input.checked)){
                                                                d.style.opacity = 0
                                                                d.style.transition = "0.2s"
                                                            }
                                                        })
                                                    }}
                                                    onClick={(e) => {
                                                        let count = 0
                                                        document.querySelectorAll(".delete-check").forEach(input => {
                                                            if(input !== undefined && input.checked){
                                                                count++
                                                            }
                                                        })
                                                        setDeleteCheckCount(count)
                                                        setSelectMode(aiGenerateImageList.length == count)
                                                        if(count > 0){
                                                            let checked = e.currentTarget.getElementsByTagName("input")[0].checked
                                                            e.currentTarget.getElementsByTagName("input")[0].checked = !checked
                                                            e.currentTarget.style.border = checked ? "3px solid #FFFFFF" : "3px solid #A68F8D"
                                                            e.currentTarget.style.backgroundColor = checked ? "rgba(255,255,255,0)" : "rgba(255,255,255,0.5)"
                                                        } else {
                                                            setShowGeneratedInfo(true)
                                                            setGeneratedInfo(data)
                                                            setGeneratedImageIndex(i)
                                                        }
                                                    }}
                                                    >
                                                        <Container>
                                                            <input type="checkbox" className="delete-check"  onClick={(e) => {
                                                                e.stopPropagation()
                                                                let count = 0
                                                                document.querySelectorAll(".delete-check").forEach(input => {
                                                                    if(input !== undefined && input.checked){
                                                                        count++
                                                                    }
                                                                })
                                                                e.currentTarget.parentNode.parentNode.style.border = !e.target.checked ? "3px solid #FFFFFF" : "3px solid #A68F8D"
                                                                e.currentTarget.parentNode.parentNode.style.backgroundColor = !e.target.checked ? "rgba(255,255,255,0)" : "rgba(255,255,255,0.5)"
                                                                setDeleteCheckCount(count)
                                                                setSelectMode(aiGenerateImageList.length == count && count > 0)
                                                            }}
                                                            style={{position:"absolute",zIndex:"1",width:"32px",height:"32px",top:"10px",right:"10px",cursor:"pointer"}}
                                                            defaultChecked={0} data-proc_id={data.proc_id} />
                                                            <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"10px",right:"10px"}}>
                                                                {data.count > 1 ? <><Icon.Images style={{fontSize:"24px",color:"#EEEEEE"}} />&nbsp;</> : ""}
                                                                <Icon.InfoCircle style={{fontSize:"24px",color:"#EEEEEE",cursor:"pointer"}} onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    setShowGeneratedInfo(true)
                                                                    setGeneratedInfo(data)
                                                                    setGeneratedImageIndex(i)
                                                                }} />
                                                            </Badge>
                                                        </Container>
                                                    </Container>
                                                <img
                                                    className='lazy'
                                                    //src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+data.mode+(data.inpaint === 1 ? "_inpaint" : "")+'/'+(data.proc_id)+ApiFetch.API_THUMB_EXT}
                                                    src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/2/"+0}
                                                    alt={data.proc_id}
                                                    data-no={i} data-type="generate" loading="lazy"
                                                    id={"generated-"+data.proc_id}
                                                />
                                            </ImageListItem>
                                        ))}
                                        </ImageList>
                                    </div>
                                </Col>
                            </Row>
                            </div>
                        </Col>
                    </Row>
                    <hr />
                    <div style={{position:"fixed",top:window ? window.innerHeight / 2 : 0,zIndex:2,display:loginInfo.upload_left_bar_display_flag === 2 || param.generate === "generate" ? "none" : "block"}}>
                        <ButtonGroup vertical>
                            <Button className='p-1' variant='secondary' onClick={() => window.scrollTo({top:0,left:0,behavior:"instant"})}>TOP</Button>
                            <Button className='p-1' variant={title !== "" ? 'success' : 'secondary'} onClick={() => moveTo("#title")}>タイトル</Button>
                            <Button className='p-1' variant={styleOfPainting !== "" ? 'success' : 'secondary'} onClick={() => moveTo("#style-of-painting")}>画風</Button>
                            <Button className='p-1' variant={(ageLimit === "1" && (sexualExpression === "1" || sexualExpression === "2")) || ageLimit === "2" || ageLimit === "3" || ageLimit === "4" ? 'success' : 'secondary'} onClick={() => moveTo("#age-limit")}>年齢制限</Button>
                            <Button className='p-1' variant={'secondary'} onClick={() => moveTo("#event")}>イベント</Button>
                            <Button className='p-1' variant={uploadReady ? 'danger' : 'secondary'} onClick={() => uploadHandler()} disabled={uploading}>投稿</Button>
                        </ButtonGroup>
                    </div>
                    <Row className={param.generate === "generate" ? 'd-none' : ""}>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <h5>②{t("upload.image.info")}</h5>
                            <PostLimit />
                            <div style={{display:"block"}}>
                                <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                    <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={promptInfoPublication} id="prompt-info-publication" onChange={(e) => {
                                        setPromptInfoPublication(e.currentTarget.checked)
                                    }} />
                                    <Form.Control type="text" value={t("upload.image.public")} readOnly />
                                </InputGroup>
                            </div>
                        </Col>
                        <Col xs={6} sm={5} md={6} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:"none"}}>
                            <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                <InputGroup.Checkbox style={{cursor:"pointer"}} id="batch" onChange={(e) => {
                                        if(e.currentTarget.checked){
                                            setBatchMode(true)
                                            //setUseFilename(true)
                                        } else {
                                            setBatchMode(false)
                                            //document.getElementById("title").removeAttribute("disabled")
                                            //document.getElementById("title").value = ""
                                        }
                                    }} />
                                <Form.Control type="text" value={t("upload.image.batchPosting")} readOnly />
                                <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("一括投稿とは",
                                <span >複数選択したファイルを1ファイル1投稿として連続で投稿できる機能です。<br />
                                一つ一つ投稿する手間を省きます。<br />
                                タイトルや概要などは入力したものがすべての投稿に設定されます。<br />
                                一括投稿を使用しない場合は、複数枚が1ページにまとめて投稿されます。</span>)} />
                            </InputGroup>
                        </Col>
                        <Col xs={6} sm={7} md={6} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            {false && batchMode ? (
                            <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                <InputGroup.Checkbox style={{cursor:"pointer",}} id="use_filename" onChange={(e) => {
                                        if(e.currentTarget.checked){
                                            setUseFilename(true)
                                            document.getElementById("title").setAttribute("disabled",e.currentTarget.checked)
                                            document.getElementById("title").value = "<ファイル名が設定されます>"
                                        } else {
                                            setUseFilename(false)
                                            document.getElementById("title").removeAttribute("disabled")
                                            document.getElementById("title").value = ""
                                        }
                                    }} />
                                <Form.Control type="text" style={{fontSize:"12px"}} defaultValue={"タイトルにファイル名を使用する"} readOnly />
                            </InputGroup>
                            ) : ""}
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="title" label={<><span className='required'>必須</span> {t("upload.image.imageTitle")}</>} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" 
                                        onChange={(e) => setTitle(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                            </Col>
                            {showQuestionnairePopup ? (
                                <Questionnaire
                                    switch={setShowQuestionnairePopup}
                                    onSave={setQuestionInfo}
                                    options={questionInfo === undefined ? [] : questionInfo.options}
                                    deadlineDate={questionInfo === undefined ? "" : questionInfo.deadlineDate}
                                    deadlineTime={questionInfo === undefined ? "" : questionInfo.deadlineTime}
                                />
                            ) : ""}
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"10px auto"}} id="style-of-painting">
                                <p className='d-inline '><span className='required'>必須</span> {t("upload.image.styleOfPainting")} </p>
                                <ButtonGroup>
                                    {styles.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`style-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="style-radio"
                                            value={radio.value}
                                            checked={styleOfPainting === radio.value}
                                            onChange={(e) => {
                                                setStyleOfPainting(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto"}} id="age-limit">
                                <p className='d-inline '><span className='required'>必須</span> {t("upload.image.ageLimit")} </p>
                                   <ButtonGroup>
                                    {nenrei.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`age-limit-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="radio"
                                            value={radio.value}
                                            checked={ageLimit === radio.value}
                                            onChange={(e) => {
                                                if(e.currentTarget.value === "3" || e.currentTarget.value === "4" || e.currentTarget.value === "5"){
                                                    setSexualExpression("")
                                                }
                                                if(e.currentTarget.value === "1"){
                                                    setSexualExpression("")
                                                }
                                                if(e.currentTarget.value === "2"){
                                                    setSexualExpression("1")
                                                }
                                                setAgeLimit(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                                {(ageLimit === "3" || ageLimit === "4" || ageLimit === "5") && 
                                <Container className='mt-3'>
                                    {t("upload.image.mosaic0")}<br /><br />
                                    <strong>{t("upload.image.mosaic1")}</strong><br />
                                    {t("upload.image.mosaic2")}<br />
                                    {t("upload.image.mosaic3")}<br />
                                    <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/1.png"} width="300px" style={{border:"1px solid #CCCCCC"}} />
                                    <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/2.png"} width="300px" style={{marginLeft:"10px",border:"1px solid #CCCCCC"}} />
                                </Container>}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto",display:ageLimit === "1" ? "block" : "none"}}>
                                <p className='d-inline'><span className='required'>必須</span> {t("upload.image.whatIsSexual")} </p>
                                <ButtonGroup>
                                    {yesOrNoRadio.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`sexual-expression-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="sexual-radio"
                                            value={radio.value}
                                            checked={sexualExpression === radio.value}
                                            onChange={(e) => {
                                                if(e.currentTarget.value === "1"){
                                                    setAgeLimit("2")
                                                }
                                                setSexualExpression(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                                <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("PG12とは ",
                                        <p>
                                            ■性的表現(軽微なものを含む) 
                                            性的なものを想起させる、接吻、抱擁・下着の露出など。
                                            性行為や類似する動作を連想させる表現や表情。
                                            胸や谷間、乳首、臀部、股間等の強調や際どい表現や構図。
                                            極端に面積の少ない衣類や水着を身に着けた人物の描画や、
                                            露出度の非常に高い人物の描写、透けた衣服を身に着けた人物の描写や全裸等。<br />
                                            ■その他刺激的な表現
                                            軽微な創傷や流血、薬物の登場、児童が真似をする可能性のあるもの
                                            流血表現または刺激的にはオプションのセンシティブフラグをつけてください。
                                        </p>)} />
                                <p className='mt-1'>全年齢は例えば小学校の教科書に記載されても問題ないことを基準に。</p>
                                <p className='mt-1'>流血または刺激的な表現にはオプションのセンシティブフラグをつけてください。</p>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"20px auto"}}>
                                {loginInfo.plan === undefined || loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : <>
                                    {loginInfo.result && (ageLimit === "4" || ageLimit === "5") ? (<>
                                        <Link to="/generate_unlimit"><div style={{border:"1px solid #555555",borderRadius:"5px"}} className='p-2 d-inline-block '>R18画像生成<br /><Image src="/img/unlimit/ad.webp" width={240} /></div></Link>
                                        <br /><br />
                                    </>) : ""}
                                </>}
                                12/7 <Link to='/terms' target='_blank'>利用規約</Link>が更新されました。
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"20px auto"}}>
                                {loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0 ? "" : (
                                <div>
                                    <div style={{border:"1px solid #BBBBBB",borderRadius:"5px"}} className='p-2 d-inline-block mb-1'>
                                        <div>公開設定</div>
                                        <MuiButton onClick={() => setLimitDiv("public")} className='m-1' variant={limitDiv === "public" ? 'contained' : "outlined"} disableElevation>全体公開</MuiButton>
                                        <MuiButton onClick={() => setLimitDiv("plans")}className='m-1' variant={limitDiv === "plans" ? 'contained' : "outlined"} disableElevation disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0}>プランを選択</MuiButton>
                                        <MuiButton onClick={() => setLimitDiv("any_plans")}className='m-1' variant={limitDiv === "any_plans" ? 'contained' : "outlined"} disableElevation disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0}>すべての有料プラン</MuiButton>
                                        <div style={{ height: 400, width: '100%',display:limitDiv === "plans" ? "block" : "none" }} className='mt-3'>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                checkboxSelection
                                                pageSizeOptions={[]}
                                                onRowSelectionModelChange={(selection) => {
                                                    setSelectionPlans(selection)
                                                }}
                                                rowSelectionModel={selectionPlans}
                                                
                                            />
                                        </div>
                                    </div>
                                    <br />
                                    <div style={{border:"1px solid #BBBBBB",borderRadius:"5px"}} className='p-2 d-inline-block mt-1'>
                                        この投稿を販売&nbsp;
                                        <ButtonGroup>
                                            {yesOrNoRadio.map((radio, idx) => (
                                                <ToggleButton
                                                    className='p-1'
                                                    key={idx}
                                                    id={`unit-sell-${idx}`}
                                                    type="radio"
                                                    variant={'outline-primary'}
                                                    name="unit-sell-radio"
                                                    value={radio.value}
                                                    checked={unitSell === radio.value}
                                                    onChange={(e) => {
                                                        setUnitSell(e.currentTarget.value)
                                                    }}
                                                    >
                                                    {radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>&nbsp;
                                        {unitSell === "1" ? (
                                        <TextField
                                            type='number'
                                            value={unitAmount}
                                            onChange={(e) => setUnitAmount(e.currentTarget.value)}
                                            label="販売価格"
                                            id="unit-amount"
                                            sx={{ m: 1, width: '25ch' }}
                                            disabled={unitSell === "2"}
                                        />
                                        ) : ""}
                                        <Tooltip title="投稿を単品で販売する場合の金額を設定します。プランに指定されていても購入していれば閲覧できます。" arrow>
                                            <Icon.InfoCircle  />
                                        </Tooltip>
                                    </div>
                                </div>
                                )}
                                {loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0 ? (
                                        <><MuiButton variant='outlined' onClick={() => navigate("/manage/payouts")}>収益化を設定</MuiButton></>
                                ) : ""}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto",display:loginInfo.result !== undefined && loginInfo.result ? "block" : "none"}}>
                                <div style={{border:"1px solid #BBBBBB",borderRadius:"5px"}} className='p-2 d-inline-block mt-1'>
                                    ファンアートまたは公式として投稿する&nbsp;
                                    <ButtonGroup>
                                        {yesOrNoRadio.map((radio, idx) => (
                                            <ToggleButton
                                                className='p-1'
                                                key={idx}
                                                id={`fanart-${idx}`}
                                                type="radio"
                                                variant={'outline-primary'}
                                                name="fanart-radio"
                                                value={radio.value}
                                                checked={fanart === radio.value}
                                                onChange={(e) => {
                                                    setFanart(e.currentTarget.value)
                                                }}
                                                >
                                                {radio.name}
                                            </ToggleButton>
                                        ))}
                                    </ButtonGroup>&nbsp;
                                    {fanart === "1" ? (
                                    <Typeahead id="character-list" placeholder={"キャラクターを検索して関連付け"} clearButton={true}
                                        multiple
                                        onInputChange={(input) => {
                                            // キャラクター
                                            getCharacterList(input).then(r => {
                                                if(r.result){
                                                    let list = []
                                                    for(let i = 0;i < r.data.length;i++){
                                                        list.push({"label":r.data[i].character_name,"id":r.data[i].group_id})
                                                    }
                                                    setCharacterList(list.concat([]))
                                                }
                                            })
                                        }}
                                        onChange={(selected) => {
                                            //let value = selected.length === 0 ? "" : selected[0]
                                            setSelectedCharacterList(selected)
                                        }}
                                        options={characterList}
                                    />
                                    ) : ""}
                                    {fanart === "1" ? "" : <Tooltip title="ファンアートを投稿する場合は、登場するキャラクターを検索して設定してください。関連付けがすべて自分のキャラクターである場合は公式扱いになります。" arrow>
                                        <Icon.InfoCircle  />
                                    </Tooltip>}
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <MuiButton variant='contained' onClick={() => {
                                    let description = document.getElementById("description")
                                    if(description.value.length === 0){
                                        description.value = "#" + odai
                                    } else {
                                        description.value += " #" + odai
                                    }
                                    setUseOdai(true)
                                    dialog("確認","ハッシュタグ「#" + odai + "」を概要に追加しました。")
                                }}>{t("upload.image.odai1")}「{odai}」{t("upload.image.odai2")}</MuiButton>
                                <p>{t("upload.image.odai3")}</p>
                                <FloatingLabel controlId="description" label={t("upload.image.imageDescription")} className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            setUseOdai(document.getElementById("description").value.indexOf("#"+odai) !== -1)
                                        }}
                                    />
                                </FloatingLabel>
                                <LoadingButton color='info' className='m-1 p-1' variant='contained' onClick={() => {
                                    setTagging(true)
                                    getTags(fileList.map(d => d.prompt).join(",")).then(r => {
                                        if(r.result){
                                            setTagLatest(r.data.map(d => d.replace("#","")))
                                        }
                                        setTagging(false)
                                    })
                                }} disabled={fileList.map(d => d.prompt).join("").length === 0} loading={tagging}>プロンプトからタグを生成</LoadingButton>
                                <LoadingButton color='info' className='m-1 p-1' variant='contained' onClick={() => {
                                    setTagging(true)
                                    getTagsByImage(fileList[editImageNo].imageData).then(r => {
                                        if(r.result){
                                            setTagLatest(r.data.map(d => d.replace("#","")))
                                        }
                                        setTagging(false)
                                    })
                                }} disabled={fileList.length === 0} loading={tagging}>選択中の画像からタグを生成</LoadingButton><br />
                                <LoadingButton color='info' className='m-1 p-1' variant='contained' onClick={() => {
                                    setTagging(true)
                                    getIdentityByImage(fileList[editImageNo].imageData).then(r => {
                                        if(r.result){
                                            setTagLatest(r.data.map(d => d.replace("#","")))
                                        }
                                        setTagging(false)
                                    })
                                }} disabled={fileList.length === 0} loading={tagging}>選択中の画像からclassを生成</LoadingButton><br />
                                <LoadingButton color='info' className='m-1 p-1 d-none' variant='contained' onClick={() => {
                                    setTagging(true)
                                    getAgeLimitByImage(fileList[editImageNo].imageData).then(r => {
                                        if(r.result){
                                            alert(r.data)
                                        }
                                        setTagging(false)
                                    })
                                }} disabled={fileList.length === 0} loading={tagging}>選択中の画像の年齢制限を取得</LoadingButton>
                                <LoadingButton color='info' className='m-1 p-1 d-none' variant='contained' onClick={() => {
                                    setTagging(true)
                                    getPromptByImage(fileList[editImageNo].imageData).then(r => {
                                        if(r.result){
                                            alert(r.data)
                                        }
                                        setTagging(false)
                                    })
                                }} disabled={fileList.length === 0} loading={tagging}>選択中の画像をプロンプトに変換</LoadingButton>
                                <MuiButton variant='outlined' className='m-1 p-1' onClick={() => {
                                    tagLatest.forEach(d => {
                                        document.querySelector("#description").value += " #" + d
                                    })
                                }}>全てのタグ候補を追加</MuiButton><br />
                                {tagLatest.map((d,i) => <MuiButton key={i} variant='outlined' className='m-1 p-1' onClick={() => {
                                    document.querySelector("#description").value += " #" + d
                                }}>+{d}</MuiButton>)}
                                <p>{t("upload.image.tag")}</p>
                                <Typeahead id="tag" placeholder={t("category.tag")} clearButton={true} multiple
                                className='mb-1'
                                onInputChange={(input) => {
                                    tagSearch(input).then(r => {
                                        if(r.result){
                                            setTagOptions(r.data)
                                        }
                                    })
                                }}
                                onChange={(selected) => {
                                    setTag(selected)
                                }}
                                options={tagOptions}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <Typeahead id="upload-option-select" placeholder={t("upload.image.option")}
                                    className="mb-1"
                                    multiple
                                    clearButton={true}
                                    onChange={(selected) => {
                                        setOptionSelected(selected)
                                    }}
                                    selected={optionSelected}
                                    defaultSelected={[]}
                                    options={[
                                        {label:t("upload.image.original"),value:"original"},
                                        {label:t("upload.image.limitedPublication"),value:"limitedPublication"},
                                        {label:t("upload.image.loggedInUserOnly"),value:"loggedInUserOnly"},
                                        {label:"公式プラン加入者のみに公開",value:"officialPlanUserOnly"},
                                        //{label:t("upload.image.premiumOrHigherUserOnly"),value:"loggedInUserOnly"},
                                        {label:t("upload.image.newPostHidden"),value:"newPostHidden"},
                                        {label:t("upload.image.rankingHidden"),value:"rankingHidden"},
                                        {label:t("upload.image.sensitive"),value:"sensitive"}
                                    ]}
                                    />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <Typeahead id="generation-method-select" placeholder={t("common.generationMethod")}
                                    className="mb-1"
                                    multiple
                                    clearButton={true}
                                    onChange={(selected) => {
                                        setGenearteMethodSelected(selected)
                                    }}
                                    selected={generateMethodSelected}
                                    defaultSelected={[]}
                                    options={[
                                        {label:t("upload.image.t2i"),value:"t2i"},
                                        {label:t("upload.image.i2i"),value:"i2i"},
                                        {label:t("upload.image.inpaint"),value:"inpaint"},
                                        {label:t("upload.image.outpaint"),value:"outpaint"},
                                        {label:t("upload.image.ip2p"),value:"ip2p"},
                                        {label:"ControlNet",value:"ControlNet"}
                                    ]}
                                    />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto",display:loginInfo.result !== undefined && loginInfo.result ? "block" : "none"}}>
                                <Typeahead id="series-list" ref={ref} placeholder={"シリーズに追加"} clearButton={true}
                                onChange={(selected) => {
                                    let value = selected.length === 0 ? "" : selected[0]
                                    setSeries(value)
                                }}
                                options={seriesList}
                                />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto"}} id="event">
                                開催イベント&nbsp;
                                <Icon.InfoCircle style={{fontSize:"20px",cursor:"pointer"}} onClick={() => {
                                    dialog("info",<>
                                    <Link to={"/event"} target='_blank'>イベント情報</Link>として登録されたもののうち、
                                    開催期間3か月前後のものが表示されます。開催期間中に投稿作品に関連付けすることで、
                                    投稿時ポイントが付与されます。通常:300 スタンダードプラン:1000 プレミアムプラン:3000
                                    </>)
                                }} />
                                <br />
                                参加すると、自動で参加用のタグが付きます。
                                <Container className='d-flex justify-content-start'>
                                {eventList.map((d,i) => {
                                    return (<div key={i} style={{border:"1px solid #BBBBBB"}} className='m-3'>
                                        <Thumb data={d} i={i} key={i} list={eventList} type="event" />
                                        <div className='text-center'>
                                            {d.from_datetime} ～<br />{d.to_datetime}<br />
                                            {d.tag !== eventTag ? (
                                            <Button variant='outline-secondary'
                                                onClick={() => setEventTag(d.tag)}
                                            >参加する</Button>) : (
                                                <Icon.Check style={{color:"#00FF00",fontSize:"36px",cursor:"pointer"}} onClick={() => setEventTag("") }/>
                                            )}
                                        </div>
                                    </div>)
                                })}
                                </Container>
                                <Link to={"/event"} target='_blank'>イベント一覧</Link><br /><br />
                                <MuiButton variant='outlined' onClick={() => {
                                    dialog("",<>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#ノウハウ"
                                            } else {
                                                description.value += " #ノウハウ"
                                            }
                                            dialog("確認","ハッシュタグ「#ノウハウ」を概要に追加しました。")
                                        }}>「ノウハウ」タグを追加</Button>
                                        <p>
                                            自己流生成法の紹介や加筆修正の過程など<br />
                                        </p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#素材"
                                            } else {
                                                description.value += " #素材"
                                            }
                                            dialog("確認","ハッシュタグ「#素材」を概要に追加しました。")
                                        }}>素材として公開(素材タグを追加)</Button>
                                        <p>
                                            #素材タグが付いているものは、誰もが自由に利用できるようになります。<br />
                                            他者の著作物に似たものは素材にはできません。
                                        </p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#AI画像副産物"
                                            } else {
                                                description.value += " #AI画像副産物"
                                            }
                                            dialog("確認","ハッシュタグ「#AI画像副産物」を概要に追加しました。")
                                        }}>「AI画像副産物」タグを追加</Button>
                                        <p>失敗したけど味がある。目的のものとは違うけどいいものが出力された場合、など。</p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#ネタ画像"
                                            } else {
                                                description.value += " #ネタ画像"
                                            }
                                            dialog("確認","ハッシュタグ「#ネタ画像」を概要に追加しました。")
                                        }}>「ネタ画像」タグを追加</Button>
                                        <p>生成の過程で思いもよらない面白いものやネタ的な画像が出力された場合、など。</p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#物語を感じるAIアート"
                                            } else {
                                                description.value += "#物語を感じるAIアート"
                                            }
                                            dialog("確認","ハッシュタグ「#物語を感じるAIアート」を概要に追加しました。")
                                        }}>「物語を感じるAIアート」タグを追加</Button>
                                        <p>概要欄に短い物語が書いてあると良いでしょう。</p>
                                        <Button variant='warning' onClick={() => {
                                            let description = document.getElementById("description")
                                            if(description.value.length === 0){
                                                description.value = "#漫画"
                                            } else {
                                                description.value += "#漫画"
                                            }
                                            dialog("確認","ハッシュタグ「#漫画」を概要に追加しました。")
                                        }}>「漫画」タグを追加</Button>
                                        <p><a href="https://twitter.com/jonigata_ai" target={"_blank"} rel="noreferrer">AI生成画像向き簡易マンガ制作ツール</a></p>
                                        <b>タグを関係のない作品につけた場合は修正する場合があります。</b>
                                    </>)
                                }}>タグ候補の案</MuiButton>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",border:"3px solid #CCCCCC",padding:"10px",borderRadius:"5px",display:"none"}}>
                                <Link to={"https://twitter.com/ourt_ai/status/1671962304546762752"} target='_blank'>
                                <img
                                    className="d-block w-100"
                                    src="/img/horror202306.webp"
                                    alt="投稿企画「ホラー」"
                                    style={{objectFit:"contain",width:"100%",height:"100%"}}
                                />
                                </Link>
                                <Button variant='warning' onClick={() => {
                                    let description = document.getElementById("description")
                                    if(description.value.length === 0){
                                        description.value = "#ホラー"
                                    } else {
                                        description.value += "#ホラー"
                                    }
                                    dialog("確認","ハッシュタグ「#ホラー」を概要に追加しました。")
                                }} disabled>企画に参加(タグを追加)</Button>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",border:"3px solid #CCCCCC",padding:"10px",borderRadius:"5px",display:"none"}}>
                                <h5>「和気あいAI」 AIイラスト、グッズ等展示即売会のイメージイラストへの応募</h5>
                                <p>
                                <Button variant="warning" onClick={() => {
                                    let description = document.getElementById("description")
                                    description.value += (description.value.length === 0 ? "":"\n") + "#和気あいAI202309"
                                    dialog("確認","参加用のハッシュタグを概要に追加しました。")
                                }}>イメージイラストに応募する(応募タグを追加)</Button><br />
                                応募期限：2023/6/30  23:59まで<br />
                                <Link to={"https://twitter.com/ko_to_ba_no_aya/status/1659724898934341633"} target='_blank'>募集要項</Link><br />
                                <Link to={"/event/fd392f6e-b02f-4fe4-8fe3-a4aedd7d7bec"} target='_blank'>イベント詳細</Link>
                                </p>
                            </Col>
                        </Col>
                        <hr />
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"40px auto"}}>
                                <p>{t("upload.image.promptMulti")}</p>
                                <MuiButton className='mb-3' variant='outlined' color='error' onClick={() => deleteSelectedFormValue()}>
                                    {t("upload.image.deleteCurrentInfo")}
                                </MuiButton>
                                <p style={{display:"block"}}>{t("upload.image.useModelRequired")}</p>
                                <Typeahead id="ai-model-input" ref={ref} placeholder={"Search"} clearButton={true}
                                onInputChange={(input) => {
                                    let value = input === undefined ? "no-select" : input
                                    if(fileList.length > 0){
                                        fileList[editImageNo].software = value
                                    }
                                    document.getElementById("ai-model").value = value
                                }}
                                onChange={(selected) => {
                                    let value = selected.length === 0 ? "no-select" : selected[0]
                                    if(fileList.length > 0){
                                        fileList[editImageNo].software = value
                                    }
                                    document.getElementById("ai-model").value = value
                                }}
                                //disabled={fileList.length > 0 && fileList[editImageNo].useAIGeneration}
                                options={[
                                    "StableDiffusion",
                                    "StableDiffusion_v1-1",
                                    "StableDiffusion_v1-2",
                                    "StableDiffusion_v1-3",
                                    "StableDiffusion_v1-4",
                                    "StableDiffusion_v1-5",
                                    "StableDiffusion_v2-1",
                                    "StableDiffusionXL",
                                    "StableDiffusion3",
                                    "StableDiffusion3Large",
                                    "StableDiffusion3LargeTurbo",
                                    "FLUX.1",
                                    "FLUX.1_schnell",
                                    "FLUX.1_dev",
                                    "FLUX.1_pro",
                                    "NovelAI",
                                    "HolaraAI",
                                    "Agelesnate",
                                    "AgelesnateV1_1",
                                    "AgelesnateV1_2",
                                    "AgelesnateV1_21",
                                    "AgelesnateV2",
                                    "AgelesnateV3",
                                    "animelike25D",
                                    "Aurora_v1.0",
                                    "Animagine_XL_V3",
                                    "Animagine_XL_V3.1",
                                    "AnythingV3",
                                    "AnythingV4",
                                    "AnythingV4.5",
                                    "AnythingV5",
                                    "AbyssOrangeMix",
                                    "AbyssOrangeMix2",
                                    "AbyssOrangeMix3",
                                    "ACertainThing",
                                    "ACertainModel",
                                    "ACertainty",
                                    "AikimiD1",
                                    "AikimiXW1",
                                    "AikimiXR1",
                                    "AikimiXR2",
                                    "AikimiXR3",
                                    "AikimiXR4",
                                    "AikimiXR5",
                                    "Aikimi_dB4",
                                    "Aikimi_dC3",
                                    "Aikimi_dC4",
                                    "AikiliMX2",
                                    "AikiMIXSD2v1",
                                    "blue_pencil-v1",
                                    "blue_pencil-v1b",
                                    "blue_pencil-v2",
                                    "blue_pencil-v2b",
                                    "blue_pencil-v3",
                                    "blue_pencil-v4",
                                    "blue_pencil-v5",
                                    "blue_pencil-v5b",
                                    "blue_pencil-v6",
                                    "blue_pencil-v7",
                                    "blue_pencil-v8",
                                    "blue_pencil-v9",
                                    "blue_pencil-v9b",
                                    "blue_pencil-v10",
                                    "blue_pencil-EX",
                                    "blue_pencil_realistic-v0.1",
                                    "blazingDrive_V09i",
                                    "EverlastingV2",
                                    "7th_anime_v3_testA",
                                    "7th_anime_v3_testB",
                                    "7th_anime_v3_testC",
                                    "7th_anime_3.1_A",
                                    "7th_anime_3.1_B",
                                    "7th_anime_3.1_C",
                                    "7th_anime_3.1_Cg",
                                    "7th_anime_v2.1_B",
                                    "Baka-DiffusionV1",
                                    "CounterfeitV1.0",
                                    "CounterfeitV2.0",
                                    "CounterfeitV2.2",
                                    "CounterfeitV2.5",
                                    "CounterfeitV3.0",
                                    "CinnamonMix",
                                    "ChilloutMix",
                                    "chilled_remix_v1Fp16vae",
                                    "chilled_remix_v1vae",
                                    "chilled_remixb_v1vae",
                                    "chilled_reversemix_v1vae",
                                    "DALL-E2",
                                    "DALL-E3",
                                    "Defmix",
                                    "demiPeroMixV1",
                                    "demiPeroMixV2",
                                    "DivineEleganceMixV1",
                                    "DivineEleganceMixV2",
                                    "DivineEleganceMixV3",
                                    "Elysium_V1",
                                    "Elysium_Anime_V1",
                                    "Elysium_Anime_V2",
                                    "Elysium_Anime_V3",
                                    "Elysium_Kuro_Anime_V1",
                                    "HentaiDiffusion",
                                    "Hassaku_V1to1.2-inpainting",
                                    "Hassaku_V1",
                                    "Hassaku_V1m",
                                    "Hassaku_V1.1",
                                    "Hassaku_V1.2",
                                    "OsukiniMix_A",
                                    "OsukiniMix_B",
                                    "OsukiniMix_B_V2",
                                    "SEmix_V1_A",
                                    "SEmix_V1_B",
                                    "SEmix_V1_C",
                                    "SEmix_V2_A",
                                    "SEmix_V2_B",
                                    "Shining_Mix_V1",
                                    "Shining_Mix_V2",
                                    "Shirayuki_General_V1",
                                    "Shirayuki_Anime_V1",
                                    "SukumizuMix",
                                    "WaifuDiffusion",
                                    "SukiyakiMix",
                                    "SukiAnimix",
                                    "majicmixRealistic_v6",
                                    "Midjourney",
                                    "Midjourney_V5",
                                    "Microsoft Bing Image Creator",
                                    "milktea_mild_V1",
                                    "niji・journey",
                                    "niji・journey_V5",
                                    "TrinArt",
                                    "Ernie-vilg",
                                    "UnstableDiffusion",
                                    "MeituAIPainting",
                                    "Rabbit_v1.3",
                                    "Rivera",
                                    "PastelMix",
                                    "PerfectSketchbook",
                                    "Protogen",
                                    "お絵描きばりぐっどくん",
                                    "えいあーとAI",
                                    /*"ourt AI Diffusion (Anime V1)",*/
                                    "ourt AI Diffusion (Anime V2)",
                                    "ourt AI Diffusion (Anime V3)",
                                    "ourt AI Diffusion (Anime V3.5)",
                                    "未使用",
                                    "マージモデル(名称なし)",
                                    "オリジナルモデル"
                                    ]}
                                />
                                <FloatingLabel controlId="ai-model" label={t("upload.image.useModel")} className="mb-3" style={{display:"block"}}>
                                    <Form.Control type="text" placeholder=""
                                        //disabled={fileList.length > 0 && fileList[editImageNo].useAIGeneration}
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].software = e.currentTarget.value
                                    }} />
                                </FloatingLabel>
                                <MuiButton className='mb-0' variant='outlined' onClick={() => {
                                    let model = document.getElementById("ai-model").value
                                    if(model === "" || model === "no-select"){
                                        dialog("確認",t("upload.image.useModelRequired"))
                                        return
                                    }
                                    fileList.forEach(d => {
                                        d.software = model
                                    })
                                    dialog("確認",t("upload.image.useModelLeft")+"「"+model+"」"+t("upload.image.useModelRight"))
                                }}>
                                    {t("upload.image.allUseSameModel")}
                                </MuiButton>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"30px auto",display:"none"}}>
                                <FloatingLabel controlId="model-version" label={t("upload.image.modelVersion")} className="mb-3" style={{display:"block"}}>
                                    <Form.Control type="text" placeholder="" readOnly disabled />
                                </FloatingLabel>
                            </Col>
                            {fileList.length > 0 && fileList[editImageNo] ? (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="m-1">
                                    <Container style={{width:"240px",height:"auto",display:"block"}}>
                                        <Container className='text-center'>
                                            {t("upload.image.edittingInfo")}
                                        </Container>
                                        <Container className='d-flex justify-content-between mb-3'>
                                            <MuiButton variant='outlined' onClick={() => {
                                                if(editImageNo > 0){
                                                    setEditImageNo(editImageNo - 1)
                                                }
                                                }} disabled={editImageNo === 0}>
                                                <Icon.ArrowLeft /></MuiButton>
                                            <MuiButton variant='outlined' onClick={() => {
                                                if(editImageNo < fileList.length){
                                                    setEditImageNo(editImageNo + 1)
                                                }
                                                }} disabled={editImageNo === fileList.length - 1} >
                                                <Icon.ArrowRight /></MuiButton>
                                        </Container>
                                        <Container>
                                            <Image alt={fileList[editImageNo].file.name} src={fileList[editImageNo].imageDataMiddle} id="select-img" style={{objectFit:"contain",width:"100%",height:"100%",cursor:"pointer"}}
                                            onClick={(e) => {
                                                setPreviewSource(fileList[editImageNo].useMosaic === "1" ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataOriginal)
                                                setPreviewFlg(true)
                                            }}/>
                                        </Container>
                                    </Container>
                                </Col>
                            ) : ""}
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"10px auto",display:promptInfoPublication ? "block" : "none"}}>
                                <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="read-prompt-info-file" onChange={(e) => {
                                    let img = new ImageFile({file:e.currentTarget.files[0]})
                                    setMetaData(e.currentTarget.files[0],img).then(r => {
                                        setMetaDataField(img,true)
                                        if(editImageNo !== -1){
                                            fileList[editImageNo].prompt = img.prompt
                                            fileList[editImageNo].software = img.software
                                            fileList[editImageNo].modelHash = img.modelHash
                                            fileList[editImageNo].comment = img.comment
                                        }
                                    })
                                    e.currentTarget.value = ""
                                }} />
                                <MuiButton variant='outlined' onClick={() => document.getElementById("read-prompt-info-file").click()}>プロンプト情報だけ読み込む</MuiButton>
                            </Col>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto",display:promptInfoPublication ? "block" : "none"}}>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="prompt" label={t("upload.image.promptName")} className='mb-3 w-100' style={{display:"block"}}>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].prompt = e.currentTarget.value
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="negative-prompt" label={t("upload.image.negativePromptName")} className='mb-3 w-100' style={{display:"block"}}>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.uc = e.currentTarget.value
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:promptInfoPublication ? "block" : "none"}}>
                            <Row>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="noise" label="Noise" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.noise = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="steps" label="Steps" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.steps = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="scale" label="Scale" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.scale = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="seed" label="Seed" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.seed = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="sampler" label="Sampler" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.sampler = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="strength" label="Denoising strength" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.strength = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="mask-blur" label="Mask blur" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.maskBlur = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="clip-skip" label="Clip skip" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.clipSkip = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="ensd" label="ENSD" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.ensd = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="hires-upscale" label="Hires Upscale" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.maskBlur = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="hires-upscaler" label="Hires Upscaler" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.hiresUpscaler = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-enabled" label="ControlNet Enabled" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetEnabled = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-module" label="ControlNet Module" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetModule = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-model" label="ControlNet Model" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetModel = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-weight" label="ControlNet Weight" className="mb-3" style={{display:"block"}} autoComplete="new-password">
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetWeight = e.currentTarget.value
                                        }} autoComplete="new-password" />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="raw-info" label={"rawinfo"} className='mb-3 w-100' style={{display:"block"}}>
                                        <Form.Control
                                            as="textarea"
                                            style={{ height: '100px' }}
                                            required
                                            onChange={(e) => {
                                                if(fileList.length > 0)
                                                fileList[editImageNo].rawInfo = e.currentTarget.value
                                            }}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <Accordion flush style={{border:"1px solid #CCCCCC"}} className="mb-3">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header><RIcon.FaDesktop style={{fontSize:"18px"}} />&nbsp;{t("common.others")}</Accordion.Header>
                                        <Accordion.Body>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="vae" placeholder={"VAE"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vae = value
                                                        setVAE([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vae = value
                                                        setVAE([value])
                                                    }
                                                }}
                                                options={[
                                                    "Anything-V3.0.vae",
                                                    "anything-v4.0.vae",
                                                    "autoencoder_fix_kl-f8-trinart_characters",
                                                    "ACertainModel.vae",
                                                    "Baka-Diffusion.vae",
                                                    "clearvae_main.safetensors",
                                                    "vae-ft-ema-560000-ema-pruned",
                                                    "vae-ft-mse-840000-ema-pruned",
                                                    "kl-f8-anime",
                                                    "kl-f8-anime2",
                                                    "mse840000_klf8anime.vae",
                                                    "mse840000_klf8anime_klf8anime2.vae",
                                                    ]}
                                                selected={vae}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="gpu" placeholder={"GPU"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].gpu = value
                                                        setGPU([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].gpu = value
                                                        setGPU([value])
                                                        console.log(selected)
                                                    }
                                                }}
                                                options={[
                                                    "GeForce GTX 950","GeForce GTX 960","GeForce GTX 970","GeForce GTX 980","GeForce GTX 980 Ti",
                                                    "GeForce GTX 950M (Notebooks)","GeForce GTX 960M (Notebooks)","GeForce GTX 965M (Notebooks)","GeForce GTX 970M (Notebooks)","GeForce GTX 980M (Notebooks)","GeForce GTX 980 (Notebooks)",
                                                    "GeForce GTX 1050","GeForce GTX 1050 Ti","GeForce GTX 1060","GeForce GTX 1070","GeForce GTX 1070 Ti","GeForce GTX 1080","GeForce GTX 1080 Ti",
                                                    "GeForce GTX 1050 (Notebooks)","GeForce GTX 1050 Ti (Notebooks)","GeForce GTX 1060 (Notebooks)","GeForce GTX 1070 (Notebooks)","GeForce GTX 1080 (Notebooks)",
                                                    "Geforce GTX 1630","Geforce GTX 1650","Geforce GTX 1650 SUPER","Geforce GTX 1660","Geforce GTX 1660 Ti","Geforce GTX 1660 SUPER",
                                                    "Geforce GTX 1650 (Notebooks)","Geforce GTX 1650 Ti (Notebooks)","Geforce GTX 1660 Ti (Notebooks)",
                                                    "GeForce RTX 2050 (Notebooks)","GeForce RTX 2060 (Notebooks)","GeForce RTX 2070 (Notebooks)","GeForce RTX 2070 SUPER (Notebooks)","GeForce RTX 2080 (Notebooks)","GeForce RTX 2080 SUPER (Notebooks)",
                                                    "GeForce RTX 2060","GeForce RTX 2060 SUPER","GeForce RTX 2070","GeForce RTX 2070 SUPER","GeForce RTX 2080","GeForce RTX 2080 SUPER","GeForce RTX 2080 Ti",
                                                    "GeForce RTX 3050","GeForce RTX 3060","GeForce RTX 3060 Ti","GeForce RTX 3070","GeForce RTX 3070 Ti","GeForce RTX 3080","GeForce RTX 3080 Ti","GeForce RTX 3090","GeForce RTX 3090 Ti",
                                                    "GeForce RTX 3050 Laptop GPU","GeForce RTX 3050 Ti Laptop GPU","GeForce RTX 3060 Laptop GPU","GeForce RTX 3070 Laptop GPU","GeForce RTX 3070 Ti Laptop GPU","GeForce RTX 3080 Laptop GPU","GeForce RTX 3080 Ti Laptop GPU",
                                                    "GeForce RTX 4070 Ti","GeForce RTX 4080","GeForce RTX 4090",
                                                    "GeForce RTX 4050 Laptop GPU","GeForce RTX 4060 Laptop GPU","GeForce RTX 4070 Laptop GPU","GeForce RTX 4080 Laptop GPU","GeForce RTX 4090 Laptop GPU",
                                                    "NVIDIA A100"
                                                    ]}
                                                selected={gpu}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="vram" placeholder={"VRAM"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vram = value
                                                        setVRAM([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vram = value
                                                        setVRAM([value])
                                                    }
                                                }}
                                                options={["1GB","2GB","4GB","6GB","8GB","12GB","16GB","24GB","32GB","36GB","48GB"]}
                                                selected={vram}
                                                />
                                            </Col>
                                        </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:loginInfo.result === false ? "block" : "none"}}>
                            <hr />
                            ログインせずに匿名投稿できます。<br />削除パスワードを設定してください。
                            <FloatingLabel controlId="delete-password" label="削除パスワード" className='mb-3'>
                                <Form.Control type="password" cows="10" autoComplete="new-password" />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <hr />
                            <FloatingLabel controlId="request" label={t("upload.image.requestMessage")} className='mb-3 w-100' style={{display:"block"}}>
                                <Form.Control
                                    as="textarea"
                                    style={{ height: '100px' }}
                                    required
                                />
                            </FloatingLabel>
                            <div
                                title={t("questionnaire.title")}
                                onClick={() => {
                                    setShowQuestionnairePopup(true)
                                }}
                                style={{margin:"0 auto",marginBottom:"20px",cursor:"pointer",display:"inline"}}
                            >
                                <div style={{border:"1px solid #555555",display:"inline"}} className="p-1">
                                <Icon.ListOl style={{fontSize:"30px"}}/>{t("questionnaire.title")}
                                &nbsp;
                                {questionInfo !== undefined && questionInfo.deadlineDate.length > 0 ? <Icon.CheckLg style={{color:"green"}} /> : ""}
                                </div>
                            </div>
                            {showBookingDatetime ? (<DynamicDialog width={window.innerWidth * 0.8} height={window.innerHeight * 0.8}  switch={setShowBookingDatetime} content={
                                <Container>
                                    <MuiButton className='mb-3' variant='outlined' onClick={() => setShowBookingDatetime(false)}>{t("common.close")}</MuiButton>
                                    <h3>{t("common.scheduledPost")}</h3>
                                    <Container>
                                        <FloatingLabel controlId="booking-date" label={t("upload.image.bookingYmd")} className='mb-3 w-100'>
                                            <Form.Control
                                                type="date"
                                                required
                                                defaultValue={bookingDate}
                                                onChange={(e) => setBookingDate(e.currentTarget.value)}
                                            />
                                        </FloatingLabel>
                                    </Container>
                                    <Container>
                                        <FloatingLabel controlId="booking-time" label={t("upload.image.bookingHi")} className='mb-3 w-100'>
                                            <Form.Control
                                                type="time"
                                                required
                                                defaultValue={bookingTime}
                                                onChange={(e) => setBookingTime(e.currentTarget.value)}
                                            />
                                        </FloatingLabel>
                                        <Container className='mb-1'>
                                        {bookingTimeList.map((time,i) => {
                                            return <MuiButton variant='outlined' key={i} onClick={() => {
                                                document.getElementById("booking-time").value = time
                                                setBookingTime(time)
                                            }}>{time}</MuiButton>
                                        })}
                                        </Container>
                                        <MuiButton variant='contained' className="m-1" onClick={() => {
                                            setShowBookingDatetime(false)
                                        }}>{t("upload.image.setBooking")}</MuiButton>
                                        <MuiButton variant='contained' className="m-3" onClick={() => {
                                            document.getElementById("booking-date").value = ""
                                            document.getElementById("booking-time").value = ""
                                            setBookingDate("")
                                            setBookingTime("")
                                        }}>{t("upload.image.clearBooking")}</MuiButton>
                                    </Container>
                                </Container>
                            } />) : ""}
                            <div style={{margin:"0 auto",marginBottom:"20px",cursor:"pointer",display:"inline"}} className='p-1'>
                                <div style={{border:"1px solid #555555",display:"inline"}} className="p-1"
                                    onClick={() => {
                                        getBookingTimeList().then(r => {
                                            if(r.result){
                                                setBookingTimeList(r.data)
                                            }
                                        })
                                        setShowBookingDatetime(true)
                                    }}
                                >
                                    <Icon.Clock />
                                    {t("common.scheduledPost")}
                                    {(bookingDate === "" && bookingTime !== "") || (bookingDate !== "" && bookingTime === "") ? <> <Icon.ExclamationCircle style={{color:"red"}} /></> : ""}
                                </div>
                            </div>
                            <div id="upload-form">
                                {bookingDate !== "" && bookingTime !== "" ?(
                                    <Container className='mt-1'>
                                        {t("common.yoyaku")}:{bookingDate !== "" ? bookingDate : ""} {bookingTime !== "" ? bookingTime : ""}
                                    </Container>
                                ): ""}
                                <MuiButton variant='contained' color={uploadReady ? "primary" : "warning"} style={{marginTop:"10px",marginBottom:"10px",width:"200px"}} onClick={(e) => uploadHandler(e)} disabled={uploading}>{t("upload.image.upload")}</MuiButton>
                                <Button variant={uploadReady ? "primary" : "danger"} style={{position:"fixed",zIndex:2,left:window ? (window.innerWidth - 200) / 2 : 0,bottom:"60px",width:"200px"}} onClick={(e) => uploadHandler(e)} disabled={uploading}>
                                    {t("upload.image.upload")}
                                    {uploading && (<><br /><ProgressBar className="progress" animated now={progressNow} label={`${progressLabel}`} /></>)}
                                </Button>
                            </div>
                            <p>
                                <Link to='/terms'>利用規約</Link>に違反する投稿は削除の対象となります。
                            </p>
                            <p>
                                要望や不具合報告、その他アワートAIに関する更新情報の告知などは公式Discordでも行っています。<br />
                                <Icon.Discord /> <a href="https://discord.gg/vQNvaCXYvu" alt="Official Discord" target={"_blank"} rel="noreferrer">Official Discord</a>
                            </p>
                            <MuiButton variant='contained' onClick={() => planDialog(dialog)}>支援について</MuiButton><br />
                            <br />
                            {loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : (
                                <iframe src="https://rcm-fe.amazon-adsystem.com/e/cm?o=9&p=294&l=ur1&category=kindleunlimited&banner=1D102G5E4DY0DNM0T382&f=ifr&linkID=1f2ebcba4ab1b661743a03341e6b1aa2&t=ourt-ai-22&tracking_id=ourt-ai-22" width="320" height="100" scrolling="no" border="0" marginWidth="0" style={{border:"none"}} frameBorder="0" sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"></iframe>
                            )}
                            <div>
                                <hr />
                                {t("upload.image.hasPoint")}：<b>{point}</b><br />
                                {t("upload.image.last3Month")}：<b>{calcPointInfo.avg}</b><br />
                                <b>{calcPointInfo.addPoint}</b>{t("upload.image.point")} / 1 {t("upload.image.unit")}<br />
                                <hr />
                                {t("upload.image.getPointTotal")}：<b>{useOdai ? calcPointInfo.point * 2 : calcPointInfo.point}</b>{useOdai ? " ("+t("common.odaiBonus")+")" : ""}<br />
                                {t("upload.image.odai1")}{t("upload.image.odai2")}：<b>{useOdai ? t("common.yes") : t("common.no")}</b><br />
                                {t("upload.image.review")}
                            </div>
                            {uploading && (<><ProgressBar className="progress" animated now={progressNow} label={`${progressLabel}`} style={{marginBottom:"10px"}} /></>)}
                            {uploading && batchUploading && (<><ProgressBar id="batch_progress" animated now={batchProgressNow} label={`${batchProgressLabel}`} style={{marginBottom:"10px"}} /></>)}
                        </Col>
                    </Row>
                    </Form>
        </Container>
        {postedGroupId === "" ? (<Footer />) : ""}
    </div>
    </>
    )
}

export default Upload;
